var Ei = Object.defineProperty;
var Ii = (t, e, i) => e in t ? Ei(t, e, { enumerable: !0, configurable: !0, writable: !0, value: i }) : t[e] = i;
var $e = (t, e, i) => Ii(t, typeof e != "symbol" ? e + "" : e, i);
import ue, { defineComponent as b, nextTick as ve, getCurrentInstance as Oi, ref as W, onBeforeMount as Ti, watch as Se, isRef as ot, reactive as ft, onBeforeUnmount as Di, computed as z, unref as R, inject as St, provide as At, isReactive as Li, isReadonly as ji } from "vue";
const Bi = b({
  name: "AppActionButton",
  props: {
    faIcon: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    enabled: {
      type: Boolean,
      default: !0
    }
  },
  methods: {
    onClick(t) {
      this.$emit("click", t);
    }
  },
  computed: {
    disabled() {
      return !this.enabled;
    }
  }
});
function _(t, e, i, n, s, r, l, a) {
  var o = typeof t == "function" ? t.options : t;
  return e && (o.render = e, o.staticRenderFns = i, o._compiled = !0), r && (o._scopeId = "data-v-" + r), {
    exports: t,
    options: o
  };
}
var Fi = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("button", { attrs: { type: "button", disabled: e.disabled }, on: { click: e.onClick } }, [i("div", { staticClass: "button-container" }, [i("fa-icon-compat", { staticClass: "icon", attrs: { icon: e.faIcon } }), i("span", { staticClass: "label" }, [e._v(e._s(e.label))])], 1)]);
}, Wi = [], Ni = /* @__PURE__ */ _(
  Bi,
  Fi,
  Wi,
  !1,
  null,
  "04d3c1de"
);
const qi = Ni.exports, Hi = b({
  name: "AppButton",
  props: {
    label: {
      type: String,
      required: !0
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    theme: {
      type: String,
      default: "primary",
      validator(t) {
        return ["primary", "cta"].includes(t);
      }
    }
  },
  methods: {
    onClick(t) {
      this.$emit("click", t);
    }
  },
  computed: {
    disabled() {
      return !this.enabled;
    }
  }
});
var Vi = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("button", { class: e.theme, attrs: { disabled: e.disabled, type: "button" }, on: { click: e.onClick } }, [e._v(" " + e._s(e.label) + " ")]);
}, Ui = [], Yi = /* @__PURE__ */ _(
  Hi,
  Vi,
  Ui,
  !1,
  null,
  "b7246f38"
);
const Xi = Yi.exports, Gi = b({
  name: "AppIconButton",
  props: {
    size: {
      type: Number,
      required: !1
    },
    padding: {
      type: Number,
      default: 0
    },
    frame: {
      type: String,
      default: "round",
      validator(t) {
        return ["round", "square"].includes(t);
      }
    },
    enabled: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    style() {
      return {
        minWidth: this.size ? `${this.size}px` : "auto",
        width: this.size ? `${this.size}px` : "auto",
        minHeight: this.size ? `${this.size}px` : "100%",
        height: this.size ? `${this.size}px` : "100%",
        padding: this.padding ? `${this.padding}px` : "0",
        borderRadius: this.frame === "round" ? "100px" : "6px"
      };
    },
    disabled() {
      return !this.enabled;
    }
  },
  methods: {
    onClick(t) {
      this.$emit("click", t);
    }
  }
});
var Zi = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("button", { staticClass: "app-icon-button reset-button", style: e.style, attrs: { type: "button", tabindex: "0", disabled: e.disabled }, on: { click: e.onClick } }, [e._t("default")], 2);
}, Ki = [], Qi = /* @__PURE__ */ _(
  Gi,
  Zi,
  Ki,
  !1,
  null,
  "33cda146"
);
const Ji = Qi.exports, en = b({
  name: "AppSecondaryButton",
  props: {
    label: {
      type: String,
      required: !0
    },
    enabled: {
      type: Boolean,
      default: !0
    }
  },
  methods: {
    onClick(t) {
      this.$emit("click", t);
    }
  },
  computed: {
    disabled() {
      return !this.enabled;
    }
  }
});
var tn = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("button", { attrs: { type: "button", disabled: e.disabled }, on: { click: e.onClick } }, [e._v(" " + e._s(e.label) + " ")]);
}, nn = [], sn = /* @__PURE__ */ _(
  en,
  tn,
  nn,
  !1,
  null,
  "421d72d9"
);
const rn = sn.exports;
function Ke(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var i = 0, n = Array(e); i < e; i++) n[i] = t[i];
  return n;
}
function F(t, e, i) {
  return (e = function(n) {
    var s = function(r, l) {
      if (typeof r != "object" || !r) return r;
      var a = r[Symbol.toPrimitive];
      if (a !== void 0) {
        var o = a.call(r, l);
        if (typeof o != "object") return o;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (l === "string" ? String : Number)(r);
    }(n, "string");
    return typeof s == "symbol" ? s : s + "";
  }(e)) in t ? Object.defineProperty(t, e, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = i, t;
}
function Rt(t, e) {
  var i = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function S(t) {
  for (var e = 1; e < arguments.length; e++) {
    var i = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Rt(Object(i), !0).forEach(function(n) {
      F(t, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : Rt(Object(i)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return t;
}
function he(t) {
  return function(e) {
    if (Array.isArray(e)) return Ke(e);
  }(t) || function(e) {
    if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
  }(t) || function(e, i) {
    if (e) {
      if (typeof e == "string") return Ke(e, i);
      var n = {}.toString.call(e).slice(8, -1);
      return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Ke(e, i) : void 0;
    }
  }(t) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
var Mt, on, ke, P = (Mt = function(t) {
  /*!
  	Copyright (c) 2018 Jed Watson.
  	Licensed under the MIT License (MIT), see
  	http://jedwatson.github.io/classnames
  */
  (function() {
    var e = {}.hasOwnProperty;
    function i() {
      for (var r = "", l = 0; l < arguments.length; l++) {
        var a = arguments[l];
        a && (r = s(r, n(a)));
      }
      return r;
    }
    function n(r) {
      if (typeof r == "string" || typeof r == "number") return r;
      if (typeof r != "object") return "";
      if (Array.isArray(r)) return i.apply(null, r);
      if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]")) return r.toString();
      var l = "";
      for (var a in r) e.call(r, a) && r[a] && (l = s(l, a));
      return l;
    }
    function s(r, l) {
      return l ? r ? r + " " + l : r + l : r;
    }
    t.exports ? (i.default = i, t.exports = i) : window.classNames = i;
  })();
}, Mt(ke = { path: on, exports: {}, require: function(t, e) {
  return function() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
  }(e == null && ke.path);
} }, ke.exports), ke.exports), L = function(t) {
  return function(e, i) {
    if (!e) return t;
    var n;
    typeof e == "string" ? n = e : i = e;
    var s = t;
    return n && (s += "__" + n), s + (i ? Object.keys(i).reduce(function(r, l) {
      var a = i[l];
      return a && (r += " " + (typeof a == "boolean" ? s + "--" + l : s + "--" + l + "_" + a)), r;
    }, "") : "");
  };
};
function at(t, e, i) {
  var n, s, r, l, a;
  function o() {
    var d = Date.now() - l;
    d < e && d >= 0 ? n = setTimeout(o, e - d) : (n = null, i || (a = t.apply(r, s), r = s = null));
  }
  e == null && (e = 100);
  var c = function() {
    r = this, s = arguments, l = Date.now();
    var d = i && !n;
    return n || (n = setTimeout(o, e)), d && (a = t.apply(r, s), r = s = null), a;
  };
  return c.clear = function() {
    n && (clearTimeout(n), n = null);
  }, c.flush = function() {
    n && (a = t.apply(r, s), r = s = null, clearTimeout(n), n = null);
  }, c;
}
at.debounce = at;
var lt = at, w = function() {
  return w = Object.assign || function(t) {
    for (var e, i = 1, n = arguments.length; i < n; i++) for (var s in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
    return t;
  }, w.apply(this, arguments);
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function Kt(t, e) {
  var i, n;
  return t && e ? (i = "".concat(t).concat(e[0].toUpperCase()).concat(e.slice(1)), n = "".concat(t, "-").concat(e)) : (i = t || e, n = t || e), { name: i, classname: n };
}
function Qt(t) {
  return /^blob:/.test(t);
}
function zt(t) {
  return Qt(t) || function(e) {
    return /^data:/.test(e);
  }(t);
}
function fe(t) {
  return !!(t && t.constructor && t.call && t.apply);
}
function E(t) {
  return t === void 0;
}
function De(t) {
  return typeof t == "object" && t !== null;
}
function ct(t, e, i) {
  var n = {};
  return De(t) ? (Object.keys(e).forEach(function(s) {
    E(t[s]) ? n[s] = e[s] : De(e[s]) ? De(t[s]) ? n[s] = ct(t[s], e[s], i[s]) : n[s] = t[s] ? e[s] : i[s] : e[s] === !0 || e[s] === !1 ? n[s] = !!t[s] : n[s] = t[s];
  }), n) : t ? e : i;
}
function Pe(t) {
  var e = Number(t);
  return Number.isNaN(e) ? t : e;
}
function kt(t) {
  return typeof (t == "number" || /* @__PURE__ */ function(e) {
    return typeof e == "object" && e !== null;
  }(t) && toString.call(t) == "[object Number]") && !Jt(t);
}
function Jt(t) {
  return t != t;
}
function ei(t, e) {
  return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
}
var xe = function(t, e) {
  t === void 0 && (t = {}), e === void 0 && (e = {}), this.type = "manipulateImage", this.move = t, this.scale = e;
}, an = function(t, e) {
  e === void 0 && (e = {}), this.type = "resize", this.directions = t, this.params = e;
}, mt = function(t) {
  this.type = "move", this.directions = t;
}, ln = function() {
  function t(e, i, n, s, r) {
    this.type = "drag", this.nativeEvent = e, this.position = n, this.previousPosition = s, this.element = i, this.anchor = r;
  }
  return t.prototype.shift = function() {
    var e = this, i = e.element, n = e.anchor, s = e.position, r = i.getBoundingClientRect(), l = r.left, a = r.top;
    return { left: s.left - l - n.left, top: s.top - a - n.top };
  }, t;
}();
function T(t, e, i, n, s, r, l, a, o, c) {
  const d = typeof i == "function" ? i.options : i;
  let u;
  return t && t.render && (d.render = t.render, d.staticRenderFns = t.staticRenderFns, d._compiled = !0), i;
}
var ti = T({ render: function() {
  var t = this, e = t.$createElement;
  return (t._self._c || e)("div", { ref: "draggable", class: t.classname, on: { touchstart: t.onTouchStart, mousedown: t.onMouseDown, mouseover: t.onMouseOver, mouseleave: t.onMouseLeave } }, [t._t("default")], 2);
}, staticRenderFns: [] }, void 0, { name: "DraggableElement", mixins: [{ beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeDestroy: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, mounted: function() {
  if (!this.$refs.draggable) throw new Error('You should add ref "draggable" to your root element to use draggable mixin');
  this.touches = [], this.hovered = !1;
}, methods: { onMouseOver: function() {
  this.hovered || (this.hovered = !0, this.$emit("enter"));
}, onMouseLeave: function() {
  this.hovered && !this.touches.length && (this.hovered = !1, this.$emit("leave"));
}, onTouchStart: function(t) {
  t.cancelable && !this.disabled && t.touches.length === 1 && (this.touches = he(t.touches), this.hovered || (this.$emit("enter"), this.hovered = !0), t.touches.length && this.initAnchor(this.touches.reduce(function(e, i) {
    return { clientX: e.clientX + i.clientX / t.touches.length, clientY: e.clientY + i.clientY / t.touches.length };
  }, { clientX: 0, clientY: 0 })), t.preventDefault && t.preventDefault(), t.stopPropagation());
}, onTouchEnd: function() {
  this.processEnd();
}, onTouchMove: function(t) {
  this.touches.length && (this.processMove(t, t.touches), t.preventDefault && t.preventDefault(), t.stopPropagation && t.stopPropagation());
}, onMouseDown: function(t) {
  if (!this.disabled && t.button === 0) {
    var e = { fake: !0, clientX: t.clientX, clientY: t.clientY };
    this.touches = [e], this.initAnchor(e), t.stopPropagation();
  }
}, onMouseMove: function(t) {
  this.touches.length && (this.processMove(t, [{ fake: !0, clientX: t.clientX, clientY: t.clientY }]), t.preventDefault && t.preventDefault());
}, onMouseUp: function() {
  this.processEnd();
}, initAnchor: function(t) {
  var e = this.$refs.draggable.getBoundingClientRect(), i = e.left, n = e.right, s = e.bottom, r = e.top;
  this.anchor = { left: t.clientX - i, top: t.clientY - r, bottom: s - t.clientY, right: n - t.clientX };
}, processMove: function(t, e) {
  var i = he(e);
  if (this.touches.length) {
    if (this.touches.length === 1 && i.length === 1) {
      var n = this.$refs.draggable;
      this.$emit("drag", new ln(t, n, { left: i[0].clientX, top: i[0].clientY }, { left: this.touches[0].clientX, top: this.touches[0].clientY }, this.anchor));
    }
    this.touches = i;
  }
}, processEnd: function() {
  this.touches.length && this.$emit("drag-end"), this.hovered && (this.$emit("leave"), this.hovered = !1), this.touches = [];
} } }], props: { classname: { type: String } } }, void 0, !1), Qe = L("vue-handler-wrapper"), cn = T({ render: function() {
  var t = this, e = t.$createElement, i = t._self._c || e;
  return i("div", { class: t.classes.root }, [i("DraggableElement", { class: t.classes.draggable, on: { drag: function(n) {
    return t.$emit("drag", n);
  }, "drag-end": function(n) {
    return t.$emit("drag-end");
  }, leave: function(n) {
    return t.$emit("leave");
  }, enter: function(n) {
    return t.$emit("enter");
  } } }, [t._t("default")], 2)], 1);
}, staticRenderFns: [] }, void 0, { name: "HandlerWrapper", components: { DraggableElement: ti }, props: { horizontalPosition: { type: String }, verticalPosition: { type: String }, disabled: { type: Boolean, default: !1 } }, computed: { classes: function() {
  var t;
  if (this.horizontalPosition || this.verticalPosition) {
    var e = Kt(this.horizontalPosition, this.verticalPosition);
    t = Qe(F(F({}, e.classname, !0), "disabled", this.disabled));
  } else t = Qe({ disabled: this.disabled });
  return { root: t, draggable: Qe("draggable") };
} } }, void 0, !1), un = L("vue-line-wrapper"), dn = T({ render: function() {
  var t = this, e = t.$createElement;
  return (t._self._c || e)("DraggableElement", { class: t.classname, on: { drag: function(i) {
    return t.$emit("drag", i);
  }, "drag-end": function(i) {
    return t.$emit("drag-end");
  }, leave: function(i) {
    return t.$emit("leave");
  }, enter: function(i) {
    return t.$emit("enter");
  } } }, [t._t("default")], 2);
}, staticRenderFns: [] }, void 0, { name: "LineWrapper", components: { DraggableElement: ti }, props: { position: { type: String, required: !0 }, disabled: { type: Boolean, default: !1 } }, computed: { classname: function() {
  return un(F(F({}, this.position, !0), "disabled", this.disabled));
} } }, void 0, !1), V = ["left", "right", "top", "bottom"], hn = ["left", "right"], pn = ["top", "bottom"], fn = ["left", "top"], mn = ["fill-area", "fit-area", "stencil", "none"], Pt = { left: 0, top: 0, width: 0, height: 0 };
function Et(t, e, i) {
  return !(i = i || ["width", "height", "left", "top"]).some(function(n) {
    return t[n] !== e[n];
  });
}
function U(t) {
  return { left: t.left, top: t.top, right: t.left + t.width, bottom: t.top + t.height };
}
function me(t, e) {
  return { left: t.left - e.left, top: t.top - e.top };
}
function I(t) {
  return { left: t.left + t.width / 2, top: t.top + t.height / 2 };
}
function Ae(t, e) {
  var i = { left: 0, top: 0, right: 0, bottom: 0 };
  return V.forEach(function(n) {
    var s = e[n], r = U(t)[n];
    i[n] = s !== void 0 && r !== void 0 ? n === "left" || n === "top" ? Math.max(0, s - r) : Math.max(0, r - s) : 0;
  }), i;
}
function H(t, e) {
  return { left: t.left - e.left, top: t.top - e.top, width: t.width + e.left + e.right, height: t.height + e.top + e.bottom };
}
function je(t) {
  return { left: -t.left, top: -t.top };
}
function D(t, e) {
  return w(w({}, t), { left: t.left + e.left, top: t.top + e.top });
}
function B(t, e, i, n) {
  if (e !== 1) {
    if (i) {
      var s = I(t);
      return { width: t.width * e, height: t.height * e, left: t.left + t.width * (1 - e) / 2 + (i.left - s.left) * (1 - e), top: t.top + t.height * (1 - e) / 2 + (i.top - s.top) * (1 - e) };
    }
    return { width: t.width * e, height: t.height * e, left: t.left + t.width * (1 - e) / 2, top: t.top + t.height * (1 - e) / 2 };
  }
  return t;
}
function A(t) {
  return t.width / t.height;
}
function be(t, e) {
  return Math.min(e.right !== void 0 && e.left !== void 0 ? (e.right - e.left) / t.width : 1 / 0, e.bottom !== void 0 && e.top !== void 0 ? (e.bottom - e.top) / t.height : 1 / 0);
}
function ge(t, e) {
  var i = { left: 0, top: 0 }, n = Ae(t, e);
  return n.left && n.left > 0 ? i.left = n.left : n.right && n.right > 0 && (i.left = -n.right), n.top && n.top > 0 ? i.top = n.top : n.bottom && n.bottom > 0 && (i.top = -n.bottom), i;
}
function Je(t, e) {
  var i;
  return e.minimum && t < e.minimum ? i = e.minimum : e.maximum && t > e.maximum && (i = e.maximum), i;
}
function It(t, e) {
  var i = A(t), n = A(e);
  return e.width < 1 / 0 && e.height < 1 / 0 ? i > n ? { width: e.width, height: e.width / i } : { width: e.height * i, height: e.height } : e.width < 1 / 0 ? { width: e.width, height: e.width / i } : e.height < 1 / 0 ? { width: e.height * i, height: e.height } : t;
}
function gt(t, e) {
  var i = e * Math.PI / 180;
  return { width: Math.abs(t.width * Math.cos(i)) + Math.abs(t.height * Math.sin(i)), height: Math.abs(t.width * Math.sin(i)) + Math.abs(t.height * Math.cos(i)) };
}
function re(t, e) {
  var i = e * Math.PI / 180;
  return { left: t.left * Math.cos(i) - t.top * Math.sin(i), top: t.left * Math.sin(i) + t.top * Math.cos(i) };
}
function Be(t, e) {
  var i = Ae(O(t, e), e);
  return i.left + i.right + i.top + i.bottom ? i.left + i.right > i.top + i.bottom ? Math.min((t.width + i.left + i.right) / t.width, be(t, e)) : Math.min((t.height + i.top + i.bottom) / t.height, be(t, e)) : 1;
}
function O(t, e, i) {
  i === void 0 && (i = !1);
  var n = ge(t, e);
  return D(t, i ? je(n) : n);
}
function et(t) {
  return { width: t.right !== void 0 && t.left !== void 0 ? t.right - t.left : 1 / 0, height: t.bottom !== void 0 && t.top !== void 0 ? t.bottom - t.top : 1 / 0 };
}
function ii(t, e, i) {
  i === void 0 && (i = !0);
  var n = {};
  return V.forEach(function(s) {
    var r = t[s], l = e[s];
    r !== void 0 && l !== void 0 ? n[s] = s === "left" || s === "top" ? i ? Math.max(r, l) : Math.min(r, l) : i ? Math.min(r, l) : Math.max(r, l) : l !== void 0 ? n[s] = l : r !== void 0 && (n[s] = r);
  }), n;
}
function Fe(t, e) {
  return ii(t, e, !0);
}
function Ot(t) {
  var e = t.size, i = t.aspectRatio, n = t.ignoreMinimum, s = t.sizeRestrictions;
  return !!((e.correctRatio || A(e) >= i.minimum && A(e) <= i.maximum) && e.height <= s.maxHeight && e.width <= s.maxWidth && e.width && e.height && (n || e.height >= s.minHeight && e.width >= s.minWidth));
}
function Tt(t, e) {
  return Math.pow(t.width - e.width, 2) + Math.pow(t.height - e.height, 2);
}
function J(t) {
  var e = t.width, i = t.height, n = t.sizeRestrictions, s = { minimum: t.aspectRatio && t.aspectRatio.minimum || 0, maximum: t.aspectRatio && t.aspectRatio.maximum || 1 / 0 }, r = { width: Math.max(n.minWidth, Math.min(n.maxWidth, e)), height: Math.max(n.minHeight, Math.min(n.maxHeight, i)) };
  function l(c, d) {
    return d === void 0 && (d = !1), c.reduce(function(u, p) {
      return Ot({ size: p, aspectRatio: s, sizeRestrictions: n, ignoreMinimum: d }) && (!u || Tt(p, { width: e, height: i }) < Tt(u, { width: e, height: i })) ? p : u;
    }, null);
  }
  var a = [];
  s && [s.minimum, s.maximum].forEach(function(c) {
    c && a.push({ width: r.width, height: r.width / c, correctRatio: !0 }, { width: r.height * c, height: r.height, correctRatio: !0 });
  }), Ot({ size: r, aspectRatio: s, sizeRestrictions: n }) && a.push(r);
  var o = l(a) || l(a, !0);
  return o && { width: o.width, height: o.height };
}
function ut(t) {
  var e = t.event, i = t.coordinates, n = t.positionRestrictions, s = n === void 0 ? {} : n, r = D(i, e.directions);
  return D(r, ge(r, s));
}
function gn(t) {
  var e = t.coordinates, i = t.transform, n = t.imageSize, s = t.sizeRestrictions, r = t.positionRestrictions, l = t.aspectRatio, a = t.visibleArea, o = function(d, u) {
    return ut({ coordinates: d, positionRestrictions: r, event: new mt({ left: u.left - d.left, top: u.top - d.top }) });
  }, c = w({}, e);
  return (Array.isArray(i) ? i : [i]).forEach(function(d) {
    var u = {};
    E((u = typeof d == "function" ? d({ coordinates: c, imageSize: n, visibleArea: a }) : d).width) && E(u.height) || (c = function(p, f) {
      var h = w(w(w({}, p), J({ width: f.width, height: f.height, sizeRestrictions: s, aspectRatio: l })), { left: 0, top: 0 });
      return o(h, { left: p.left, top: p.top });
    }(c, w(w({}, c), u))), E(u.left) && E(u.top) || (c = o(c, w(w({}, c), u)));
  }), c;
}
function vn(t) {
  t.event;
  var e = t.getAreaRestrictions, i = t.boundaries, n = t.coordinates, s = t.visibleArea;
  t.aspectRatio;
  var r = t.stencilSize, l = t.sizeRestrictions, a = t.positionRestrictions;
  t.stencilReference;
  var o, c, d, u = w({}, n), p = w({}, s), f = w({}, r);
  o = A(f), c = A(u), d === void 0 && (d = 1e-3), (o === 0 || c === 0 ? Math.abs(c - o) < d : Math.abs(c / o) < 1 + d && Math.abs(c / o) > 1 - d) || (u = w(w({}, u), J({ sizeRestrictions: l, width: u.width, height: u.height, aspectRatio: { minimum: A(f), maximum: A(f) } })));
  var h = Be(p = B(p, u.width * i.width / (p.width * f.width)), e({ visibleArea: p, type: "resize" }));
  return h !== 1 && (p = B(p, h), u = B(u, h)), p = O(p = D(p, me(I(u), I(p))), e({ visibleArea: p, type: "move" })), { coordinates: u = O(u, Fe(U(p), a)), visibleArea: p };
}
function bn(t) {
  var e = t.event, i = t.getAreaRestrictions, n = t.boundaries, s = t.coordinates, r = t.visibleArea;
  t.aspectRatio, t.stencilSize, t.sizeRestrictions;
  var l = t.positionRestrictions;
  t.stencilReference;
  var a = w({}, s), o = w({}, r);
  if (s && r && e.type !== "manipulateImage") {
    var c = { width: 0, height: 0 };
    o.width, n.width, A(n) > A(a) ? (c.height = 0.8 * n.height, c.width = c.height * A(a)) : (c.width = 0.8 * n.width, c.height = c.width * A(a));
    var d = Be(o = B(o, a.width * n.width / (o.width * c.width)), i({ visibleArea: o, type: "resize" }));
    o = B(o, d), d !== 1 && (c.height /= d, c.width /= d), o = O(o = D(o, me(I(a), I(o))), i({ visibleArea: o, type: "move" })), a = O(a, Fe(U(o), l));
  }
  return { coordinates: a, visibleArea: o };
}
function _n(t) {
  var e = t.event, i = t.coordinates, n = t.visibleArea, s = t.getAreaRestrictions, r = w({}, n), l = w({}, i);
  if (e.type === "setCoordinates") {
    var a = Math.max(0, l.width - r.width), o = Math.max(0, l.height - r.height);
    a > o ? r = B(r, Math.min(l.width / r.width, be(r, s({ visibleArea: r, type: "resize" })))) : o > a && (r = B(r, Math.min(l.height / r.height, be(r, s({ visibleArea: r, type: "resize" }))))), r = O(r = D(r, je(ge(l, U(r)))), s({ visibleArea: r, type: "move" }));
  }
  return { visibleArea: r, coordinates: l };
}
function yn(t) {
  var e = t.imageSize, i = t.visibleArea, n = t.aspectRatio, s = t.sizeRestrictions, r = i || e, l = Math.min(n.maximum || 1 / 0, Math.max(n.minimum || 0, A(r))), a = r.width < r.height ? { width: 0.8 * r.width, height: 0.8 * r.width / l } : { height: 0.8 * r.height, width: 0.8 * r.height * l };
  return J(w(w({}, a), { aspectRatio: n, sizeRestrictions: s }));
}
function wn(t) {
  var e, i, n = t.imageSize, s = t.visibleArea, r = t.boundaries, l = t.aspectRatio, a = t.sizeRestrictions, o = t.stencilSize, c = s || n;
  return A(c) > A(r) ? i = (e = o.height * c.height / r.height) * A(o) : e = (i = o.width * c.width / r.width) / A(o), J({ width: i, height: e, aspectRatio: l, sizeRestrictions: a });
}
function Ee(t, e) {
  return ii(t, U(e));
}
function Dt(t) {
  var e = t.directions, i = t.coordinates, n = t.positionRestrictions, s = n === void 0 ? {} : n, r = t.sizeRestrictions, l = t.preserveRatio, a = t.compensate, o = w({}, e), c = H(i, o).width, d = H(i, o).height;
  c < 0 && (o.left < 0 && o.right < 0 ? (o.left = -(i.width - r.minWidth) / (o.left / o.right), o.right = -(i.width - r.minWidth) / (o.right / o.left)) : o.left < 0 ? o.left = -(i.width - r.minWidth) : o.right < 0 && (o.right = -(i.width - r.minWidth))), d < 0 && (o.top < 0 && o.bottom < 0 ? (o.top = -(i.height - r.minHeight) / (o.top / o.bottom), o.bottom = -(i.height - r.minHeight) / (o.bottom / o.top)) : o.top < 0 ? o.top = -(i.height - r.minHeight) : o.bottom < 0 && (o.bottom = -(i.height - r.minHeight)));
  var u = Ae(H(i, o), s);
  a && (u.left && u.left > 0 && u.right === 0 ? (o.right += u.left, o.left -= u.left) : u.right && u.right > 0 && u.left === 0 && (o.left += u.right, o.right -= u.right), u.top && u.top > 0 && u.bottom === 0 ? (o.bottom += u.top, o.top -= u.top) : u.bottom && u.bottom > 0 && u.top === 0 && (o.top += u.bottom, o.bottom -= u.bottom), u = Ae(H(i, o), s));
  var p = { width: 1 / 0, height: 1 / 0, left: 1 / 0, right: 1 / 0, top: 1 / 0, bottom: 1 / 0 };
  if (V.forEach(function(m) {
    var g = u[m];
    g && o[m] && (p[m] = Math.max(0, 1 - g / o[m]));
  }), l) {
    var f = Math.min.apply(null, V.map(function(m) {
      return p[m];
    }));
    f !== 1 / 0 && V.forEach(function(m) {
      o[m] *= f;
    });
  } else V.forEach(function(m) {
    p[m] !== 1 / 0 && (o[m] *= p[m]);
  });
  if (c = H(i, o).width, d = H(i, o).height, o.right + o.left && (c > r.maxWidth ? p.width = (r.maxWidth - i.width) / (o.right + o.left) : c < r.minWidth && (p.width = (r.minWidth - i.width) / (o.right + o.left))), o.bottom + o.top && (d > r.maxHeight ? p.height = (r.maxHeight - i.height) / (o.bottom + o.top) : d < r.minHeight && (p.height = (r.minHeight - i.height) / (o.bottom + o.top))), l) {
    var h = Math.min(p.width, p.height);
    h !== 1 / 0 && V.forEach(function(m) {
      o[m] *= h;
    });
  } else p.width !== 1 / 0 && hn.forEach(function(m) {
    o[m] *= p.width;
  }), p.height !== 1 / 0 && pn.forEach(function(m) {
    o[m] *= p.height;
  });
  return o;
}
function Ie(t, e, i) {
  return e == 0 && i == 0 ? t / 2 : e == 0 ? 0 : i == 0 ? t : t * Math.abs(e / (e + i));
}
var $n = L("vue-simple-handler"), xn = L("vue-simple-handler-wrapper"), Ve = T({ render: function() {
  var t = this, e = t.$createElement, i = t._self._c || e;
  return i("HandlerWrapper", { class: t.classes.wrapper, attrs: { "vertical-position": t.verticalPosition, "horizontal-position": t.horizontalPosition, disabled: t.disabled }, on: { drag: t.onDrag, "drag-end": t.onDragEnd, enter: t.onEnter, leave: t.onLeave } }, [i("div", { class: t.classes.default })]);
}, staticRenderFns: [] }, void 0, { name: "SimpleHandler", components: { HandlerWrapper: cn }, props: { defaultClass: { type: String }, hoverClass: { type: String }, wrapperClass: { type: String }, horizontalPosition: { type: String }, verticalPosition: { type: String }, disabled: { type: Boolean, default: !1 } }, data: function() {
  return { hover: !1 };
}, computed: { classes: function() {
  var t = F(F(F(F({}, this.horizontalPosition, !!this.horizontalPosition), this.verticalPosition, !!this.verticalPosition), "".concat(this.horizontalPosition, "-").concat(this.verticalPosition), !!(this.verticalPosition && this.horizontalPosition)), "hover", this.hover);
  return { default: P($n(t), this.defaultClass, this.hover && this.hoverClass), wrapper: P(xn(t), this.wrapperClass) };
} }, methods: { onDrag: function(t) {
  this.$emit("drag", t);
}, onEnter: function() {
  this.hover = !0;
}, onLeave: function() {
  this.hover = !1;
}, onDragEnd: function() {
  this.$emit("drag-end");
} } }, void 0, !1), Cn = L("vue-simple-line"), Sn = L("vue-simple-line-wrapper"), Ue = T({ render: function() {
  var t = this, e = t.$createElement, i = t._self._c || e;
  return i("LineWrapper", { class: t.classes.wrapper, attrs: { position: t.position, disabled: t.disabled }, on: { drag: t.onDrag, "drag-end": t.onDragEnd, enter: t.onEnter, leave: t.onLeave } }, [i("div", { class: t.classes.root })]);
}, staticRenderFns: [] }, void 0, { name: "SimpleLine", components: { LineWrapper: dn }, props: { defaultClass: { type: String }, hoverClass: { type: String }, wrapperClass: { type: String }, position: { type: String }, disabled: { type: Boolean, default: !1 } }, data: function() {
  return { hover: !1 };
}, computed: { classes: function() {
  return { root: P(Cn(F({}, this.position, !0)), this.defaultClass, this.hover && this.hoverClass), wrapper: P(Sn(F({}, this.position, !0)), this.wrapperClass) };
} }, methods: { onDrag: function(t) {
  this.$emit("drag", t);
}, onEnter: function() {
  this.hover = !0;
}, onLeave: function() {
  this.hover = !1;
}, onDragEnd: function() {
  this.$emit("drag-end");
} } }, void 0, !1), tt = L("vue-bounding-box"), An = ["east", "west", null], Rn = ["south", "north", null], ni = T({ render: function() {
  var t = this, e = t.$createElement, i = t._self._c || e;
  return i("div", { ref: "box", class: t.classes.root, style: t.style }, [t._t("default"), t._v(" "), i("div", t._l(t.lineNodes, function(n) {
    return i(n.component, { key: n.name, tag: "component", attrs: { "default-class": n.class, "hover-class": n.hoverClass, "wrapper-class": n.wrapperClass, position: n.name, disabled: n.disabled }, on: { drag: function(s) {
      return t.onHandlerDrag(s, n.horizontalDirection, n.verticalDirection);
    }, "drag-end": function(s) {
      return t.onEnd();
    } } });
  }), 1), t._v(" "), t._l(t.handlerNodes, function(n) {
    return i("div", { key: n.name, class: n.wrapperClass, style: n.wrapperStyle }, [i(n.component, { tag: "component", attrs: { "default-class": n.class, "hover-class": n.hoverClass, "wrapper-class": n.wrapperClass, "horizontal-position": n.horizontalDirection, "vertical-position": n.verticalDirection, disabled: n.disabled }, on: { drag: function(s) {
      return t.onHandlerDrag(s, n.horizontalDirection, n.verticalDirection);
    }, "drag-end": function(s) {
      return t.onEnd();
    } } })], 1);
  })], 2);
}, staticRenderFns: [] }, void 0, { name: "BoundingBox", props: { width: { type: Number }, height: { type: Number }, transitions: { type: Object }, handlers: { type: Object, default: function() {
  return { eastNorth: !0, north: !0, westNorth: !0, west: !0, westSouth: !0, south: !0, eastSouth: !0, east: !0 };
} }, handlersComponent: { type: [Object, String], default: function() {
  return Ve;
} }, handlersClasses: { type: Object, default: function() {
  return {};
} }, handlersWrappersClasses: { type: Object, default: function() {
  return {};
} }, lines: { type: Object, default: function() {
  return { west: !0, north: !0, east: !0, south: !0 };
} }, linesComponent: { type: [Object, String], default: function() {
  return Ue;
} }, linesClasses: { type: Object, default: function() {
  return {};
} }, linesWrappersClasses: { type: Object, default: function() {
  return {};
} }, resizable: { type: Boolean, default: !0 } }, data: function() {
  var t = [];
  return An.forEach(function(e) {
    Rn.forEach(function(i) {
      if (e !== i) {
        var n = Kt(e, i), s = n.name, r = n.classname;
        t.push({ name: s, classname: r, verticalDirection: i, horizontalDirection: e });
      }
    });
  }), { points: t };
}, computed: { style: function() {
  var t = {};
  return this.width && this.height && (t.width = "".concat(this.width, "px"), t.height = "".concat(this.height, "px"), this.transitions && this.transitions.enabled && (t.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction))), t;
}, classes: function() {
  var t = this.handlersClasses, e = this.handlersWrappersClasses, i = this.linesClasses, n = this.linesWrappersClasses;
  return { root: tt(), handlers: t, handlersWrappers: e, lines: i, linesWrappers: n };
}, lineNodes: function() {
  var t = this, e = [];
  return this.points.forEach(function(i) {
    i.horizontalDirection && i.verticalDirection || !t.lines[i.name] || e.push({ name: i.name, component: t.linesComponent, class: P(t.classes.lines.default, t.classes.lines[i.name], !t.resizable && t.classes.lines.disabled), wrapperClass: P(t.classes.linesWrappers.default, t.classes.linesWrappers[i.name], !t.resizable && t.classes.linesWrappers.disabled), hoverClass: t.classes.lines.hover, verticalDirection: i.verticalDirection, horizontalDirection: i.horizontalDirection, disabled: !t.resizable });
  }), e;
}, handlerNodes: function() {
  var t = this, e = [], i = this.width, n = this.height;
  return this.points.forEach(function(s) {
    if (t.handlers[s.name]) {
      var r = { name: s.name, component: t.handlersComponent, class: P(t.classes.handlers.default, t.classes.handlers[s.name]), wrapperClass: P(t.classes.handlersWrappers.default, t.classes.handlersWrappers[s.name]), hoverClass: t.classes.handlers.hover, verticalDirection: s.verticalDirection, horizontalDirection: s.horizontalDirection, disabled: !t.resizable };
      if (i && n) {
        var l = s.horizontalDirection, a = s.verticalDirection, o = l === "east" ? i : l === "west" ? 0 : i / 2, c = a === "south" ? n : a === "north" ? 0 : n / 2;
        r.wrapperClass = tt("handler"), r.wrapperStyle = { transform: "translate(".concat(o, "px, ").concat(c, "px)") }, t.transitions && t.transitions.enabled && (r.wrapperStyle.transition = "".concat(t.transitions.time, "ms ").concat(t.transitions.timingFunction));
      } else r.wrapperClass = tt("handler", F({}, s.classname, !0));
      e.push(r);
    }
  }), e;
} }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeDestroy: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, mounted: function() {
  this.touches = [];
}, methods: { onEnd: function() {
  this.$emit("resize-end");
}, onHandlerDrag: function(t, e, i) {
  var n, s = t.shift(), r = s.left, l = s.top, a = { left: 0, right: 0, top: 0, bottom: 0 };
  e === "west" ? a.left -= r : e === "east" && (a.right += r), i === "north" ? a.top -= l : i === "south" && (a.bottom += l), !i && e ? n = "width" : i && !e && (n = "height"), this.resizable && this.$emit("resize", new an(a, { allowedDirections: { left: e === "west" || !e, right: e === "east" || !e, bottom: i === "south" || !i, top: i === "north" || !i }, preserveAspectRatio: t.nativeEvent && t.nativeEvent.shiftKey, respectDirection: n }));
} } }, void 0, !1), Mn = L("vue-draggable-area"), si = T({ render: function() {
  var t = this, e = t.$createElement;
  return (t._self._c || e)("div", { ref: "container", on: { touchstart: t.onTouchStart, mousedown: t.onMouseDown } }, [t._t("default")], 2);
}, staticRenderFns: [] }, void 0, { name: "DraggableArea", props: { movable: { type: Boolean, default: !0 }, activationDistance: { type: Number, default: 20 } }, computed: { classnames: function() {
  return { default: Mn() };
} }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeDestroy: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, mounted: function() {
  this.touches = [], this.touchStarted = !1;
}, methods: { onTouchStart: function(t) {
  if (t.cancelable) {
    var e = this.movable && t.touches.length === 1;
    e && (this.touches = he(t.touches)), (this.touchStarted || e) && (t.preventDefault(), t.stopPropagation());
  }
}, onTouchEnd: function() {
  this.touchStarted = !1, this.processEnd();
}, onTouchMove: function(t) {
  this.touches.length >= 1 && (this.touchStarted ? (this.processMove(t, t.touches), t.preventDefault(), t.stopPropagation()) : ei({ x: this.touches[0].clientX, y: this.touches[0].clientY }, { x: t.touches[0].clientX, y: t.touches[0].clientY }) > this.activationDistance && (this.initAnchor({ clientX: t.touches[0].clientX, clientY: t.touches[0].clientY }), this.touchStarted = !0));
}, onMouseDown: function(t) {
  if (this.movable && t.button === 0) {
    var e = { fake: !0, clientX: t.clientX, clientY: t.clientY };
    this.touches = [e], this.initAnchor(e), t.stopPropagation();
  }
}, onMouseMove: function(t) {
  this.touches.length && (this.processMove(t, [{ fake: !0, clientX: t.clientX, clientY: t.clientY }]), t.preventDefault && t.cancelable && t.preventDefault(), t.stopPropagation());
}, onMouseUp: function() {
  this.processEnd();
}, initAnchor: function(t) {
  var e = this.$refs.container.getBoundingClientRect(), i = e.left, n = e.top;
  this.anchor = { x: t.clientX - i, y: t.clientY - n };
}, processMove: function(t, e) {
  var i = he(e);
  if (this.touches.length) {
    var n = this.$refs.container.getBoundingClientRect(), s = n.left, r = n.top;
    this.touches.length === 1 && i.length === 1 && this.$emit("move", new mt({ left: i[0].clientX - (s + this.anchor.x), top: i[0].clientY - (r + this.anchor.y) }));
  }
}, processEnd: function() {
  this.touches.length && this.$emit("move-end"), this.touches = [];
} } }, void 0, !1), zn = 4;
function it(t) {
  var e, i;
  return { rotate: t.rotate || 0, flip: { horizontal: ((e = t == null ? void 0 : t.flip) === null || e === void 0 ? void 0 : e.horizontal) || !1, vertical: ((i = t == null ? void 0 : t.flip) === null || i === void 0 ? void 0 : i.vertical) || !1 } };
}
function kn(t) {
  return new Promise(function(e, i) {
    try {
      if (t) if (/^data:/i.test(t)) e(function(o) {
        o = o.replace(/^data:([^;]+);base64,/gim, "");
        for (var c = atob(o), d = c.length, u = new ArrayBuffer(d), p = new Uint8Array(u), f = 0; f < d; f++) p[f] = c.charCodeAt(f);
        return u;
      }(t));
      else if (/^blob:/i.test(t)) {
        var n = new FileReader();
        n.onload = function(o) {
          e(o.target.result);
        }, r = t, l = function(o) {
          n.readAsArrayBuffer(o);
        }, (a = new XMLHttpRequest()).open("GET", r, !0), a.responseType = "blob", a.onload = function() {
          this.status != 200 && this.status !== 0 || l(this.response);
        }, a.send();
      } else {
        var s = new XMLHttpRequest();
        s.onreadystatechange = function() {
          s.readyState === zn && (s.status === 200 || s.status === 0 ? e(s.response) : i("Warning: could not load an image to parse its orientation"), s = null);
        }, s.onprogress = function() {
          s.getResponseHeader("content-type") !== "image/jpeg" && s.abort();
        }, s.withCredentials = !1, s.open("GET", t, !0), s.responseType = "arraybuffer", s.send(null);
      }
      else i("Error: the image is empty");
    } catch (o) {
      i(o);
    }
    var r, l, a;
  });
}
function vt(t) {
  var e = t.rotate, i = t.flip, n = t.scaleX, s = t.scaleY, r = "";
  return r += " rotate(".concat(e, "deg) "), r += " scaleX(".concat(n * (i.horizontal ? -1 : 1), ") "), r += " scaleY(".concat(s * (i.vertical ? -1 : 1), ") ");
}
function Pn(t) {
  try {
    var e, i = new DataView(t), n = void 0, s = void 0, r = void 0, l = void 0;
    if (i.getUint8(0) === 255 && i.getUint8(1) === 216) for (var a = i.byteLength, o = 2; o + 1 < a; ) {
      if (i.getUint8(o) === 255 && i.getUint8(o + 1) === 225) {
        r = o;
        break;
      }
      o++;
    }
    if (r && (n = r + 10, function(f, h, m) {
      var g, v = "";
      for (g = h, m += h; g < m; g++) v += String.fromCharCode(f.getUint8(g));
      return v;
    }(i, r + 4, 4) === "Exif")) {
      var c = i.getUint16(n);
      if (((s = c === 18761) || c === 19789) && i.getUint16(n + 2, s) === 42) {
        var d = i.getUint32(n + 4, s);
        d >= 8 && (l = n + d);
      }
    }
    if (l) {
      for (var u = i.getUint16(l, s), p = 0; p < u; p++)
        if (o = l + 12 * p + 2, i.getUint16(o, s) === 274) {
          o += 8, e = i.getUint16(o, s), i.setUint16(o, 1, s);
          break;
        }
    }
    return e;
  } catch {
    return null;
  }
}
var Oe = L("vue-preview-result");
T({ render: function() {
  var t = this, e = t.$createElement, i = t._self._c || e;
  return i("div", { class: t.classes.root }, [i("div", { ref: "wrapper", class: t.classes.wrapper, style: t.wrapperStyle }, [i("img", { ref: "image", class: t.classes.image, style: t.imageStyle, attrs: { src: t.image.src } })])]);
}, staticRenderFns: [] }, void 0, { name: "PreviewResult", props: { image: { type: Object }, transitions: { type: Object }, stencilCoordinates: { type: Object, default: function() {
  return { width: 0, height: 0, left: 0, top: 0 };
} }, imageClass: { type: String } }, computed: { classes: function() {
  return { root: Oe(), wrapper: Oe("wrapper"), imageWrapper: Oe("image-wrapper"), image: P(Oe("image"), this.imageClass) };
}, wrapperStyle: function() {
  var t = { width: "".concat(this.stencilCoordinates.width, "px"), height: "".concat(this.stencilCoordinates.height, "px"), left: "calc(50% - ".concat(this.stencilCoordinates.width / 2, "px)"), top: "calc(50% - ".concat(this.stencilCoordinates.height / 2, "px)") };
  return this.transitions && this.transitions.enabled && (t.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), t;
}, imageStyle: function() {
  var t = this.image.transforms, e = gt({ width: this.image.width, height: this.image.height }, t.rotate), i = { width: "".concat(this.image.width, "px"), height: "".concat(this.image.height, "px"), left: "0px", top: "0px" }, n = { left: (this.image.width - e.width) * t.scaleX / 2, top: (this.image.height - e.height) * t.scaleY / 2 }, s = { left: (1 - t.scaleX) * this.image.width / 2, top: (1 - t.scaleY) * this.image.height / 2 };
  return i.transform = `translate(
				`.concat(-this.stencilCoordinates.left - t.translateX - n.left - s.left, "px,").concat(-this.stencilCoordinates.top - t.translateY - n.top - s.top, "px) ") + vt(t), this.transitions && this.transitions.enabled && (i.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), i;
} } }, void 0, !1);
function Lt(t, e) {
  var i = e.getBoundingClientRect(), n = i.left, s = i.top, r = { left: 0, top: 0 }, l = 0;
  return t.forEach(function(a) {
    r.left += (a.clientX - n) / t.length, r.top += (a.clientY - s) / t.length;
  }), t.forEach(function(a) {
    l += ei({ x: r.left, y: r.top }, { x: a.clientX - n, y: a.clientY - s });
  }), { centerMass: r, spread: l, count: t.length };
}
var En = T({ render: function() {
  var t = this, e = t.$createElement;
  return (t._self._c || e)("div", { ref: "container", on: { touchstart: t.onTouchStart, mousedown: t.onMouseDown, wheel: t.onWheel } }, [t._t("default")], 2);
}, staticRenderFns: [] }, void 0, { props: { touchMove: { type: Boolean, required: !0 }, mouseMove: { type: Boolean, required: !0 }, touchResize: { type: Boolean, required: !0 }, wheelResize: { type: [Boolean, Object], required: !0 }, eventsFilter: { type: Function, required: !1 } }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeDestroy: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, created: function() {
  this.transforming = !1, this.debouncedProcessEnd = lt(this.processEnd), this.touches = [];
}, methods: { processMove: function(t, e) {
  if (this.touches.length) {
    if (this.touches.length === 1 && e.length === 1) this.$emit("move", new xe({ left: this.touches[0].clientX - e[0].clientX, top: this.touches[0].clientY - e[0].clientY }));
    else if (this.touches.length > 1 && this.touchResize) {
      var i = Lt(e, this.$refs.container), n = this.oldGeometricProperties;
      n.count === i.count && n.count > 1 && this.$emit("resize", new xe({ left: n.centerMass.left - i.centerMass.left, top: n.centerMass.top - i.centerMass.top }, { factor: n.spread / i.spread, center: i.centerMass })), this.oldGeometricProperties = i;
    }
    this.touches = e;
  }
}, processEnd: function() {
  this.transforming && (this.transforming = !1, this.$emit("transform-end"));
}, processStart: function() {
  this.transforming = !0, this.debouncedProcessEnd.clear();
}, processEvent: function(t) {
  return this.eventsFilter ? this.eventsFilter(t, this.transforming) !== !1 : (t.preventDefault(), t.stopPropagation(), !0);
}, onTouchStart: function(t) {
  if (t.cancelable && (this.touchMove || this.touchResize && t.touches.length > 1) && this.processEvent(t)) {
    var e = this.$refs.container, i = e.getBoundingClientRect(), n = i.left, s = i.top, r = i.bottom, l = i.right;
    this.touches = he(t.touches).filter(function(a) {
      return a.clientX > n && a.clientX < l && a.clientY > s && a.clientY < r;
    }), this.oldGeometricProperties = Lt(this.touches, e);
  }
}, onTouchEnd: function(t) {
  t.touches.length === 0 && (this.touches = [], this.processEnd());
}, onTouchMove: function(t) {
  var e = this;
  if (this.touches.length) {
    var i = he(t.touches).filter(function(n) {
      return !n.identifier || e.touches.find(function(s) {
        return s.identifier === n.identifier;
      });
    });
    this.processEvent(t) && (this.processMove(t, i), this.processStart());
  }
}, onMouseDown: function(t) {
  if (this.mouseMove && "buttons" in t && t.buttons === 1 && this.processEvent(t)) {
    var e = { fake: !0, clientX: t.clientX, clientY: t.clientY };
    this.touches = [e], this.processStart();
  }
}, onMouseMove: function(t) {
  this.touches.length && this.processEvent(t) && this.processMove(t, [{ clientX: t.clientX, clientY: t.clientY }]);
}, onMouseUp: function() {
  this.touches = [], this.processEnd();
}, onWheel: function(t) {
  if (this.wheelResize && this.processEvent(t)) {
    var e = this.$refs.container.getBoundingClientRect(), i = e.left, n = e.top, s = 1 + this.wheelResize.ratio * (l = t.deltaY || t.detail || t.wheelDelta, (a = +l) == 0 || Jt(a) ? a : a > 0 ? 1 : -1), r = { left: t.clientX - i, top: t.clientY - n };
    this.$emit("resize", new xe({}, { factor: s, center: r })), this.touches.length || this.debouncedProcessEnd();
  }
  var l, a;
} } }, void 0, !1), jt = T({ render: function() {
  var t = this, e = t.$createElement;
  return (t._self._c || e)("transformable-image", { attrs: { "touch-move": t.touchMove, "touch-resize": t.touchResize, "mouse-move": t.mouseMove, "wheel-resize": t.wheelResize }, on: { move: function(i) {
    return t.$emit("move", i);
  }, resize: function(i) {
    return t.$emit("resize", i);
  } } }, [t._t("default")], 2);
}, staticRenderFns: [] }, void 0, { components: { TransformableImage: En }, props: { touchMove: { type: Boolean, required: !0 }, mouseMove: { type: Boolean, required: !0 }, touchResize: { type: Boolean, required: !0 }, wheelResize: { type: [Boolean, Object], required: !0 } } }, void 0, !1), Te = L("vue-preview"), In = T({ render: function() {
  var t = this, e = t.$createElement, i = t._self._c || e;
  return i("div", { ref: "root", class: t.classes.root, style: t.style }, [i("div", { ref: "wrapper", class: t.classes.wrapper, style: t.wrapperStyle }, [i("img", { directives: [{ name: "show", rawName: "v-show", value: t.image && t.image.src, expression: "image && image.src" }], ref: "image", class: t.classes.image, style: t.imageStyle, attrs: { src: t.image && t.image.src } })])]);
}, staticRenderFns: [] }, void 0, { props: { coordinates: { type: Object }, transitions: { type: Object }, image: { type: Object, default: function() {
  return {};
} }, imageClass: { type: String }, width: { type: Number }, height: { type: Number }, fill: { type: Boolean } }, data: function() {
  return { calculatedImageSize: { width: 0, height: 0 }, calculatedSize: { width: 0, height: 0 } };
}, computed: { classes: function() {
  return { root: Te({ fill: this.fill }), wrapper: Te("wrapper"), imageWrapper: Te("image-wrapper"), image: P(Te("image"), this.imageClass) };
}, style: function() {
  if (this.fill) return {};
  var t = {};
  return this.width && (t.width = "".concat(this.size.width, "px")), this.height && (t.height = "".concat(this.size.height, "px")), this.transitions && this.transitions.enabled && (t.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), t;
}, wrapperStyle: function() {
  var t = { width: "".concat(this.size.width, "px"), height: "".concat(this.size.height, "px"), left: "calc(50% - ".concat(this.size.width / 2, "px)"), top: "calc(50% - ".concat(this.size.height / 2, "px)") };
  return this.transitions && this.transitions.enabled && (t.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), t;
}, imageStyle: function() {
  if (this.coordinates && this.image) {
    var t = this.coordinates.width / this.size.width, e = S(S({ rotate: 0, flip: { horizontal: !1, vertical: !1 } }, this.image.transforms), {}, { scaleX: 1 / t, scaleY: 1 / t }), i = this.imageSize.width, n = this.imageSize.height, s = gt({ width: i, height: n }, e.rotate), r = { width: "".concat(i, "px"), height: "".concat(n, "px"), left: "0px", top: "0px" }, l = { rotate: { left: (i - s.width) * e.scaleX / 2, top: (n - s.height) * e.scaleY / 2 }, scale: { left: (1 - e.scaleX) * i / 2, top: (1 - e.scaleY) * n / 2 } };
    return r.transform = `translate(
				`.concat(-this.coordinates.left / t - l.rotate.left - l.scale.left, "px,").concat(-this.coordinates.top / t - l.rotate.top - l.scale.top, "px) ") + vt(e), this.transitions && this.transitions.enabled && (r.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), r;
  }
  return {};
}, size: function() {
  return { width: this.width || this.calculatedSize.width, height: this.height || this.calculatedSize.height };
}, imageSize: function() {
  return { width: this.image.width || this.calculatedImageSize.width, height: this.image.height || this.calculatedImageSize.height };
} }, watch: { image: function(t) {
  (t.width || t.height) && this.onChangeImage();
} }, mounted: function() {
  var t = this;
  this.onChangeImage(), this.$refs.image.addEventListener("load", function() {
    t.refreshImage();
  }), window.addEventListener("resize", this.refresh), window.addEventListener("orientationchange", this.refresh);
}, destroyed: function() {
  window.removeEventListener("resize", this.refresh), window.removeEventListener("orientationchange", this.refresh);
}, methods: { refreshImage: function() {
  var t = this.$refs.image;
  this.calculatedImageSize.height = t.naturalHeight, this.calculatedImageSize.width = t.naturalWidth;
}, refresh: function() {
  var t = this.$refs.root;
  this.width || (this.calculatedSize.width = t.clientWidth), this.height || (this.calculatedSize.height = t.clientHeight);
}, onChangeImage: function() {
  var t = this.$refs.image;
  t && t.complete && this.refreshImage(), this.refresh();
} } }, void 0, !1), ri = T({ render: function() {
  var t = this, e = t.$createElement;
  return (t._self._c || e)("preview", t._b({ attrs: { fill: !0 } }, "preview", t.$attrs, !1));
}, staticRenderFns: [] }, void 0, { components: { Preview: In }, inheritAttrs: !1 }, void 0, !1), nt = L("vue-rectangle-stencil"), oi = T({ render: function() {
  var t = this, e = t.$createElement, i = t._self._c || e;
  return i("div", { class: t.classes.stencil, style: t.style }, [i("bounding-box", { class: t.classes.boundingBox, attrs: { width: t.stencilCoordinates.width, height: t.stencilCoordinates.height, transitions: t.transitions, handlers: t.handlers, "handlers-component": t.handlersComponent, "handlers-classes": t.handlersClasses, "handlers-wrappers-classes": t.handlersWrappersClasses, lines: t.lines, "lines-component": t.linesComponent, "lines-classes": t.linesClasses, "lines-wrappers-classes": t.linesWrappersClasses, resizable: t.resizable }, on: { resize: t.onResize, "resize-end": t.onResizeEnd } }, [i("draggable-area", { attrs: { movable: t.movable }, on: { move: t.onMove, "move-end": t.onMoveEnd } }, [i("stencil-preview", { class: t.classes.preview, attrs: { image: t.image, coordinates: t.coordinates, width: t.stencilCoordinates.width, height: t.stencilCoordinates.height, transitions: t.transitions } })], 1)], 1)], 1);
}, staticRenderFns: [] }, void 0, { name: "RectangleStencil", components: { StencilPreview: ri, BoundingBox: ni, DraggableArea: si }, props: { image: { type: Object }, coordinates: { type: Object }, stencilCoordinates: { type: Object }, handlers: { type: Object }, handlersComponent: { type: [Object, String], default: function() {
  return Ve;
} }, lines: { type: Object }, linesComponent: { type: [Object, String], default: function() {
  return Ue;
} }, aspectRatio: { type: [Number, String] }, minAspectRatio: { type: [Number, String] }, maxAspectRatio: { type: [Number, String] }, movable: { type: Boolean, default: !0 }, resizable: { type: Boolean, default: !0 }, transitions: { type: Object }, movingClass: { type: String }, resizingClass: { type: String }, previewClass: { type: String }, boundingBoxClass: { type: String }, linesClasses: { type: Object, default: function() {
  return {};
} }, linesWrappersClasses: { type: Object, default: function() {
  return {};
} }, handlersClasses: { type: Object, default: function() {
  return {};
} }, handlersWrappersClasses: { type: Object, default: function() {
  return {};
} } }, data: function() {
  return { moving: !1, resizing: !1 };
}, computed: { classes: function() {
  return { stencil: P(nt({ movable: this.movable, moving: this.moving, resizing: this.resizing }), this.moving && this.movingClass, this.resizing && this.resizingClass), preview: P(nt("preview"), this.previewClass), boundingBox: P(nt("bounding-box"), this.boundingBoxClass) };
}, style: function() {
  var t = this.stencilCoordinates, e = t.height, i = t.width, n = t.left, s = t.top, r = { width: "".concat(i, "px"), height: "".concat(e, "px"), transform: "translate(".concat(n, "px, ").concat(s, "px)") };
  return this.transitions && this.transitions.enabled && (r.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), r;
} }, methods: { onMove: function(t) {
  this.$emit("move", t), this.moving = !0;
}, onMoveEnd: function() {
  this.$emit("move-end"), this.moving = !1;
}, onResize: function(t) {
  this.$emit("resize", t), this.resizing = !0;
}, onResizeEnd: function() {
  this.$emit("resize-end"), this.resizing = !1;
}, aspectRatios: function() {
  return { minimum: this.aspectRatio || this.minAspectRatio, maximum: this.aspectRatio || this.maxAspectRatio };
} } }, void 0, !1), st = L("vue-circle-stencil"), On = T({ render: function() {
  var t = this, e = t.$createElement, i = t._self._c || e;
  return i("div", { class: t.classes.stencil, style: t.style }, [i("bounding-box", { class: t.classes.boundingBox, attrs: { width: t.stencilCoordinates.width, height: t.stencilCoordinates.height, transitions: t.transitions, handlers: t.handlers, "handlers-component": t.handlersComponent, "handlers-classes": t.handlersClasses, "handlers-wrappers-classes": t.handlersWrappersClasses, lines: t.lines, "lines-component": t.linesComponent, "lines-classes": t.linesClasses, "lines-wrappers-classes": t.linesWrappersClasses, resizable: t.resizable }, on: { resize: t.onResize, "resize-end": t.onResizeEnd } }, [i("draggable-area", { attrs: { movable: t.movable }, on: { move: t.onMove, "move-end": t.onMoveEnd } }, [i("stencil-preview", { class: t.classes.preview, attrs: { image: t.image, coordinates: t.coordinates, width: t.stencilCoordinates.width, height: t.stencilCoordinates.height, transitions: t.transitions } })], 1)], 1)], 1);
}, staticRenderFns: [] }, void 0, { components: { StencilPreview: ri, BoundingBox: ni, DraggableArea: si }, props: { image: { type: Object }, coordinates: { type: Object }, stencilCoordinates: { type: Object }, handlers: { type: Object, default: function() {
  return { eastNorth: !0, westNorth: !0, westSouth: !0, eastSouth: !0 };
} }, handlersComponent: { type: [Object, String], default: function() {
  return Ve;
} }, handlersClasses: { type: Object, default: function() {
  return {};
} }, handlersWrappersClasses: { type: Object, default: function() {
  return {};
} }, lines: { type: Object }, linesComponent: { type: [Object, String], default: function() {
  return Ue;
} }, linesClasses: { type: Object, default: function() {
  return {};
} }, linesWrappersClasses: { type: Object, default: function() {
  return {};
} }, movable: { type: Boolean, default: !0 }, resizable: { type: Boolean, default: !0 }, transitions: { type: Object }, movingClass: { type: String }, resizingClass: { type: String }, previewClass: { type: String }, boundingBoxClass: { type: String } }, data: function() {
  return { moving: !1, resizing: !1 };
}, computed: { classes: function() {
  return { stencil: P(st({ movable: this.movable, moving: this.moving, resizing: this.resizing }), this.moving && this.movingClass, this.resizing && this.resizingClass), preview: P(st("preview"), this.previewClass), boundingBox: P(st("bounding-box"), this.boundingBoxClass) };
}, style: function() {
  var t = this.stencilCoordinates, e = t.height, i = t.width, n = t.left, s = t.top, r = { width: "".concat(i, "px"), height: "".concat(e, "px"), transform: "translate(".concat(n, "px, ").concat(s, "px)") };
  return this.transitions && this.transitions.enabled && (r.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), r;
} }, methods: { onMove: function(t) {
  this.$emit("move", t), this.moving = !0;
}, onMoveEnd: function() {
  this.$emit("move-end"), this.moving = !1;
}, onResize: function(t) {
  this.$emit("resize", t), this.resizing = !0;
}, onResizeEnd: function() {
  this.$emit("resize-end"), this.resizing = !1;
}, aspectRatios: function() {
  return { minimum: 1, maximum: 1 };
} } }, void 0, !1), Tn = ["transitions"], Q = L("vue-advanced-cropper"), Dn = { name: "Cropper", components: { BackgroundWrapper: jt }, props: { src: { type: String, default: null }, stencilComponent: { type: [Object, String], default: function() {
  return oi;
} }, backgroundWrapperComponent: { type: [Object, String], default: function() {
  return jt;
} }, stencilProps: { type: Object, default: function() {
  return {};
} }, autoZoom: { type: Boolean, default: !1 }, imageClass: { type: String }, boundariesClass: { type: String }, backgroundClass: { type: String }, foregroundClass: { type: String }, minWidth: { type: [Number, String] }, minHeight: { type: [Number, String] }, maxWidth: { type: [Number, String] }, maxHeight: { type: [Number, String] }, debounce: { type: [Boolean, Number], default: 500 }, transitions: { type: Boolean, default: !0 }, checkOrientation: { type: Boolean, default: !0 }, canvas: { type: [Object, Boolean], default: !0 }, crossOrigin: { type: [Boolean, String], default: void 0 }, transitionTime: { type: Number, default: 300 }, imageRestriction: { type: String, default: "fit-area", validator: function(t) {
  return mn.indexOf(t) !== -1;
} }, roundResult: { type: Boolean, default: !0 }, defaultSize: { type: [Function, Object] }, defaultPosition: { type: [Function, Object], default: function(t) {
  var e = t.imageSize, i = t.visibleArea, n = t.coordinates, s = i || e;
  return { left: (i ? i.left : 0) + s.width / 2 - n.width / 2, top: (i ? i.top : 0) + s.height / 2 - n.height / 2 };
} }, defaultVisibleArea: { type: [Function, Object], default: function(t) {
  var e = t.getAreaRestrictions, i = t.coordinates, n = t.imageSize, s = A(t.boundaries);
  if (i) {
    var r = { height: Math.max(i.height, n.height), width: Math.max(i.width, n.width) }, l = It({ width: A(r) > s ? r.width : r.height * s, height: A(r) > s ? r.width / s : r.height }, et(e())), a = { left: i.left + i.width / 2 - l.width / 2, top: i.top + i.height / 2 - l.height / 2, width: l.width, height: l.height }, o = Ae(i, U(w({ left: 0, top: 0 }, n))), c = {};
    return !o.left && !o.right && a.width <= n.width && (c.left = 0, c.right = n.width), !o.top && !o.bottom && a.height <= n.height && (c.top = 0, c.bottom = n.height), O(a, c);
  }
  var d = A(n);
  return l = { height: d > s ? n.height : n.width / s, width: d > s ? n.height * s : n.width }, { left: n.width / 2 - l.width / 2, top: n.height / 2 - l.height / 2, width: l.width, height: l.height };
} }, defaultTransforms: { type: [Function, Object] }, defaultBoundaries: { type: [Function, String], validator: function(t) {
  return !(typeof t == "string" && t !== "fill" && t !== "fit");
} }, priority: { type: String, default: "coordinates" }, stencilSize: { type: [Object, Function] }, resizeImage: { type: [Boolean, Object], default: !0 }, moveImage: { type: [Boolean, Object], default: !0 }, autoZoomAlgorithm: { type: Function }, resizeAlgorithm: { type: Function, default: function(t) {
  var e = t.event, i = t.coordinates, n = t.aspectRatio, s = t.positionRestrictions, r = t.sizeRestrictions, l = w(w({}, i), { right: i.left + i.width, bottom: i.top + i.height }), a = e.params || {}, o = w({}, e.directions), c = a.allowedDirections || { left: !0, right: !0, bottom: !0, top: !0 };
  r.widthFrozen && (o.left = 0, o.right = 0), r.heightFrozen && (o.top = 0, o.bottom = 0), V.forEach(function(y) {
    c[y] || (o[y] = 0);
  });
  var d = H(l, o = Dt({ coordinates: l, directions: o, sizeRestrictions: r, positionRestrictions: s })).width, u = H(l, o).height, p = a.preserveRatio ? A(l) : Je(d / u, n);
  if (p) {
    var f = a.respectDirection;
    if (f || (f = l.width >= l.height || p === 1 ? "width" : "height"), f === "width") {
      var h = d / p - l.height;
      if (c.top && c.bottom) {
        var m = o.top, g = o.bottom;
        o.bottom = Ie(h, g, m), o.top = Ie(h, m, g);
      } else c.bottom ? o.bottom = h : c.top ? o.top = h : c.right ? o.right = 0 : c.left && (o.left = 0);
    } else if (f === "height") {
      var v = l.width - u * p;
      if (c.left && c.right) {
        var x = o.left, $ = o.right;
        o.left = -Ie(v, x, $), o.right = -Ie(v, $, x);
      } else c.left ? o.left = -v : c.right ? o.right = -v : c.top ? o.top = 0 : c.bottom && (o.bottom = 0);
    }
    o = Dt({ directions: o, coordinates: l, sizeRestrictions: r, positionRestrictions: s, preserveRatio: !0, compensate: a.compensate });
  }
  return d = H(l, o).width, u = H(l, o).height, (p = a.preserveRatio ? A(l) : Je(d / u, n)) && Math.abs(p - d / u) > 1e-3 && V.forEach(function(y) {
    c[y] || (o[y] = 0);
  }), ut({ event: new mt({ left: -o.left, top: -o.top }), coordinates: { width: i.width + o.right + o.left, height: i.height + o.top + o.bottom, left: i.left, top: i.top }, positionRestrictions: s });
} }, moveAlgorithm: { type: Function, default: ut }, initStretcher: { type: Function, default: function(t) {
  var e = t.stretcher, i = t.imageSize, n = A(i);
  e.style.width = "".concat(i.width, "px"), e.style.height = "".concat(e.clientWidth / n, "px"), e.style.width = "".concat(e.clientWidth, "px");
} }, fitCoordinates: { type: Function, default: function(t) {
  var e = t.visibleArea, i = t.coordinates, n = t.aspectRatio, s = t.sizeRestrictions, r = t.positionRestrictions, l = w(w({}, i), J({ width: i.width, height: i.height, aspectRatio: n, sizeRestrictions: { maxWidth: e.width, maxHeight: e.height, minHeight: Math.min(e.height, s.minHeight), minWidth: Math.min(e.width, s.minWidth) } }));
  return l = O(l = D(l, me(I(i), I(l))), Fe(U(e), r));
} }, fitVisibleArea: { type: Function, default: function(t) {
  var e = t.visibleArea, i = t.boundaries, n = t.getAreaRestrictions, s = t.coordinates, r = w({}, e);
  r.height = r.width / A(i), r.top += (e.height - r.height) / 2, (s.height - r.height > 0 || s.width - r.width > 0) && (r = B(r, Math.max(s.height / r.height, s.width / r.width)));
  var l = je(ge(s, U(r = B(r, Be(r, n({ visibleArea: r, type: "resize" }))))));
  return r.width < s.width && (l.left = 0), r.height < s.height && (l.top = 0), r = O(r = D(r, l), n({ visibleArea: r, type: "move" }));
} }, areaRestrictionsAlgorithm: { type: Function, default: function(t) {
  var e = t.visibleArea, i = t.boundaries, n = t.imageSize, s = t.imageRestriction, r = t.type, l = {};
  return s === "fill-area" ? l = { left: 0, top: 0, right: n.width, bottom: n.height } : s === "fit-area" && (A(i) > A(n) ? (l = { top: 0, bottom: n.height }, e && r === "move" && (e.width > n.width ? (l.left = -(e.width - n.width) / 2, l.right = n.width - l.left) : (l.left = 0, l.right = n.width))) : (l = { left: 0, right: n.width }, e && r === "move" && (e.height > n.height ? (l.top = -(e.height - n.height) / 2, l.bottom = n.height - l.top) : (l.top = 0, l.bottom = n.height)))), l;
} }, sizeRestrictionsAlgorithm: { type: Function, default: function(t) {
  return { minWidth: t.minWidth, minHeight: t.minHeight, maxWidth: t.maxWidth, maxHeight: t.maxHeight };
} }, positionRestrictionsAlgorithm: { type: Function, default: function(t) {
  var e = t.imageSize, i = {};
  return t.imageRestriction !== "none" && (i = { left: 0, top: 0, right: e.width, bottom: e.height }), i;
} } }, data: function() {
  return { transitionsActive: !1, imageLoaded: !1, imageAttributes: { width: null, height: null, crossOrigin: !1, src: null }, defaultImageTransforms: { rotate: 0, flip: { horizontal: !1, vertical: !1 } }, appliedImageTransforms: { rotate: 0, flip: { horizontal: !1, vertical: !1 } }, boundaries: { width: 0, height: 0 }, visibleArea: null, coordinates: S({}, Pt) };
}, computed: { image: function() {
  return { src: this.imageAttributes.src, width: this.imageAttributes.width, height: this.imageAttributes.height, transforms: this.imageTransforms };
}, imageTransforms: function() {
  return { rotate: this.appliedImageTransforms.rotate, flip: { horizontal: this.appliedImageTransforms.flip.horizontal, vertical: this.appliedImageTransforms.flip.vertical }, translateX: this.visibleArea ? this.visibleArea.left / this.coefficient : 0, translateY: this.visibleArea ? this.visibleArea.top / this.coefficient : 0, scaleX: 1 / this.coefficient, scaleY: 1 / this.coefficient };
}, imageSize: function() {
  var t = function(e) {
    return e * Math.PI / 180;
  }(this.imageTransforms.rotate);
  return { width: Math.abs(this.imageAttributes.width * Math.cos(t)) + Math.abs(this.imageAttributes.height * Math.sin(t)), height: Math.abs(this.imageAttributes.width * Math.sin(t)) + Math.abs(this.imageAttributes.height * Math.cos(t)) };
}, initialized: function() {
  return !!(this.visibleArea && this.imageLoaded);
}, settings: function() {
  var t = ct(this.resizeImage, { touch: !0, wheel: { ratio: 0.1 }, adjustStencil: !0 }, { touch: !1, wheel: !1, adjustStencil: !1 });
  return { moveImage: ct(this.moveImage, { touch: !0, mouse: !0 }, { touch: !1, mouse: !1 }), resizeImage: t };
}, coefficient: function() {
  return this.visibleArea ? this.visibleArea.width / this.boundaries.width : 0;
}, areaRestrictions: function() {
  return this.imageLoaded ? this.areaRestrictionsAlgorithm({ imageSize: this.imageSize, imageRestriction: this.imageRestriction, boundaries: this.boundaries }) : {};
}, transitionsOptions: function() {
  return { enabled: this.transitionsActive, timingFunction: "ease-in-out", time: 350 };
}, sizeRestrictions: function() {
  if (this.boundaries.width && this.boundaries.height && this.imageSize.width && this.imageSize.height) {
    var t = this.sizeRestrictionsAlgorithm({ imageSize: this.imageSize, minWidth: E(this.minWidth) ? 0 : Pe(this.minWidth), minHeight: E(this.minHeight) ? 0 : Pe(this.minHeight), maxWidth: E(this.maxWidth) ? 1 / 0 : Pe(this.maxWidth), maxHeight: E(this.maxHeight) ? 1 / 0 : Pe(this.maxHeight) });
    if (t = function(n) {
      var s = n.areaRestrictions, r = n.sizeRestrictions, l = n.boundaries, a = n.positionRestrictions, o = w(w({}, r), { minWidth: r.minWidth !== void 0 ? r.minWidth : 0, minHeight: r.minHeight !== void 0 ? r.minHeight : 0, maxWidth: r.maxWidth !== void 0 ? r.maxWidth : 1 / 0, maxHeight: r.maxHeight !== void 0 ? r.maxHeight : 1 / 0 });
      a.left !== void 0 && a.right !== void 0 && (o.maxWidth = Math.min(o.maxWidth, a.right - a.left)), a.bottom !== void 0 && a.top !== void 0 && (o.maxHeight = Math.min(o.maxHeight, a.bottom - a.top));
      var c = et(s), d = It(l, c);
      return c.width < 1 / 0 && (!o.maxWidth || o.maxWidth > d.width) && (o.maxWidth = Math.min(o.maxWidth, d.width)), c.height < 1 / 0 && (!o.maxHeight || o.maxHeight > d.height) && (o.maxHeight = Math.min(o.maxHeight, d.height)), o.minWidth > o.maxWidth && (o.minWidth = o.maxWidth, o.widthFrozen = !0), o.minHeight > o.maxHeight && (o.minHeight = o.maxHeight, o.heightFrozen = !0), o;
    }({ sizeRestrictions: t, areaRestrictions: this.getAreaRestrictions({ visibleArea: this.visibleArea, type: "resize" }), imageSize: this.imageSize, boundaries: this.boundaries, positionRestrictions: this.positionRestrictions, imageRestriction: this.imageRestriction, visibleArea: this.visibleArea, stencilSize: this.getStencilSize() }), this.visibleArea && this.stencilSize) {
      var e = this.getStencilSize(), i = et(this.getAreaRestrictions({ visibleArea: this.visibleArea, type: "resize" }));
      t.maxWidth = Math.min(t.maxWidth, i.width * e.width / this.boundaries.width), t.maxHeight = Math.min(t.maxHeight, i.height * e.height / this.boundaries.height), t.maxWidth < t.minWidth && (t.minWidth = t.maxWidth), t.maxHeight < t.minHeight && (t.minHeight = t.maxHeight);
    }
    return t;
  }
  return { minWidth: 0, minHeight: 0, maxWidth: 0, maxHeight: 0 };
}, positionRestrictions: function() {
  return this.positionRestrictionsAlgorithm({ imageSize: this.imageSize, imageRestriction: this.imageRestriction });
}, classes: function() {
  return { cropper: Q(), image: P(Q("image"), this.imageClass), stencil: Q("stencil"), boundaries: P(Q("boundaries"), this.boundariesClass), stretcher: P(Q("stretcher")), background: P(Q("background"), this.backgroundClass), foreground: P(Q("foreground"), this.foregroundClass), imageWrapper: P(Q("image-wrapper")), cropperWrapper: P(Q("cropper-wrapper")) };
}, stencilCoordinates: function() {
  if (this.initialized) {
    var t = this.coordinates, e = t.width, i = t.height, n = t.left, s = t.top;
    return { width: e / this.coefficient, height: i / this.coefficient, left: (n - this.visibleArea.left) / this.coefficient, top: (s - this.visibleArea.top) / this.coefficient };
  }
  return this.defaultCoordinates();
}, boundariesStyle: function() {
  var t = { width: this.boundaries.width ? "".concat(Math.round(this.boundaries.width), "px") : "auto", height: this.boundaries.height ? "".concat(Math.round(this.boundaries.height), "px") : "auto", transition: "opacity ".concat(this.transitionTime, "ms"), pointerEvents: this.imageLoaded ? "all" : "none" };
  return this.imageLoaded || (t.opacity = "0"), t;
}, imageStyle: function() {
  var t = this.imageAttributes.width > this.imageAttributes.height ? { width: Math.min(1024, this.imageAttributes.width), height: Math.min(1024, this.imageAttributes.width) / (this.imageAttributes.width / this.imageAttributes.height) } : { height: Math.min(1024, this.imageAttributes.height), width: Math.min(1024, this.imageAttributes.height) * (this.imageAttributes.width / this.imageAttributes.height) }, e = { left: (t.width - this.imageSize.width) / (2 * this.coefficient), top: (t.height - this.imageSize.height) / (2 * this.coefficient) }, i = { left: (1 - 1 / this.coefficient) * t.width / 2, top: (1 - 1 / this.coefficient) * t.height / 2 }, n = S(S({}, this.imageTransforms), {}, { scaleX: this.imageTransforms.scaleX * (this.imageAttributes.width / t.width), scaleY: this.imageTransforms.scaleY * (this.imageAttributes.height / t.height) }), s = { width: "".concat(t.width, "px"), height: "".concat(t.height, "px"), left: "0px", top: "0px", transform: "translate(".concat(-e.left - i.left - this.imageTransforms.translateX, "px, ").concat(-e.top - i.top - this.imageTransforms.translateY, "px)") + vt(n) };
  return this.transitionsOptions.enabled && (s.transition = "".concat(this.transitionsOptions.time, "ms ").concat(this.transitionsOptions.timingFunction)), s;
} }, watch: { src: function() {
  this.onChangeImage();
}, stencilComponent: function() {
  var t = this;
  this.$nextTick(function() {
    t.resetCoordinates(), t.runAutoZoom("setCoordinates"), t.onChange();
  });
}, minWidth: function() {
  this.onPropsChange();
}, maxWidth: function() {
  this.onPropsChange();
}, minHeight: function() {
  this.onPropsChange();
}, maxHeight: function() {
  this.onPropsChange();
}, imageRestriction: function() {
  this.reset();
}, stencilProps: function(t, e) {
  ["aspectRatio", "minAspectRatio", "maxAspectRatio"].find(function(i) {
    return t[i] !== e[i];
  }) && this.$nextTick(this.onPropsChange);
} }, created: function() {
  this.debouncedUpdate = lt(this.update, this.debounce), this.debouncedDisableTransitions = lt(this.disableTransitions, this.transitionsOptions.time), this.awaiting = !1;
}, mounted: function() {
  this.$refs.image.addEventListener("load", this.onSuccessLoadImage), this.$refs.image.addEventListener("error", this.onFailLoadImage), this.onChangeImage(), window.addEventListener("resize", this.refresh), window.addEventListener("orientationchange", this.refresh);
}, destroyed: function() {
  window.removeEventListener("resize", this.refresh), window.removeEventListener("orientationchange", this.refresh), this.imageAttributes.revoke && this.imageAttributes.src && URL.revokeObjectURL(this.imageAttributes.src), this.debouncedUpdate.clear(), this.debouncedDisableTransitions.clear();
}, methods: { getResult: function() {
  var t = this.initialized ? this.prepareResult(S({}, this.coordinates)) : this.defaultCoordinates(), e = { rotate: this.imageTransforms.rotate % 360, flip: S({}, this.imageTransforms.flip) };
  if (this.src && this.imageLoaded) {
    var i = this;
    return { image: this.image, coordinates: t, visibleArea: this.visibleArea ? S({}, this.visibleArea) : null, imageTransforms: e, get canvas() {
      return i.canvas ? i.getCanvas() : void 0;
    } };
  }
  return { image: this.image, coordinates: t, visibleArea: this.visibleArea ? S({}, this.visibleArea) : null, canvas: void 0, imageTransforms: e };
}, zoom: function(t, e) {
  var i = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).transitions, n = i === void 0 || i;
  this.onManipulateImage(new xe({}, { factor: 1 / t, center: e }), { normalize: !1, transitions: n });
}, move: function(t, e) {
  var i = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).transitions, n = i === void 0 || i;
  this.onManipulateImage(new xe({ left: t || 0, top: e || 0 }), { normalize: !1, transitions: n });
}, setCoordinates: function(t) {
  var e = this, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = i.autoZoom, s = n === void 0 || n, r = i.transitions, l = r === void 0 || r;
  this.$nextTick(function() {
    e.imageLoaded ? (e.transitionsActive || (l && e.enableTransitions(), e.coordinates = e.applyTransform(t), s && e.runAutoZoom("setCoordinates"), l && e.debouncedDisableTransitions()), e.onChange()) : e.delayedTransforms = t;
  });
}, refresh: function() {
  var t = this, e = this.$refs.image;
  if (this.src && e) return this.initialized ? this.updateVisibleArea().then(function() {
    t.onChange();
  }) : this.resetVisibleArea().then(function() {
    t.onChange();
  });
}, reset: function() {
  var t = this;
  return this.resetVisibleArea().then(function() {
    t.onChange(!1);
  });
}, awaitRender: function(t) {
  var e = this;
  this.awaiting || (this.awaiting = !0, this.$nextTick(function() {
    t(), e.awaiting = !1;
  }));
}, prepareResult: function(t) {
  return this.roundResult ? function(e) {
    var i = e.coordinates, n = e.sizeRestrictions, s = e.positionRestrictions, r = { width: Math.round(i.width), height: Math.round(i.height), left: Math.round(i.left), top: Math.round(i.top) };
    return r.width > n.maxWidth ? r.width = Math.floor(i.width) : r.width < n.minWidth && (r.width = Math.ceil(i.width)), r.height > n.maxHeight ? r.height = Math.floor(i.height) : r.height < n.minHeight && (r.height = Math.ceil(i.height)), O(r, s);
  }(S(S({}, this.getPublicProperties()), {}, { positionRestrictions: Ee(this.positionRestrictions, this.visibleArea), coordinates: t })) : t;
}, processAutoZoom: function(t, e, i, n) {
  var s = this.autoZoomAlgorithm;
  s || (s = this.stencilSize ? vn : this.autoZoom ? bn : _n);
  var r = s({ event: { type: t, params: n }, visibleArea: e, coordinates: i, boundaries: this.boundaries, aspectRatio: this.getAspectRatio(), positionRestrictions: this.positionRestrictions, getAreaRestrictions: this.getAreaRestrictions, sizeRestrictions: this.sizeRestrictions, stencilSize: this.getStencilSize() });
  return S(S({}, r), {}, { changed: !Et(r.visibleArea, e) || !Et(r.coordinates, i) });
}, runAutoZoom: function(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = e.transitions, n = i !== void 0 && i, s = function(c, d) {
    if (c == null) return {};
    var u, p, f = function(m, g) {
      if (m == null) return {};
      var v = {};
      for (var x in m) if ({}.hasOwnProperty.call(m, x)) {
        if (g.indexOf(x) >= 0) continue;
        v[x] = m[x];
      }
      return v;
    }(c, d);
    if (Object.getOwnPropertySymbols) {
      var h = Object.getOwnPropertySymbols(c);
      for (p = 0; p < h.length; p++) u = h[p], d.indexOf(u) >= 0 || {}.propertyIsEnumerable.call(c, u) && (f[u] = c[u]);
    }
    return f;
  }(e, Tn), r = this.processAutoZoom(t, this.visibleArea, this.coordinates, s), l = r.visibleArea, a = r.coordinates, o = r.changed;
  n && o && this.enableTransitions(), this.visibleArea = l, this.coordinates = a, n && o && this.debouncedDisableTransitions();
}, normalizeEvent: function(t) {
  return function(e) {
    var i = e.event, n = e.visibleArea, s = e.coefficient;
    if (i.type === "manipulateImage") return w(w({}, i), { move: { left: i.move && i.move.left ? s * i.move.left : 0, top: i.move && i.move.top ? s * i.move.top : 0 }, scale: { factor: i.scale && i.scale.factor ? i.scale.factor : 1, center: i.scale && i.scale.center ? { left: i.scale.center.left * s + n.left, top: i.scale.center.top * s + n.top } : null } });
    if (i.type === "resize") {
      var r = w(w({}, i), { directions: w({}, i.directions) });
      return V.forEach(function(a) {
        r.directions[a] *= s;
      }), r;
    }
    if (i.type === "move") {
      var l = w(w({}, i), { directions: w({}, i.directions) });
      return fn.forEach(function(a) {
        l.directions[a] *= s;
      }), l;
    }
    return i;
  }(S(S({}, this.getPublicProperties()), {}, { event: t }));
}, getCanvas: function() {
  if (this.$refs.canvas) {
    var t = this.$refs.canvas, e = this.$refs.image, i = this.imageTransforms.rotate !== 0 || this.imageTransforms.flip.horizontal || this.imageTransforms.flip.vertical ? function(a, o, c) {
      var d = c.rotate, u = c.flip, p = { width: o.naturalWidth, height: o.naturalHeight }, f = gt(p, d), h = a.getContext("2d");
      a.height = f.height, a.width = f.width, h.save();
      var m = re(I(w({ left: 0, top: 0 }, p)), d);
      return h.translate(-(m.left - f.width / 2), -(m.top - f.height / 2)), h.rotate(d * Math.PI / 180), h.translate(u.horizontal ? p.width : 0, u.vertical ? p.height : 0), h.scale(u.horizontal ? -1 : 1, u.vertical ? -1 : 1), h.drawImage(o, 0, 0, p.width, p.height), h.restore(), a;
    }(this.$refs.sourceCanvas, e, this.imageTransforms) : e, n = S({ minWidth: 0, minHeight: 0, maxWidth: 1 / 0, maxHeight: 1 / 0, maxArea: this.maxCanvasSize, imageSmoothingEnabled: !0, imageSmoothingQuality: "high", fillColor: "transparent" }, this.canvas), s = function(a) {
      return a.find(function(o) {
        return c = o, !Number.isNaN(parseFloat(c)) && isFinite(c);
        var c;
      });
    }, r = J({ sizeRestrictions: { minWidth: s([n.width, n.minWidth]) || 0, minHeight: s([n.height, n.minHeight]) || 0, maxWidth: s([n.width, n.maxWidth]) || 1 / 0, maxHeight: s([n.height, n.maxHeight]) || 1 / 0 }, width: this.coordinates.width, height: this.coordinates.height, aspectRatio: { minimum: this.coordinates.width / this.coordinates.height, maximum: this.coordinates.width / this.coordinates.height } });
    if (n.maxArea && r.width * r.height > n.maxArea) {
      var l = Math.sqrt(n.maxArea / (r.width * r.height));
      r = { width: Math.round(l * r.width), height: Math.round(l * r.height) };
    }
    return function(a, o, c, d, u) {
      a.width = d ? d.width : c.width, a.height = d ? d.height : c.height;
      var p = a.getContext("2d");
      p.clearRect(0, 0, a.width, a.height), u && (u.imageSmoothingEnabled && (p.imageSmoothingEnabled = u.imageSmoothingEnabled), u.imageSmoothingQuality && (p.imageSmoothingQuality = u.imageSmoothingQuality), u.fillColor && (p.fillStyle = u.fillColor, p.fillRect(0, 0, a.width, a.height), p.save()));
      var f = c.left < 0 ? -c.left : 0, h = c.top < 0 ? -c.top : 0;
      p.drawImage(o, c.left + f, c.top + h, c.width, c.height, f * (a.width / c.width), h * (a.height / c.height), a.width, a.height);
    }(t, i, this.coordinates, r, n), t;
  }
}, update: function() {
  this.$emit("change", this.getResult());
}, applyTransform: function(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], i = this.visibleArea && e ? function(s, r) {
    return w(w({}, s), { minWidth: Math.min(r.width, s.minWidth), minHeight: Math.min(r.height, s.minHeight), maxWidth: Math.min(r.width, s.maxWidth), maxHeight: Math.min(r.height, s.maxHeight) });
  }(this.sizeRestrictions, this.visibleArea) : this.sizeRestrictions, n = this.visibleArea && e ? Ee(this.positionRestrictions, this.visibleArea) : this.positionRestrictions;
  return gn({ transform: t, coordinates: this.coordinates, imageSize: this.imageSize, sizeRestrictions: i, positionRestrictions: n, aspectRatio: this.getAspectRatio(), visibleArea: this.visibleArea });
}, resetCoordinates: function() {
  var t = this;
  if (this.$refs.image) {
    this.$refs.cropper, this.$refs.image;
    var e = this.defaultSize;
    e || (e = this.stencilSize ? wn : yn);
    var i = this.sizeRestrictions;
    i.minWidth, i.minHeight, i.maxWidth, i.maxHeight;
    var n = [fe(e) ? e({ boundaries: this.boundaries, imageSize: this.imageSize, aspectRatio: this.getAspectRatio(), sizeRestrictions: this.sizeRestrictions, stencilSize: this.getStencilSize(), visibleArea: this.visibleArea }) : e, function(s) {
      var r = s.coordinates;
      return S({}, fe(t.defaultPosition) ? t.defaultPosition({ coordinates: r, imageSize: t.imageSize, visibleArea: t.visibleArea }) : t.defaultPosition);
    }];
    this.delayedTransforms && n.push.apply(n, he(Array.isArray(this.delayedTransforms) ? this.delayedTransforms : [this.delayedTransforms])), this.coordinates = this.applyTransform(n, !0), this.delayedTransforms = null;
  }
}, clearImage: function() {
  var t = this;
  this.imageLoaded = !1, setTimeout(function() {
    var e = t.$refs.stretcher;
    e && (e.style.height = "auto", e.style.width = "auto"), t.coordinates = t.defaultCoordinates(), t.boundaries = { width: 0, height: 0 };
  }, this.transitionTime);
}, enableTransitions: function() {
  this.transitions && (this.transitionsActive = !0);
}, disableTransitions: function() {
  this.transitionsActive = !1;
}, updateBoundaries: function() {
  var t = this, e = this.$refs.stretcher, i = this.$refs.cropper;
  return this.initStretcher({ cropper: i, stretcher: e, imageSize: this.imageSize }), this.$nextTick().then(function() {
    var n = { cropper: i, imageSize: t.imageSize };
    if (fe(t.defaultBoundaries) ? t.boundaries = t.defaultBoundaries(n) : t.defaultBoundaries === "fit" ? t.boundaries = function(s) {
      var r = s.cropper, l = s.imageSize, a = r.clientHeight, o = r.clientWidth, c = a, d = l.width * a / l.height;
      return d > o && (d = o, c = l.height * o / l.width), { width: d, height: c };
    }(n) : t.boundaries = function(s) {
      var r = s.cropper;
      return { width: r.clientWidth, height: r.clientHeight };
    }(n), !t.boundaries.width || !t.boundaries.height) throw new Error("It's impossible to fit the cropper in the current container");
  });
}, resetVisibleArea: function() {
  var t = this;
  return this.appliedImageTransforms = S(S({}, this.defaultImageTransforms), {}, { flip: S({}, this.defaultImageTransforms.flip) }), this.updateBoundaries().then(function() {
    var e, i, n, s, r, l;
    t.priority !== "visible-area" && (t.visibleArea = null, t.resetCoordinates()), t.visibleArea = fe(t.defaultVisibleArea) ? t.defaultVisibleArea({ imageSize: t.imageSize, boundaries: t.boundaries, coordinates: t.priority !== "visible-area" ? t.coordinates : null, getAreaRestrictions: t.getAreaRestrictions, stencilSize: t.getStencilSize() }) : t.defaultVisibleArea, t.visibleArea = (e = { visibleArea: t.visibleArea, boundaries: t.boundaries, getAreaRestrictions: t.getAreaRestrictions }, i = e.visibleArea, n = e.boundaries, s = e.getAreaRestrictions, r = w({}, i), l = A(n), r.width / r.height !== l && (r.height = r.width / l), O(r, s({ visibleArea: r, type: "move" }))), t.priority === "visible-area" ? t.resetCoordinates() : t.coordinates = t.fitCoordinates({ visibleArea: t.visibleArea, coordinates: t.coordinates, aspectRatio: t.getAspectRatio(), positionRestrictions: t.positionRestrictions, sizeRestrictions: t.sizeRestrictions }), t.runAutoZoom("resetVisibleArea");
  }).catch(function() {
    t.visibleArea = null;
  });
}, updateVisibleArea: function() {
  var t = this;
  return this.updateBoundaries().then(function() {
    t.visibleArea = t.fitVisibleArea({ imageSize: t.imageSize, boundaries: t.boundaries, visibleArea: t.visibleArea, coordinates: t.coordinates, getAreaRestrictions: t.getAreaRestrictions }), t.coordinates = t.fitCoordinates({ visibleArea: t.visibleArea, coordinates: t.coordinates, aspectRatio: t.getAspectRatio(), positionRestrictions: t.positionRestrictions, sizeRestrictions: t.sizeRestrictions }), t.runAutoZoom("updateVisibleArea");
  }).catch(function() {
    t.visibleArea = null;
  });
}, onChange: function() {
  var t = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0];
  this.$listeners && this.$listeners.change && (t && this.debounce ? this.debouncedUpdate() : this.update());
}, onChangeImage: function() {
  var t, e = this;
  if (this.imageLoaded = !1, this.delayedTransforms = null, this.src) {
    if (function(s) {
      if (zt(s)) return !1;
      var r = window.location, l = /(\w+:)?(?:\/\/)([\w.-]+)?(?::(\d+))?\/?/.exec(s) || [], a = { protocol: l[1] || "", host: l[2] || "", port: l[3] || "" }, o = function(c) {
        return c.port || ((c.protocol || r.protocol) === "http" ? 80 : 433);
      };
      return !(!a.protocol && !a.host && !a.port || a.protocol && a.protocol == r.protocol && a.host && a.host == r.host && a.host && o(a) == o(r));
    }(this.src)) {
      var i = E(this.crossOrigin) ? this.canvas : this.crossOrigin;
      i === !0 && (i = "anonymous"), this.imageAttributes.crossOrigin = i;
    }
    if (this.checkOrientation) {
      var n = (t = this.src, new Promise(function(s) {
        kn(t).then(function(r) {
          var l = Pn(r);
          s(r ? { source: t, arrayBuffer: r, orientation: l } : { source: t, arrayBuffer: null, orientation: null });
        }).catch(function(r) {
          console.warn(r), s({ source: t, arrayBuffer: null, orientation: null });
        });
      }));
      setTimeout(function() {
        n.then(e.onParseImage);
      }, this.transitionTime);
    } else setTimeout(function() {
      e.onParseImage({ source: e.src });
    }, this.transitionTime);
  } else this.clearImage();
}, onFailLoadImage: function() {
  this.imageAttributes.src && (this.clearImage(), this.$emit("error"));
}, onSuccessLoadImage: function() {
  var t = this, e = this.$refs.image;
  e && !this.imageLoaded && (this.imageAttributes.height = e.naturalHeight, this.imageAttributes.width = e.naturalWidth, this.imageLoaded = !0, this.resetVisibleArea().then(function() {
    t.$emit("ready"), t.onChange(!1);
  }));
}, onParseImage: function(t) {
  var e = this, i = t.source, n = t.arrayBuffer, s = t.orientation;
  this.imageAttributes.revoke && this.imageAttributes.src && URL.revokeObjectURL(this.imageAttributes.src), this.imageAttributes.revoke = !1, n && s && s > 1 ? Qt(i) || !zt(i) ? (this.imageAttributes.src = URL.createObjectURL(new Blob([n])), this.imageAttributes.revoke = !0) : this.imageAttributes.src = function(r) {
    for (var l = [], a = new Uint8Array(r); a.length > 0; ) {
      var o = a.subarray(0, 8192);
      l.push(String.fromCharCode.apply(null, Array.from ? Array.from(o) : o.slice())), a = a.subarray(8192);
    }
    return "data:image/jpeg;base64,".concat(btoa(l.join("")));
  }(n) : this.imageAttributes.src = i, fe(this.defaultTransforms) ? this.appliedImageTransforms = it(this.defaultTransforms()) : De(this.defaultTransforms) ? this.appliedImageTransforms = it(this.defaultTransforms) : this.appliedImageTransforms = function(r) {
    var l = it({});
    if (r) switch (r) {
      case 2:
        l.flip.horizontal = !0;
        break;
      case 3:
        l.rotate = -180;
        break;
      case 4:
        l.flip.vertical = !0;
        break;
      case 5:
        l.rotate = 90, l.flip.vertical = !0;
        break;
      case 6:
        l.rotate = 90;
        break;
      case 7:
        l.rotate = 90, l.flip.horizontal = !0;
        break;
      case 8:
        l.rotate = -90;
    }
    return l;
  }(s), this.defaultImageTransforms = S(S({}, this.appliedImageTransforms), {}, { flip: S({}, this.appliedImageTransforms.flip) }), this.$nextTick(function() {
    var r = e.$refs.image;
    r && r.complete && (function(l) {
      return !!l.naturalWidth;
    }(r) ? e.onSuccessLoadImage() : e.onFailLoadImage());
  });
}, onResizeEnd: function() {
  this.runAutoZoom("resize", { transitions: !0 });
}, onMoveEnd: function() {
  this.runAutoZoom("move", { transitions: !0 });
}, onMove: function(t) {
  var e = this;
  this.transitionsOptions.enabled || this.awaitRender(function() {
    e.coordinates = e.moveAlgorithm(S(S({}, e.getPublicProperties()), {}, { positionRestrictions: Ee(e.positionRestrictions, e.visibleArea), coordinates: e.coordinates, event: e.normalizeEvent(t) })), e.onChange();
  });
}, onResize: function(t) {
  var e = this;
  this.transitionsOptions.enabled || this.stencilSize && !this.autoZoom || this.awaitRender(function() {
    var i = e.sizeRestrictions, n = Math.min(e.coordinates.width, e.coordinates.height, 20 * e.coefficient);
    e.coordinates = e.resizeAlgorithm(S(S({}, e.getPublicProperties()), {}, { positionRestrictions: Ee(e.positionRestrictions, e.visibleArea), sizeRestrictions: { maxWidth: Math.min(i.maxWidth, e.visibleArea.width), maxHeight: Math.min(i.maxHeight, e.visibleArea.height), minWidth: Math.max(i.minWidth, n), minHeight: Math.max(i.minHeight, n) }, event: e.normalizeEvent(t) })), e.onChange(), e.ticking = !1;
  });
}, onManipulateImage: function(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!this.transitionsOptions.enabled) {
    var i = e.transitions, n = i !== void 0 && i, s = e.normalize, r = s === void 0 || s;
    n && this.enableTransitions();
    var l = function(c) {
      var d = c.event, u = c.coordinates, p = c.visibleArea, f = c.sizeRestrictions, h = c.getAreaRestrictions, m = c.positionRestrictions, g = c.adjustStencil, v = d.scale, x = d.move, $ = w({}, p), y = w({}, u), C = 1, M = 1, pe = v.factor && Math.abs(v.factor - 1) > 1e-3;
      $ = D($, { left: x.left || 0, top: x.top || 0 });
      var j = { stencil: { minimum: Math.max(f.minWidth ? f.minWidth / y.width : 0, f.minHeight ? f.minHeight / y.height : 0), maximum: Math.min(f.maxWidth ? f.maxWidth / y.width : 1 / 0, f.maxHeight ? f.maxHeight / y.height : 1 / 0, be(y, m)) }, area: { maximum: be($, h({ visibleArea: $, type: "resize" })) } };
      v.factor && pe && (v.factor < 1 ? (M = Math.max(v.factor, j.stencil.minimum)) > 1 && (M = 1) : v.factor > 1 && (M = Math.min(v.factor, Math.min(j.area.maximum, j.stencil.maximum))) < 1 && (M = 1)), M && ($ = B($, M, v.center));
      var X = u.left - p.left, G = p.width + p.left - (u.width + u.left), Z = u.top - p.top, ie = p.height + p.top - (u.height + u.top);
      return $ = O($ = D($, ge($, { left: m.left !== void 0 ? m.left - X * M : void 0, top: m.top !== void 0 ? m.top - Z * M : void 0, bottom: m.bottom !== void 0 ? m.bottom + ie * M : void 0, right: m.right !== void 0 ? m.right + G * M : void 0 })), h({ visibleArea: $, type: "move" })), y.width = y.width * M, y.height = y.height * M, y.left = $.left + X * M, y.top = $.top + Z * M, y = O(y, Fe(U($), m)), v.factor && pe && g && (v.factor > 1 ? C = Math.min(j.area.maximum, v.factor) / M : v.factor < 1 && (C = Math.max(y.height / $.height, y.width / $.width, v.factor / M)), C !== 1 && ($ = D($ = O($ = B($, C, v.factor > 1 ? v.center : I(y)), h({ visibleArea: $, type: "move" })), je(ge(y, U($)))))), { coordinates: y, visibleArea: $ };
    }(S(S({}, this.getPublicProperties()), {}, { event: r ? this.normalizeEvent(t) : t, getAreaRestrictions: this.getAreaRestrictions, imageRestriction: this.imageRestriction, adjustStencil: !this.stencilSize && this.settings.resizeImage.adjustStencil })), a = l.visibleArea, o = l.coordinates;
    this.visibleArea = a, this.coordinates = o, this.runAutoZoom("manipulateImage"), this.onChange(), n && this.debouncedDisableTransitions();
  }
}, onPropsChange: function() {
  this.coordinates = this.applyTransform(this.coordinates, !0), this.onChange(!1);
}, getAreaRestrictions: function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = t.visibleArea, i = t.type, n = i === void 0 ? "move" : i;
  return this.areaRestrictionsAlgorithm({ boundaries: this.boundaries, imageSize: this.imageSize, imageRestriction: this.imageRestriction, visibleArea: e, type: n });
}, getAspectRatio: function(t) {
  var e, i, n = this.stencilProps, s = n.aspectRatio, r = n.minAspectRatio, l = n.maxAspectRatio;
  if (this.$refs.stencil && this.$refs.stencil.aspectRatios) {
    var a = this.$refs.stencil.aspectRatios();
    e = a.minimum, i = a.maximum;
  }
  if (E(e) && (e = E(s) ? r : s), E(i) && (i = E(s) ? l : s), !t && (E(e) || E(i))) {
    var o = this.getStencilSize(), c = o ? A(o) : null;
    E(e) && (e = kt(c) ? c : void 0), E(i) && (i = kt(c) ? c : void 0);
  }
  return { minimum: e, maximum: i };
}, getStencilSize: function() {
  if (this.stencilSize) return t = { currentStencilSize: { width: this.stencilCoordinates.width, height: this.stencilCoordinates.height }, stencilSize: this.stencilSize, boundaries: this.boundaries, coefficient: this.coefficient, coordinates: this.coordinates, aspectRatio: this.getAspectRatio(!0) }, e = t.boundaries, i = t.stencilSize, n = t.aspectRatio, Je(A(s = fe(i) ? i({ boundaries: e, aspectRatio: n }) : i), n) && (s = J({ sizeRestrictions: { maxWidth: e.width, maxHeight: e.height, minWidth: 0, minHeight: 0 }, width: s.width, height: s.height, aspectRatio: { minimum: n.minimum, maximum: n.maximum } })), (s.width > e.width || s.height > e.height) && (s = J({ sizeRestrictions: { maxWidth: e.width, maxHeight: e.height, minWidth: 0, minHeight: 0 }, width: s.width, height: s.height, aspectRatio: { minimum: A(s), maximum: A(s) } })), s;
  var t, e, i, n, s;
}, getPublicProperties: function() {
  return { coefficient: this.coefficient, visibleArea: this.visibleArea, coordinates: this.coordinates, boundaries: this.boundaries, sizeRestrictions: this.sizeRestrictions, positionRestrictions: this.positionRestrictions, aspectRatio: this.getAspectRatio(), imageRestriction: this.imageRestriction };
}, defaultCoordinates: function() {
  return S({}, Pt);
}, flip: function(t, e) {
  var i = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).transitions, n = i === void 0 || i;
  if (!this.transitionsActive) {
    n && this.enableTransitions();
    var s = S({}, this.imageTransforms.flip), r = function(o) {
      var c = o.flip, d = o.previousFlip, u = o.rotate, p = o.getAreaRestrictions, f = o.coordinates, h = o.visibleArea, m = o.imageSize, g = w({}, f), v = w({}, h), x = d.horizontal !== c.horizontal, $ = d.vertical !== c.vertical;
      if (x || $) {
        var y = re({ left: m.width / 2, top: m.height / 2 }, -u), C = re(I(g), -u), M = re({ left: x ? y.left - (C.left - y.left) : C.left, top: $ ? y.top - (C.top - y.top) : C.top }, u);
        g = D(g, me(M, I(g))), C = re(I(v), -u), v = O(v = D(v, me(M = re({ left: x ? y.left - (C.left - y.left) : C.left, top: $ ? y.top - (C.top - y.top) : C.top }, u), I(v))), p({ visibleArea: v, type: "move" }));
      }
      return { coordinates: g, visibleArea: v };
    }({ flip: { horizontal: t ? !s.horizontal : s.horizontal, vertical: e ? !s.vertical : s.vertical }, previousFlip: s, rotate: this.imageTransforms.rotate, visibleArea: this.visibleArea, coordinates: this.coordinates, imageSize: this.imageSize, positionRestrictions: this.positionRestrictions, sizeRestrictions: this.sizeRestrictions, getAreaRestrictions: this.getAreaRestrictions, aspectRatio: this.getAspectRatio() }), l = r.visibleArea, a = r.coordinates;
    t && (this.appliedImageTransforms.flip.horizontal = !this.appliedImageTransforms.flip.horizontal), e && (this.appliedImageTransforms.flip.vertical = !this.appliedImageTransforms.flip.vertical), this.visibleArea = l, this.coordinates = a, this.onChange(), n && this.debouncedDisableTransitions();
  }
}, rotate: function(t) {
  var e = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).transitions, i = e === void 0 || e;
  if (!this.transitionsActive) {
    i && this.enableTransitions();
    var n = S({}, this.imageSize);
    this.appliedImageTransforms.rotate += t;
    var s = function(o) {
      var c = o.aspectRatio, d = o.getAreaRestrictions, u = o.coordinates, p = o.visibleArea, f = o.sizeRestrictions, h = o.positionRestrictions, m = o.imageSize, g = o.previousImageSize, v = o.angle, x = w({}, u), $ = w({}, p), y = re(I(w({ left: 0, top: 0 }, g)), v);
      return (x = w(w({}, J({ sizeRestrictions: f, aspectRatio: c, width: x.width, height: x.height })), re(I(x), v))).left -= y.left - m.width / 2 + x.width / 2, x.top -= y.top - m.height / 2 + x.height / 2, $ = B($, Be($, d({ visibleArea: $, type: "resize" }))), { coordinates: x = O(x, h), visibleArea: $ = O($ = D($, me(I(x), I(u))), d({ visibleArea: $, type: "move" })) };
    }({ visibleArea: this.visibleArea, coordinates: this.coordinates, previousImageSize: n, imageSize: this.imageSize, angle: t, positionRestrictions: this.positionRestrictions, sizeRestrictions: this.sizeRestrictions, getAreaRestrictions: this.getAreaRestrictions, aspectRatio: this.getAspectRatio() }), r = s.visibleArea, l = s.coordinates, a = this.processAutoZoom("rotateImage", r, l);
    r = a.visibleArea, l = a.coordinates, this.visibleArea = r, this.coordinates = l, this.onChange(), i && this.debouncedDisableTransitions();
  }
} } }, ai = T({ render: function() {
  var t = this, e = t.$createElement, i = t._self._c || e;
  return i("div", { ref: "cropper", class: t.classes.cropper }, [i("div", { ref: "stretcher", class: t.classes.stretcher }), t._v(" "), i("div", { class: t.classes.boundaries, style: t.boundariesStyle }, [i(t.backgroundWrapperComponent, { tag: "component", class: t.classes.cropperWrapper, attrs: { "wheel-resize": t.settings.resizeImage.wheel, "touch-resize": t.settings.resizeImage.touch, "touch-move": t.settings.moveImage.touch, "mouse-move": t.settings.moveImage.mouse }, on: { move: t.onManipulateImage, resize: t.onManipulateImage } }, [i("div", { class: t.classes.background, style: t.boundariesStyle }), t._v(" "), i("div", { class: t.classes.imageWrapper }, [i("img", { ref: "image", class: t.classes.image, style: t.imageStyle, attrs: { crossorigin: t.imageAttributes.crossOrigin, src: t.imageAttributes.src }, on: { mousedown: function(n) {
    n.preventDefault();
  } } })]), t._v(" "), i("div", { class: t.classes.foreground, style: t.boundariesStyle }), t._v(" "), i(t.stencilComponent, t._b({ directives: [{ name: "show", rawName: "v-show", value: t.imageLoaded, expression: "imageLoaded" }], ref: "stencil", tag: "component", attrs: { image: t.image, coordinates: t.coordinates, "stencil-coordinates": t.stencilCoordinates, transitions: t.transitionsOptions }, on: { resize: t.onResize, "resize-end": t.onResizeEnd, move: t.onMove, "move-end": t.onMoveEnd } }, "component", t.stencilProps, !1)), t._v(" "), t.canvas ? i("canvas", { ref: "canvas", style: { display: "none" } }) : t._e(), t._v(" "), t.canvas ? i("canvas", { ref: "sourceCanvas", style: { display: "none" } }) : t._e()], 1)], 1)]);
}, staticRenderFns: [] }, void 0, Dn, void 0, !1);
ue.component("cropper", ai), ue.component("rectangle-stencil", oi), ue.component("circle-stencil", On), ue.component("simple-handler", Ve), ue.component("simple-line", Ue);
const Ln = b({
  components: {
    Cropper: ai
  },
  props: {
    image: {
      type: String,
      required: !0
    },
    minImageHeight: {
      type: Number,
      default: 0
    },
    minImageWidth: {
      type: Number,
      default: 0
    },
    maxImageHeight: {
      type: Number,
      required: !0
    },
    maxImageWidth: {
      type: Number,
      required: !0
    }
  },
  computed: {
    cropper() {
      return this.$refs.cropper;
    },
    aspectRatio() {
      return this.maxImageWidth / this.maxImageHeight;
    }
  },
  methods: {
    pixelsRestriction({
      imageSize: { width: t, height: e }
    }) {
      const i = Math.min(700, t, e * this.aspectRatio), n = Math.min(e, i / this.aspectRatio);
      return {
        minWidth: i,
        minHeight: n
      };
    },
    onAccept() {
      const t = this.cropper.getResult().canvas;
      if (!t) {
        console.warn("Could not retrieve Canvas");
        return;
      }
      t.toBlob((e) => {
        this.$emit("crop-accept", e);
      }, "image/webp");
    },
    onCancel() {
      this.$emit("crop-cancel");
    }
  }
});
var jn = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("div", { staticClass: "app-cropper" }, [i("cropper", { ref: "cropper", staticClass: "cropper", attrs: { canvas: {
    minHeight: e.minImageHeight,
    minWidth: e.minImageWidth,
    maxHeight: e.maxImageHeight,
    maxWidth: e.maxImageWidth
  }, "size-restrictions-algorithm": e.pixelsRestriction, src: e.image, "stencil-props": {
    aspectRatio: e.aspectRatio
  } } }), i("div", { staticClass: "buttons" }, [i("app-button", { attrs: { label: e.$t("common.form.accept") }, on: { click: e.onAccept } }), i("app-secondary-button", { attrs: { label: e.$t("common.form.cancel") }, on: { click: e.onCancel } })], 1)], 1);
}, Bn = [], Fn = /* @__PURE__ */ _(
  Ln,
  jn,
  Bn,
  !1,
  null,
  "c0254e36"
);
const li = Fn.exports, Wn = b({
  components: {
    AppCropper: li
  },
  props: {
    image: {
      type: String,
      required: !0
    },
    maxImageHeight: {
      type: Number,
      required: !0
    },
    maxImageWidth: {
      type: Number,
      required: !0
    }
  },
  created() {
    let t = window.innerWidth - document.body.clientWidth;
    document.body.style.paddingRight = `${t}px`, document.body.style.overflowY = "hidden";
  },
  beforeDestroy() {
    document.body.style.paddingRight = "0px", document.body.style.overflowY = "auto";
  },
  methods: {
    onCropAccept(t) {
      this.$emit("crop-accept", t);
    },
    onCropCancel() {
      this.$emit("crop-cancel");
    }
  }
});
var Nn = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("app-overlay", { attrs: { "center-content": !0, theme: "dark" } }, [i("div", { staticClass: "panel" }, [i("app-cropper", { attrs: { image: e.image, "max-image-height": e.maxImageHeight, "max-image-width": e.maxImageWidth }, on: { "crop-accept": e.onCropAccept, "crop-cancel": e.onCropCancel } })], 1)]);
}, qn = [], Hn = /* @__PURE__ */ _(
  Wn,
  Nn,
  qn,
  !1,
  null,
  "4051c6bb"
);
const Vn = Hn.exports, Un = b({
  props: {
    value: Boolean,
    label: {
      type: String,
      default: ""
    },
    image: {
      type: String,
      required: !1
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    disabled() {
      return !this.enabled;
    }
  },
  methods: {
    updateModel(t) {
      var e;
      this.$emit("input", (e = t == null ? void 0 : t.target) == null ? void 0 : e.checked);
    }
  }
});
var Yn = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("label", { staticClass: "app-checkbox-container", class: { error: e.error, disabled: e.disabled, center: !!e.image } }, [e.image ? i("div", { staticClass: "image-option" }, [i("img", { attrs: { alt: e.label, src: e.image } })]) : e._e(), i("div", { staticClass: "app-checkbox" }, [i("input", { class: { error: e.error, disabled: e.disabled }, attrs: { disabled: e.disabled, type: "checkbox" }, domProps: { checked: e.value }, on: { input: e.updateModel } }), i("span", { staticClass: "checkbox-label" }, [e._v(e._s(e.label))])])]);
}, Xn = [], Gn = /* @__PURE__ */ _(
  Un,
  Yn,
  Xn,
  !1,
  null,
  "8d02ba6a"
);
const Zn = Gn.exports, Kn = b({
  props: {
    value: {
      type: Array,
      required: !0
    },
    error: {
      type: Boolean,
      default: !1
    },
    options: {
      type: Array,
      default: () => []
    },
    alignment: {
      type: String,
      default: "column"
    }
  },
  created() {
    this.options.forEach((t) => {
      this.selected[t.value] = this.value.indexOf(t.value) != -1;
    });
  },
  data() {
    return {
      selected: {}
    };
  },
  computed: {
    hasImages() {
      return this.options.some((t) => t.image);
    }
  },
  methods: {
    updateModel() {
      const t = Object.keys(this.selected).filter((e) => this.selected[e]).map(
        (e) => Number.isNaN(Number(e)) || e.trim() === "" ? e : Number(e)
      );
      this.$emit("input", t);
    }
  }
});
var Qn = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("base-input-item", e._b({ staticClass: "app-checkbox-group", attrs: { error: e.error } }, "base-input-item", e.$attrs, !1), [i("div", { staticClass: "checkbox-items", class: `grid-${e.alignment} ${e.hasImages ? "has-image" : ""}` }, e._l(e.options, function(n, s) {
    return i("app-checkbox", e._b({ key: s, attrs: { image: n.image, label: n.text }, on: { input: e.updateModel }, model: { value: e.selected[n.value], callback: function(r) {
      e.$set(e.selected, n.value, r);
    }, expression: "selected[option.value]" } }, "app-checkbox", e.$attrs, !1));
  }), 1)]);
}, Jn = [], es = /* @__PURE__ */ _(
  Kn,
  Qn,
  Jn,
  !1,
  null,
  "0e9fb78f"
);
const ts = es.exports, is = b({
  props: {
    value: {
      type: Date,
      required: !1
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    max: {
      type: Date,
      required: !1
    },
    min: {
      type: Date,
      required: !1
    }
  },
  data() {
    return {
      innerValue: ""
    };
  },
  created() {
    this.innerValue = this.toDateString(this.value);
  },
  watch: {
    value(t) {
      this.innerValue = this.toDateString(t);
    },
    innerValue(t) {
      const e = this.toDate(t);
      this.$emit("input", e);
    }
  },
  computed: {
    maxDate() {
      return this.toDateString(this.max) || "9999-12-31";
    },
    minDate() {
      return this.toDateString(this.min);
    }
  },
  methods: {
    toDate(t) {
      if (!t)
        return;
      const [e, i, n] = t == null ? void 0 : t.split("-");
      if (!(Number(e) < 999 || Number(i) === 0 || Number(n) === 0))
        return new Date(t);
    },
    toDateString(t) {
      var i;
      return t ? ((i = t == null ? void 0 : t.toISOString()) == null ? void 0 : i.substring(0, 10)) ?? "" : "";
    },
    onClick() {
      this.onToggleCalendarPopup();
    },
    onToggleCalendarPopup() {
      var e;
      const t = this;
      if (t.enabled)
        try {
          (e = t.$refs.dateInput) == null || e.showPicker();
        } catch {
        }
    }
  }
});
var ns = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("div", { staticClass: "app-datepicker-button" }, [i("input", { directives: [{ name: "model", rawName: "v-model", value: e.innerValue, expression: "innerValue" }], ref: "dateInput", staticClass: "date-input", attrs: { type: "date", max: e.maxDate, min: e.minDate }, domProps: { value: e.innerValue }, on: { input: function(n) {
    n.target.composing || (e.innerValue = n.target.value);
  } } }), e._t("default", function() {
    return [i("app-icon-button", { ref: "dateInputButton", attrs: { enabled: e.enabled, size: 34, padding: 6 }, on: { click: e.onClick } }, [i("fa-icon-compat", { staticClass: "fa-icon", attrs: { icon: "fa-light fa-calendar" } })], 1)];
  }, { toggle: e.onToggleCalendarPopup })], 2);
}, ss = [], rs = /* @__PURE__ */ _(
  is,
  ns,
  ss,
  !1,
  null,
  "00ecc9a0"
);
const os = rs.exports, as = b({
  props: {
    value: {
      type: Date,
      required: !1
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    max: {
      type: Date,
      required: !1
    },
    min: {
      type: Date,
      required: !1
    }
  },
  data() {
    return {
      innerValue: ""
    };
  },
  created() {
    this.innerValue = this.toDateString(this.value);
  },
  watch: {
    value(t) {
      this.innerValue = this.toDateString(t);
    },
    innerValue(t) {
      const e = this.toDate(t);
      this.$emit("input", e);
    }
  },
  computed: {
    maxDate() {
      return this.toDateString(this.max) || "9999-12-31";
    },
    minDate() {
      return this.toDateString(this.min);
    },
    clearButtonVisible() {
      return !!this.value;
    }
  },
  methods: {
    toDate(t) {
      if (!t)
        return;
      const [e, i, n] = t == null ? void 0 : t.split("-");
      if (!(Number(e) < 999 || Number(i) === 0 || Number(n) === 0))
        return new Date(t);
    },
    toDateString(t) {
      var i;
      return t ? ((i = t == null ? void 0 : t.toISOString()) == null ? void 0 : i.substring(0, 10)) ?? "" : "";
    },
    onClearInput() {
      this.$emit("input", void 0);
    },
    onFocus(t) {
      this.onToggleCalendarPopup();
    },
    onClick() {
      this.onToggleCalendarPopup();
    },
    onToggleCalendarPopup() {
      setTimeout(() => {
        var e, i, n;
        const t = this;
        if (t.enabled)
          try {
            (n = (i = (e = t.$refs.dateInput) == null ? void 0 : e.$el) == null ? void 0 : i.querySelector("input")) == null || n.showPicker();
          } catch {
          }
      }, 100);
    }
  }
});
var ls = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("base-input-item", e._b({ staticClass: "app-datepicker-input" }, "base-input-item", e.$attrs, !1), [i("base-input-text", { ref: "dateInput", staticClass: "base-input-text", class: { empty: !e.value }, attrs: { enabled: e.enabled, max: e.maxDate, min: e.minDate, "input-type": "date" }, on: { focus: e.onFocus }, scopedSlots: e._u([{ key: "end", fn: function() {
    return [e.clearButtonVisible ? i("app-icon-button", { staticClass: "button-clear-date", attrs: { size: 32 }, on: { click: e.onClearInput } }, [i("fa-icon-compat", { staticClass: "fa-icon", attrs: { icon: "fa-light fa-circle-xmark" } })], 1) : e._e(), i("app-icon-button", { ref: "dateInputButton", staticClass: "button-pick-date", attrs: { enabled: e.enabled, padding: 6, size: 34 }, on: { click: e.onClick } }, [i("fa-icon-compat", { staticClass: "fa-icon", attrs: { icon: "fa-light fa-calendar" } })], 1)];
  }, proxy: !0 }]), model: { value: e.innerValue, callback: function(n) {
    e.innerValue = n;
  }, expression: "innerValue" } })], 1);
}, cs = [], us = /* @__PURE__ */ _(
  as,
  ls,
  cs,
  !1,
  null,
  "2002d22c"
);
const ds = us.exports, hs = b({
  props: {
    value: {
      type: [String, Boolean, Number]
    },
    label: {
      type: String
    },
    error: {
      type: Boolean,
      default: !1
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    options: {
      type: Array,
      default: () => []
    },
    alignment: {
      type: String,
      default: "column"
    }
  },
  computed: {
    componentId() {
      return self.crypto.randomUUID();
    },
    disabled() {
      return !this.enabled;
    },
    hasImages() {
      return this.options.some((t) => t.image);
    }
  },
  data() {
    return {
      transparentPixel: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
    };
  },
  methods: {
    updateValue(t) {
      this.$emit("input", t);
    }
  }
});
var ps = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("base-input-item", e._b({ staticClass: "app-radio-buttons", attrs: { error: e.error, label: e.label } }, "base-input-item", e.$attrs, !1), [i("div", { staticClass: "options", class: `grid-${e.alignment} ${e.hasImages ? "has-images" : ""}` }, e._l(e.options, function(n, s) {
    return i("div", { key: n.text }, [i("label", { attrs: { for: `${e.componentId}-${s}` } }, [e.hasImages ? i("div", { staticClass: "image-option" }, [i("img", { attrs: { alt: n.text, src: n.image ?? e.transparentPixel } })]) : e._e(), i("div", { class: { center: e.hasImages } }, [i("input", { attrs: { id: `${e.componentId}-${s}`, disabled: e.disabled, type: "radio" }, domProps: { checked: n.value === e.value, value: n.value }, on: { change: function(r) {
      return e.updateValue(n.value);
    } } }), e._v(" " + e._s(n.text) + " ")])])]);
  }), 0)]);
}, fs = [], ms = /* @__PURE__ */ _(
  hs,
  ps,
  fs,
  !1,
  null,
  "cd00ed55"
);
const gs = ms.exports, vs = b({
  props: {
    value: {
      type: Array,
      default: () => []
    },
    selectionMode: {
      type: String,
      required: !0,
      validator: (t) => ["single", "multiple"].includes(t)
    }
  },
  data() {
    return {
      selectionSingle: "",
      selectionMultiple: []
    };
  },
  created() {
    if (!Array.isArray(this.value)) {
      console.error("AppDropdown accepts only an array as v-model");
      return;
    }
    this.innerUpdate(this.value);
  },
  watch: {
    value(t) {
      this.innerUpdate(t);
    }
  },
  computed: {
    selectionComponent() {
      return this.selectionMode === "multiple" ? "app-multiselect" : "app-singleselect";
    },
    innerModel() {
      return this.selectionMode === "single" ? this.selectionSingle : this.selectionMultiple;
    }
  },
  methods: {
    innerUpdate(t) {
      this.selectionMode === "single" && t.length > 1 && console.warn(
        "AppDropdown configured as a single input cannot receive multiple values. Only first element will be considered"
      ), this.selectionSingle = (t == null ? void 0 : t[0]) ?? "", this.selectionMultiple = t ?? [];
    },
    onUpdateSingle(t) {
      this.$emit("input", [t]), this.$emit("update-multiple", t);
    },
    onUpdateMultiple(t) {
      this.$emit("input", t), this.$emit("update-single", t);
    },
    onSelectionItemAdded(t) {
      this.$emit("selection-item-added", t);
    },
    onSelectionItemRemoved(t) {
      this.$emit("selection-item-removed", t);
    }
  }
});
var bs = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i(e.selectionComponent, e._b({ tag: "component", attrs: { value: e.innerModel }, on: { "update-single": e.onUpdateSingle, "update-multiple": e.onUpdateMultiple, "selection-item-added": e.onSelectionItemAdded, "selection-item-removed": e.onSelectionItemRemoved }, scopedSlots: e._u([{ key: "search", fn: function() {
    return [e._t("search")];
  }, proxy: !0 }, { key: "controls", fn: function() {
    return [e._t("controls")];
  }, proxy: !0 }], null, !0) }, "component", e.$attrs, !1));
}, _s = [], ys = /* @__PURE__ */ _(
  vs,
  bs,
  _s,
  !1,
  null,
  "c63f81c3"
);
const ws = ys.exports, $s = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, xs = {
  start: "end",
  end: "start"
};
function bt(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function _e(t) {
  return t.split("-")[0];
}
function Ye(t) {
  return t.split("-")[1];
}
function Cs(t) {
  return t === "x" ? "y" : "x";
}
function ci(t) {
  return t === "y" ? "height" : "width";
}
function Re(t) {
  return ["top", "bottom"].includes(_e(t)) ? "y" : "x";
}
function ui(t) {
  return Cs(Re(t));
}
function Ss(t, e, i) {
  i === void 0 && (i = !1);
  const n = Ye(t), s = ui(t), r = ci(s);
  let l = s === "x" ? n === (i ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return e.reference[r] > e.floating[r] && (l = We(l)), [l, We(l)];
}
function As(t) {
  const e = We(t);
  return [dt(t), e, dt(e)];
}
function dt(t) {
  return t.replace(/start|end/g, (e) => xs[e]);
}
function Rs(t, e, i) {
  const n = ["left", "right"], s = ["right", "left"], r = ["top", "bottom"], l = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return i ? e ? s : n : e ? n : s;
    case "left":
    case "right":
      return e ? r : l;
    default:
      return [];
  }
}
function Ms(t, e, i, n) {
  const s = Ye(t);
  let r = Rs(_e(t), i === "start", n);
  return s && (r = r.map((l) => l + "-" + s), e && (r = r.concat(r.map(dt)))), r;
}
function We(t) {
  return t.replace(/left|right|bottom|top/g, (e) => $s[e]);
}
function zs(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function ks(t) {
  return typeof t != "number" ? zs(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function Ne(t) {
  const {
    x: e,
    y: i,
    width: n,
    height: s
  } = t;
  return {
    width: n,
    height: s,
    top: i,
    left: e,
    right: e + n,
    bottom: i + s,
    x: e,
    y: i
  };
}
function Bt(t, e, i) {
  let {
    reference: n,
    floating: s
  } = t;
  const r = Re(e), l = ui(e), a = ci(l), o = _e(e), c = r === "y", d = n.x + n.width / 2 - s.width / 2, u = n.y + n.height / 2 - s.height / 2, p = n[a] / 2 - s[a] / 2;
  let f;
  switch (o) {
    case "top":
      f = {
        x: d,
        y: n.y - s.height
      };
      break;
    case "bottom":
      f = {
        x: d,
        y: n.y + n.height
      };
      break;
    case "right":
      f = {
        x: n.x + n.width,
        y: u
      };
      break;
    case "left":
      f = {
        x: n.x - s.width,
        y: u
      };
      break;
    default:
      f = {
        x: n.x,
        y: n.y
      };
  }
  switch (Ye(e)) {
    case "start":
      f[l] -= p * (i && c ? -1 : 1);
      break;
    case "end":
      f[l] += p * (i && c ? -1 : 1);
      break;
  }
  return f;
}
const Ps = async (t, e, i) => {
  const {
    placement: n = "bottom",
    strategy: s = "absolute",
    middleware: r = [],
    platform: l
  } = i, a = r.filter(Boolean), o = await (l.isRTL == null ? void 0 : l.isRTL(e));
  let c = await l.getElementRects({
    reference: t,
    floating: e,
    strategy: s
  }), {
    x: d,
    y: u
  } = Bt(c, n, o), p = n, f = {}, h = 0;
  for (let m = 0; m < a.length; m++) {
    const {
      name: g,
      fn: v
    } = a[m], {
      x,
      y: $,
      data: y,
      reset: C
    } = await v({
      x: d,
      y: u,
      initialPlacement: n,
      placement: p,
      strategy: s,
      middlewareData: f,
      rects: c,
      platform: l,
      elements: {
        reference: t,
        floating: e
      }
    });
    d = x ?? d, u = $ ?? u, f = {
      ...f,
      [g]: {
        ...f[g],
        ...y
      }
    }, C && h <= 50 && (h++, typeof C == "object" && (C.placement && (p = C.placement), C.rects && (c = C.rects === !0 ? await l.getElementRects({
      reference: t,
      floating: e,
      strategy: s
    }) : C.rects), {
      x: d,
      y: u
    } = Bt(c, p, o)), m = -1);
  }
  return {
    x: d,
    y: u,
    placement: p,
    strategy: s,
    middlewareData: f
  };
};
async function Es(t, e) {
  var i;
  e === void 0 && (e = {});
  const {
    x: n,
    y: s,
    platform: r,
    rects: l,
    elements: a,
    strategy: o
  } = t, {
    boundary: c = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: u = "floating",
    altBoundary: p = !1,
    padding: f = 0
  } = bt(e, t), h = ks(f), g = a[p ? u === "floating" ? "reference" : "floating" : u], v = Ne(await r.getClippingRect({
    element: (i = await (r.isElement == null ? void 0 : r.isElement(g))) == null || i ? g : g.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(a.floating)),
    boundary: c,
    rootBoundary: d,
    strategy: o
  })), x = u === "floating" ? {
    x: n,
    y: s,
    width: l.floating.width,
    height: l.floating.height
  } : l.reference, $ = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(a.floating)), y = await (r.isElement == null ? void 0 : r.isElement($)) ? await (r.getScale == null ? void 0 : r.getScale($)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, C = Ne(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: x,
    offsetParent: $,
    strategy: o
  }) : x);
  return {
    top: (v.top - C.top + h.top) / y.y,
    bottom: (C.bottom - v.bottom + h.bottom) / y.y,
    left: (v.left - C.left + h.left) / y.x,
    right: (C.right - v.right + h.right) / y.x
  };
}
const _t = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var i, n;
      const {
        placement: s,
        middlewareData: r,
        rects: l,
        initialPlacement: a,
        platform: o,
        elements: c
      } = e, {
        mainAxis: d = !0,
        crossAxis: u = !0,
        fallbackPlacements: p,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: m = !0,
        ...g
      } = bt(t, e);
      if ((i = r.arrow) != null && i.alignmentOffset)
        return {};
      const v = _e(s), x = Re(a), $ = _e(a) === a, y = await (o.isRTL == null ? void 0 : o.isRTL(c.floating)), C = p || ($ || !m ? [We(a)] : As(a)), M = h !== "none";
      !p && M && C.push(...Ms(a, m, h, y));
      const pe = [a, ...C], j = await Es(e, g), X = [];
      let G = ((n = r.flip) == null ? void 0 : n.overflows) || [];
      if (d && X.push(j[v]), u) {
        const K = Ss(s, l, y);
        X.push(j[K[0]], j[K[1]]);
      }
      if (G = [...G, {
        placement: s,
        overflows: X
      }], !X.every((K) => K <= 0)) {
        var Z, ie;
        const K = (((Z = r.flip) == null ? void 0 : Z.index) || 0) + 1, we = pe[K];
        if (we)
          return {
            data: {
              index: K,
              overflows: G
            },
            reset: {
              placement: we
            }
          };
        let le = (ie = G.filter((ne) => ne.overflows[0] <= 0).sort((ne, N) => ne.overflows[1] - N.overflows[1])[0]) == null ? void 0 : ie.placement;
        if (!le)
          switch (f) {
            case "bestFit": {
              var ze;
              const ne = (ze = G.filter((N) => {
                if (M) {
                  const q = Re(N.placement);
                  return q === x || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  q === "y";
                }
                return !0;
              }).map((N) => [N.placement, N.overflows.filter((q) => q > 0).reduce((q, k) => q + k, 0)]).sort((N, q) => N[1] - q[1])[0]) == null ? void 0 : ze[0];
              ne && (le = ne);
              break;
            }
            case "initialPlacement":
              le = a;
              break;
          }
        if (s !== le)
          return {
            reset: {
              placement: le
            }
          };
      }
      return {};
    }
  };
};
async function Is(t, e) {
  const {
    placement: i,
    platform: n,
    elements: s
  } = t, r = await (n.isRTL == null ? void 0 : n.isRTL(s.floating)), l = _e(i), a = Ye(i), o = Re(i) === "y", c = ["left", "top"].includes(l) ? -1 : 1, d = r && o ? -1 : 1, u = bt(e, t);
  let {
    mainAxis: p,
    crossAxis: f,
    alignmentAxis: h
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: u.mainAxis || 0,
    crossAxis: u.crossAxis || 0,
    alignmentAxis: u.alignmentAxis
  };
  return a && typeof h == "number" && (f = a === "end" ? h * -1 : h), o ? {
    x: f * d,
    y: p * c
  } : {
    x: p * c,
    y: f * d
  };
}
const di = function(t) {
  return {
    name: "offset",
    options: t,
    async fn(e) {
      var i, n;
      const {
        x: s,
        y: r,
        placement: l,
        middlewareData: a
      } = e, o = await Is(e, t);
      return l === ((i = a.offset) == null ? void 0 : i.placement) && (n = a.arrow) != null && n.alignmentOffset ? {} : {
        x: s + o.x,
        y: r + o.y,
        data: {
          ...o,
          placement: l
        }
      };
    }
  };
};
function hi(t) {
  return t && t.document && t.location && t.alert && t.setInterval;
}
function te(t) {
  if (t == null) return window;
  if (!hi(t)) {
    const e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function Me(t) {
  return te(t).getComputedStyle(t);
}
function ee(t) {
  return hi(t) ? "" : t ? (t.nodeName || "").toLowerCase() : "";
}
function pi() {
  const t = navigator.userAgentData;
  return t != null && t.brands ? t.brands.map((e) => e.brand + "/" + e.version).join(" ") : navigator.userAgent;
}
function Y(t) {
  return t instanceof te(t).HTMLElement;
}
function ye(t) {
  return t instanceof te(t).Element;
}
function yt(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof te(t).ShadowRoot || t instanceof ShadowRoot;
}
function Xe(t) {
  const { overflow: e, overflowX: i, overflowY: n } = Me(t);
  return /auto|scroll|overlay|hidden/.test(e + n + i);
}
function Os(t) {
  return ["table", "td", "th"].includes(ee(t));
}
function Ft(t) {
  const e = /firefox/i.test(pi()), i = Me(t);
  return i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].includes(i.willChange) || e && i.willChange === "filter" || e && !!i.filter && i.filter !== "none";
}
function fi() {
  return !/^((?!chrome|android).)*safari/i.test(pi());
}
const Wt = Math.min, Ce = Math.max, qe = Math.round;
function de(t, e, i) {
  var n, s, r, l;
  e === void 0 && (e = !1), i === void 0 && (i = !1);
  const a = t.getBoundingClientRect();
  let o = 1, c = 1;
  e && Y(t) && (o = t.offsetWidth > 0 && qe(a.width) / t.offsetWidth || 1, c = t.offsetHeight > 0 && qe(a.height) / t.offsetHeight || 1);
  const d = ye(t) ? te(t) : window, u = !fi() && i, p = (a.left + (u && (n = (s = d.visualViewport) == null ? void 0 : s.offsetLeft) != null ? n : 0)) / o, f = (a.top + (u && (r = (l = d.visualViewport) == null ? void 0 : l.offsetTop) != null ? r : 0)) / c, h = a.width / o, m = a.height / c;
  return { width: h, height: m, top: f, right: p + h, bottom: f + m, left: p, x: p, y: f };
}
function ae(t) {
  return (e = t, (e instanceof te(e).Node ? t.ownerDocument : t.document) || window.document).documentElement;
  var e;
}
function Ge(t) {
  return ye(t) ? { scrollLeft: t.scrollLeft, scrollTop: t.scrollTop } : { scrollLeft: t.pageXOffset, scrollTop: t.pageYOffset };
}
function mi(t) {
  return de(ae(t)).left + Ge(t).scrollLeft;
}
function Ts(t, e, i) {
  const n = Y(e), s = ae(e), r = de(t, n && function(o) {
    const c = de(o);
    return qe(c.width) !== o.offsetWidth || qe(c.height) !== o.offsetHeight;
  }(e), i === "fixed");
  let l = { scrollLeft: 0, scrollTop: 0 };
  const a = { x: 0, y: 0 };
  if (n || !n && i !== "fixed") if ((ee(e) !== "body" || Xe(s)) && (l = Ge(e)), Y(e)) {
    const o = de(e, !0);
    a.x = o.x + e.clientLeft, a.y = o.y + e.clientTop;
  } else s && (a.x = mi(s));
  return { x: r.left + l.scrollLeft - a.x, y: r.top + l.scrollTop - a.y, width: r.width, height: r.height };
}
function gi(t) {
  return ee(t) === "html" ? t : t.assignedSlot || t.parentNode || (yt(t) ? t.host : null) || ae(t);
}
function Nt(t) {
  return Y(t) && getComputedStyle(t).position !== "fixed" ? t.offsetParent : null;
}
function ht(t) {
  const e = te(t);
  let i = Nt(t);
  for (; i && Os(i) && getComputedStyle(i).position === "static"; ) i = Nt(i);
  return i && (ee(i) === "html" || ee(i) === "body" && getComputedStyle(i).position === "static" && !Ft(i)) ? e : i || function(n) {
    let s = gi(n);
    for (yt(s) && (s = s.host); Y(s) && !["html", "body"].includes(ee(s)); ) {
      if (Ft(s)) return s;
      s = s.parentNode;
    }
    return null;
  }(t) || e;
}
function qt(t) {
  if (Y(t)) return { width: t.offsetWidth, height: t.offsetHeight };
  const e = de(t);
  return { width: e.width, height: e.height };
}
function vi(t) {
  const e = gi(t);
  return ["html", "body", "#document"].includes(ee(e)) ? t.ownerDocument.body : Y(e) && Xe(e) ? e : vi(e);
}
function bi(t, e) {
  var i;
  e === void 0 && (e = []);
  const n = vi(t), s = n === ((i = t.ownerDocument) == null ? void 0 : i.body), r = te(n), l = s ? [r].concat(r.visualViewport || [], Xe(n) ? n : []) : n, a = e.concat(l);
  return s ? a : a.concat(bi(l));
}
function Ht(t, e, i) {
  return e === "viewport" ? Ne(function(n, s) {
    const r = te(n), l = ae(n), a = r.visualViewport;
    let o = l.clientWidth, c = l.clientHeight, d = 0, u = 0;
    if (a) {
      o = a.width, c = a.height;
      const p = fi();
      (p || !p && s === "fixed") && (d = a.offsetLeft, u = a.offsetTop);
    }
    return { width: o, height: c, x: d, y: u };
  }(t, i)) : ye(e) ? function(n, s) {
    const r = de(n, !1, s === "fixed"), l = r.top + n.clientTop, a = r.left + n.clientLeft;
    return { top: l, left: a, x: a, y: l, right: a + n.clientWidth, bottom: l + n.clientHeight, width: n.clientWidth, height: n.clientHeight };
  }(e, i) : Ne(function(n) {
    var s;
    const r = ae(n), l = Ge(n), a = (s = n.ownerDocument) == null ? void 0 : s.body, o = Ce(r.scrollWidth, r.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0), c = Ce(r.scrollHeight, r.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0);
    let d = -l.scrollLeft + mi(n);
    const u = -l.scrollTop;
    return Me(a || r).direction === "rtl" && (d += Ce(r.clientWidth, a ? a.clientWidth : 0) - o), { width: o, height: c, x: d, y: u };
  }(ae(t)));
}
function Ds(t) {
  const e = bi(t), i = ["absolute", "fixed"].includes(Me(t).position) && Y(t) ? ht(t) : t;
  return ye(i) ? e.filter((n) => ye(n) && function(s, r) {
    const l = r.getRootNode == null ? void 0 : r.getRootNode();
    if (s.contains(r)) return !0;
    if (l && yt(l)) {
      let a = r;
      do {
        if (a && s === a) return !0;
        a = a.parentNode || a.host;
      } while (a);
    }
    return !1;
  }(n, i) && ee(n) !== "body") : [];
}
const Ls = { getClippingRect: function(t) {
  let { element: e, boundary: i, rootBoundary: n, strategy: s } = t;
  const r = [...i === "clippingAncestors" ? Ds(e) : [].concat(i), n], l = r[0], a = r.reduce((o, c) => {
    const d = Ht(e, c, s);
    return o.top = Ce(d.top, o.top), o.right = Wt(d.right, o.right), o.bottom = Wt(d.bottom, o.bottom), o.left = Ce(d.left, o.left), o;
  }, Ht(e, l, s));
  return { width: a.right - a.left, height: a.bottom - a.top, x: a.left, y: a.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
  let { rect: e, offsetParent: i, strategy: n } = t;
  const s = Y(i), r = ae(i);
  if (i === r) return e;
  let l = { scrollLeft: 0, scrollTop: 0 };
  const a = { x: 0, y: 0 };
  if ((s || !s && n !== "fixed") && ((ee(i) !== "body" || Xe(r)) && (l = Ge(i)), Y(i))) {
    const o = de(i, !0);
    a.x = o.x + i.clientLeft, a.y = o.y + i.clientTop;
  }
  return { ...e, x: e.x - l.scrollLeft + a.x, y: e.y - l.scrollTop + a.y };
}, isElement: ye, getDimensions: qt, getOffsetParent: ht, getDocumentElement: ae, getElementRects: (t) => {
  let { reference: e, floating: i, strategy: n } = t;
  return { reference: Ts(e, ht(i), n), floating: { ...qt(i), x: 0, y: 0 } };
}, getClientRects: (t) => Array.from(t.getClientRects()), isRTL: (t) => Me(t).direction === "rtl" }, wt = (t, e, i) => Ps(t, e, { platform: Ls, ...i }), js = b({
  props: {
    value: {
      type: Boolean,
      required: !0
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  mounted() {
    document.addEventListener("focusin", this.listenerFocusin), document.addEventListener("focusout", this.listenerFocusout), document.addEventListener("keyup", this.listenerKeyup);
  },
  unmounted() {
    document.removeEventListener("focusin", this.listenerFocusin), document.removeEventListener("focusout", this.listenerFocusout), document.removeEventListener("keyup", this.listenerKeyup);
  },
  watch: {
    value() {
      ve(() => {
        this.updateFloatingPosition();
      });
    }
  },
  computed: {
    disabled() {
      return !this.enabled;
    }
  },
  methods: {
    $contains(t) {
      const e = this.$refs.dropdown;
      return e == null ? void 0 : e.contains(t);
    },
    listenerFocusin(t) {
      this.$contains(t.target) && this.onOpenOptions();
    },
    listenerFocusout(t) {
      this.$contains(t.relatedTarget) || this.onCloseOptions();
    },
    listenerKeyup(t) {
      var e;
      ((e = t.key) == null ? void 0 : e.toUpperCase()) === "ESCAPE" && this.onCloseOptions();
    },
    updateFloatingPosition() {
      const t = this.$refs.dropdown, e = this.$refs.floating;
      e && wt(t, e, {
        placement: "bottom",
        // 70 padding top to avoid it going under the header,
        // not ideal to have it implicit here but needed a
        // quick solution
        middleware: [di(8), _t({ padding: { top: 70 } })]
      }).then(({ x: i, y: n }) => {
        Object.assign(e.style, {
          left: `${i}px`,
          top: `${n}px`
        });
      });
    },
    onOpenOptions() {
      this.enabled && this.$emit("input", !0);
    },
    onCloseOptions() {
      this.enabled && this.$emit("input", !1);
    }
  }
});
var Bs = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("div", { ref: "dropdown", staticClass: "base-dropdown", class: { disabled: e.disabled, error: e.error }, attrs: { tabindex: e.enabled ? 0 : -1 }, on: { click: e.onOpenOptions } }, [e._t("content"), i("transition", { attrs: { mode: "out-in", name: "dropdown-slide" } }, [e.value ? i("div", { ref: "floating", staticClass: "floating" }, [e._t("options")], 2) : e._e()])], 2);
}, Fs = [], Ws = /* @__PURE__ */ _(
  js,
  Bs,
  Fs,
  !1,
  null,
  "bf10f611"
);
const _i = Ws.exports, Ns = b({
  props: {
    checked: {
      type: Boolean,
      default: !1
    },
    enabled: {
      type: Boolean,
      default: !1
    },
    mark: {
      type: String,
      default: "full",
      validator(t) {
        return ["full", "partial"].indexOf(t) !== -1;
      }
    }
  },
  computed: {
    style() {
      return this.enabled && this.checked ? {
        background: "#2B94FC",
        border: "#2B94FC"
      } : this.enabled && !this.checked ? {
        background: "#FAFAFA",
        border: "#CBCBCB"
      } : !this.enabled && this.checked ? {
        background: "#E6E6E6",
        border: "#E6E6E6"
      } : {
        background: "#E6E6E6",
        border: "#D6D6D6"
      };
    }
  }
});
var qs = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("svg", { attrs: { width: "22", height: "22", viewBox: "0 0 22 22", fill: "none" } }, [i("rect", { attrs: { x: "1", y: "1", width: "20", height: "20", rx: "4", fill: e.style.background, stroke: e.style.border } }), e.checked ? [e.mark === "full" ? i("path", { attrs: { d: "M6 11.5 L10 14.5 L16 7.5", stroke: "#FFFFFF", "stroke-width": "2.5" } }) : e.mark === "partial" ? i("path", { attrs: { d: "M5 11.25 L17 11.25", stroke: "#FFFFFF", "stroke-width": "2.5" } }) : e._e()] : e._e()], 2);
}, Hs = [], Vs = /* @__PURE__ */ _(
  Ns,
  qs,
  Hs,
  !1,
  null,
  null
);
const yi = Vs.exports, Us = b({
  components: {
    BaseCheckmark: yi
  },
  props: {
    mode: {
      type: String,
      required: !0
    },
    option: {
      type: Object,
      required: !0
    },
    checked: {
      type: Boolean,
      default: !1
    },
    enabled: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    checkmarkEnabled() {
      return this.mode === "multiple";
    }
  },
  methods: {
    onClick() {
      this.enabled && (this.checked ? this.$emit("item-remove", this.option.value) : this.$emit("item-add", this.option.value));
    }
  }
});
var Ys = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("div", { staticClass: "dropdown-options-item", class: { checked: e.checked, enabled: e.enabled }, on: { click: function(n) {
    return n.stopPropagation(), e.onClick.apply(null, arguments);
  } } }, [e.checkmarkEnabled ? i("base-checkmark", { staticClass: "checkmark", attrs: { enabled: e.enabled, checked: e.checked } }) : e._e(), e.option.image ? i("img", { staticClass: "image", attrs: { src: e.option.image } }) : e._e(), i("div", { staticClass: "content" }, [i("div", { staticClass: "text" }, [e._v(e._s(e.option.text))]), e.option.description ? i("div", { staticClass: "description" }, [e._v(" " + e._s(e.option.description) + " ")]) : e._e()])], 1);
}, Xs = [], Gs = /* @__PURE__ */ _(
  Us,
  Ys,
  Xs,
  !1,
  null,
  "d9a503e3"
);
const $t = Gs.exports, Zs = b({
  components: {
    DropdownOptionsItem: $t
  },
  props: {
    model: {
      type: Object,
      required: !0
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    optionsGroups: {
      type: Array,
      default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: !1
    },
    searchEnabled: {
      type: Boolean,
      required: !0
    },
    searchLabel: {
      type: String,
      required: !1
    }
  },
  data() {
    return {
      query: ""
    };
  },
  computed: {
    filteredOptions() {
      if (!this.query)
        return this.options;
      const t = this.query.toUpperCase();
      return this.options.filter((e) => e.text.toUpperCase().includes(t));
    }
  },
  methods: {
    optionsForGroup(t) {
      return this.filteredOptions.filter((e) => e.groupKey === t);
    },
    onItemAdd(t) {
      this.$emit("item-add", t);
    },
    onItemRemove(t) {
      this.$emit("item-remove", t);
    }
  }
});
var Ks = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("div", { staticClass: "dropdown-options" }, [i("div", { staticClass: "options-controls" }, [e._t("search", function() {
    return [e.searchEnabled ? i("app-search-input", { staticClass: "search-input", attrs: { placeholder: e.searchLabel }, model: { value: e.query, callback: function(n) {
      e.query = n;
    }, expression: "query" } }) : e._e()];
  }), e._t("controls")], 2), i("div", { staticClass: "options-content" }, [e.loading ? i("div", { staticClass: "loading" }, [i("app-loading")], 1) : e.optionsGroups.length ? i("div", e._l(e.optionsGroups, function(n) {
    return i("div", { key: `group-${n.key}` }, [i("div", { staticClass: "options-group-label" }, [e._v(e._s(n.label))]), e._l(e.optionsForGroup(n.key), function(s, r) {
      return i("dropdown-options-item", { key: r, attrs: { mode: e.model.selectionMode, option: s, enabled: e.model.optionEnabled(s.value), checked: e.model.optionChecked(s.value) }, on: { "item-add": e.onItemAdd, "item-remove": e.onItemRemove } });
    })], 2);
  }), 0) : e.filteredOptions.length ? i("div", { staticClass: "options-list" }, e._l(e.filteredOptions, function(n, s) {
    return i("dropdown-options-item", { key: s, attrs: { mode: e.model.selectionMode, option: n, enabled: e.model.optionEnabled(n.value), checked: e.model.optionChecked(n.value) }, on: { "item-add": e.onItemAdd, "item-remove": e.onItemRemove } });
  }), 1) : e._e()])]);
}, Qs = [], Js = /* @__PURE__ */ _(
  Zs,
  Ks,
  Qs,
  !1,
  null,
  "779f226f"
);
const wi = Js.exports, er = b({
  computed: {
    arrowSrc() {
      return "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDEyIDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNi4wMDE2NCA2TDExIDEuMDAzMjgiIHN0cm9rZT0iIzgzODM4MyIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
    }
  }
});
var tr = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("div", { staticClass: "dropdown-content" }, [i("div", { staticClass: "content" }, [e._t("default")], 2), i("img", { staticClass: "arrow", attrs: { src: e.arrowSrc } })]);
}, ir = [], nr = /* @__PURE__ */ _(
  er,
  tr,
  ir,
  !1,
  null,
  "cc260f09"
);
const $i = nr.exports, sr = b({
  components: {
    DropdownContent: $i
  },
  props: {
    value: {
      type: Object,
      required: !0
    },
    options: {
      type: Array,
      required: !0
    },
    optionsPool: {
      type: Set,
      default: () => /* @__PURE__ */ new Set()
    },
    placeholder: {
      type: String,
      required: !0
    }
  },
  computed: {
    pool() {
      const t = [...this.options, ...this.optionsPool];
      return new Map(t.map((e) => [e.value, e]));
    },
    selectionOption() {
      const t = this.value.selectionValues[0];
      if (!t)
        return;
      const e = this.pool.get(t);
      if (e)
        return e;
      console.warn(
        `Unknown value "${t}" is selected but not included as a dropdown option`
      );
    },
    displayValue() {
      var t;
      return (t = this.selectionOption) == null ? void 0 : t.text;
    }
  }
});
var rr = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("dropdown-content", [e.displayValue ? i("div", { staticClass: "content-value" }, [e._v(e._s(e.displayValue))]) : i("div", { staticClass: "placeholder" }, [e._v(e._s(e.placeholder))])]);
}, or = [], ar = /* @__PURE__ */ _(
  sr,
  rr,
  or,
  !1,
  null,
  "3c34a3f5"
);
const lr = ar.exports, cr = b({
  props: {
    value: {
      type: Object,
      required: !0
    },
    options: {
      type: Array,
      required: !0
    }
  },
  methods: {
    onSelectRandom() {
      const t = this.options.length, e = Math.floor(Math.random() * t);
      this.value.optionToggle(this.options[e].value), this.$emit("input", this.value.updateModel());
    }
  }
});
var ur = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("div", { staticClass: "dropdown-control-random" }, [i("button", { attrs: { type: "button" }, on: { click: e.onSelectRandom } }, [e._v("Select Random")])]);
}, dr = [], hr = /* @__PURE__ */ _(
  cr,
  ur,
  dr,
  !1,
  null,
  "3217d52f"
);
const pr = hr.exports;
class xt {
  constructor(e) {
    $e(this, "selection");
    this.selection = e ?? "";
  }
  get selectionMode() {
    return "single";
  }
  get selectionGlobal() {
    return !1;
  }
  get selectionValues() {
    return this.selection ? [this.selection] : [];
  }
  get selectionCount() {
    return this.selection ? 1 : 0;
  }
  get hash() {
    return ["single", ...this.selectionValues].join("");
  }
  optionToggle(e) {
    return this.selection === e ? this.selection = "" : this.selection = e, this;
  }
  optionSet(e, i) {
    return this.selection = "", i && (this.selection = e), this;
  }
  optionUpdate(e) {
    return this.selection = e.length > 0 ? e[0] : "", this;
  }
  updateModel() {
    return new xt(this.selection);
  }
  optionChecked(e) {
    return this.selection === e;
  }
  optionEnabled(e) {
    return !0;
  }
}
const fr = b({
  components: {
    BaseDropdown: _i,
    DropdownOptions: wi,
    AppSingleselectContent: lr,
    DropdownControlRandom: pr
  },
  props: {
    value: {
      type: String,
      required: !0
    },
    options: {
      type: Array,
      required: !0
    },
    optionsPool: {
      type: Array,
      required: !1
    },
    optionsGroups: {
      type: Array,
      default() {
        return [];
      }
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    error: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    searchEnabled: {
      type: Boolean,
      default: !1
    },
    searchLabel: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      optionsVisible: !1,
      model: this.buildModel(this.value),
      pool: new Set(this.optionsPool)
    };
  },
  watch: {
    optionsVisible(t) {
      t && this.focusSearchField(), this.$emit("toggle-open", t);
    },
    optionsPool(t) {
      this.pool = new Set(t);
    },
    value(t) {
      const e = this.buildModel(t);
      e.hash !== this.model.hash && (this.model = e.updateModel());
    },
    model(t) {
      const e = t.selectionValues[0] ?? "";
      this.updateMemory(e), this.$emit("input", e), this.$emit("update-single", e), this.optionsVisible = !1;
    }
  },
  methods: {
    focusSearchField() {
      this.$nextTick(() => {
        const t = this.$el.querySelector(
          ".base-dropdown .text-input"
        );
        t == null || t.focus();
      });
    },
    updateMemory(t) {
      const e = this.options.find((i) => i.value === t);
      e && this.pool.add(e);
    },
    buildModel(t) {
      return new xt(t);
    },
    onItemAdd(t) {
      const e = this.model.selectionValues[0];
      this.model = this.model.optionSet(t, !0).updateModel(), e && this.onSelectionItemRemoved(e), this.onSelectionItemAdded(t);
    },
    onItemRemove(t) {
      this.model = this.model.optionSet(t, !1).updateModel(), this.onSelectionItemRemoved(t);
    },
    onSelectionItemAdded(t) {
      this.$emit("selection-item-added", t);
    },
    onSelectionItemRemoved(t) {
      this.$emit("selection-item-removed", t);
    }
  }
});
var mr = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("base-input-item", e._b({ attrs: { enabled: e.enabled, error: e.error } }, "base-input-item", e.$attrs, !1), [i("base-dropdown", { attrs: { enabled: e.enabled, error: e.error }, scopedSlots: e._u([{ key: "content", fn: function() {
    return [i("app-singleselect-content", { attrs: { options: e.options, "options-pool": e.pool, placeholder: e.placeholder }, model: { value: e.model, callback: function(n) {
      e.model = n;
    }, expression: "model" } })];
  }, proxy: !0 }, { key: "options", fn: function() {
    return [i("dropdown-options", { attrs: { model: e.model, options: e.options, "options-groups": e.optionsGroups, loading: e.loading, "search-enabled": e.searchEnabled, "search-label": e.searchLabel }, on: { "item-add": e.onItemAdd, "item-remove": e.onItemRemove }, scopedSlots: e._u([{ key: "search", fn: function() {
      return [e._t("search")];
    }, proxy: !0 }, { key: "controls", fn: function() {
      return [e._t("controls")];
    }, proxy: !0 }], null, !0) })];
  }, proxy: !0 }]), model: { value: e.optionsVisible, callback: function(n) {
    e.optionsVisible = n;
  }, expression: "optionsVisible" } })], 1);
}, gr = [], vr = /* @__PURE__ */ _(
  fr,
  mr,
  gr,
  !1,
  null,
  "f72f11e5"
);
const br = vr.exports, _r = b({
  props: {
    option: {
      type: Object,
      required: !0
    }
  },
  computed: {
    xSrc() {
      return "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuMjc3MzQgNS4xMjVMOS4wOTM3NSAyLjMzNTk0TDkuNjY3OTcgMS43NjE3MkM5Ljc1IDEuNjc5NjkgOS43NSAxLjU0Mjk3IDkuNjY3OTcgMS40MzM1OUw5LjA2NjQxIDAuODMyMDMxQzguOTU3MDMgMC43NSA4LjgyMDMxIDAuNzUgOC43MzgyOCAwLjgzMjAzMUw1LjM3NSA0LjIyMjY2TDEuOTg0MzggMC44MzIwMzFDMS45MDIzNCAwLjc1IDEuNzY1NjIgMC43NSAxLjY1NjI1IDAuODMyMDMxTDEuMDU0NjkgMS40MzM1OUMwLjk3MjY1NiAxLjU0Mjk3IDAuOTcyNjU2IDEuNjc5NjkgMS4wNTQ2OSAxLjc2MTcyTDQuNDQ1MzEgNS4xMjVMMS4wNTQ2OSA4LjUxNTYyQzAuOTcyNjU2IDguNTk3NjYgMC45NzI2NTYgOC43MzQzOCAxLjA1NDY5IDguODQzNzVMMS42NTYyNSA5LjQ0NTMxQzEuNzY1NjIgOS41MjczNCAxLjkwMjM0IDkuNTI3MzQgMS45ODQzOCA5LjQ0NTMxTDUuMzc1IDYuMDU0NjlMOC4xNjQwNiA4Ljg3MTA5TDguNzM4MjggOS40NDUzMUM4LjgyMDMxIDkuNTI3MzQgOC45NTcwMyA5LjUyNzM0IDkuMDY2NDEgOS40NDUzMUw5LjY2Nzk3IDguODQzNzVDOS43NSA4LjczNDM4IDkuNzUgOC41OTc2NiA5LjY2Nzk3IDguNTE1NjJMNi4yNzczNCA1LjEyNVoiIGZpbGw9IiMyQjk0RkMiLz4KPC9zdmc+Cg==";
    }
  },
  methods: {
    onClickRemove() {
      this.$emit("item-remove", this.option.value);
    }
  }
});
var yr = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("div", { staticClass: "dropdown-content-tag" }, [i("div", { staticClass: "text", attrs: { title: e.option.text } }, [e._v(e._s(e.option.text))]), i("button", { attrs: { type: "button", tabindex: "-1" }, on: { click: function(n) {
    return n.preventDefault(), n.stopPropagation(), e.onClickRemove.apply(null, arguments);
  } } }, [i("img", { attrs: { src: e.xSrc } })])]);
}, wr = [], $r = /* @__PURE__ */ _(
  _r,
  yr,
  wr,
  !1,
  null,
  "98e2dbc0"
);
const xr = $r.exports, Cr = b({
  components: {
    DropdownContent: $i,
    DropdownContentTag: xr
  },
  props: {
    value: {
      type: Object,
      required: !0
    },
    options: {
      type: Array,
      required: !0
    },
    optionsPool: {
      type: Set,
      default: () => /* @__PURE__ */ new Set()
    },
    placeholder: {
      type: String,
      required: !0
    },
    globalSelection: {
      type: Object,
      required: !1
    }
  },
  computed: {
    pool() {
      const t = [
        ...this.options,
        ...this.optionsPool
      ];
      return new Map(t.map((e) => [e.value, e]));
    },
    selectionOptions() {
      const t = [];
      return this.value.selectionValues.forEach((e) => {
        const i = this.pool.get(e);
        i ? t.push(i) : console.warn(
          `Unknown value "${e}" is selected but not included as a dropdown option`
        );
      }), t;
    }
  },
  methods: {
    onSelectionRemove(t) {
      this.value.optionSet(t, !1), this.$emit("input", this.value.updateModel()), this.$emit("selection-item-removed", t);
    }
  }
});
var Sr = function() {
  var n;
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("dropdown-content", [e.value.selectionGlobal ? i("span", [e._v(e._s((n = e.globalSelection) == null ? void 0 : n.text))]) : e.value.selectionValues.length === 0 ? i("span", { staticClass: "placeholder" }, [e._v(" " + e._s(e.placeholder) + " ")]) : i("div", { staticClass: "tag-container" }, e._l(e.selectionOptions, function(s) {
    return i("dropdown-content-tag", { key: s.value, attrs: { option: s }, on: { "item-remove": e.onSelectionRemove } });
  }), 1)]);
}, Ar = [], Rr = /* @__PURE__ */ _(
  Cr,
  Sr,
  Ar,
  !1,
  null,
  "35c54cbb"
);
const Mr = Rr.exports;
class xi {
  constructor(e) {
    $e(this, "selection");
    this.selection = e;
  }
  get selectionMode() {
    return "multiple";
  }
  get selectionGlobal() {
    return !0;
  }
  get selectionValues() {
    return [this.selection.value];
  }
  get selectionCount() {
    return 1;
  }
  get hash() {
    return `global${this.selection.value}`;
  }
  optionToggle(e) {
    return console.warn("Global selection dropdown cannot toggle individual options"), this;
  }
  optionSet(e, i) {
    return console.warn("Global selection dropdown cannot set individual options"), this;
  }
  optionUpdate(e) {
    return this;
  }
  updateModel() {
    return this;
  }
  optionChecked(e) {
    return !0;
  }
  optionEnabled(e) {
    return !1;
  }
}
class Ze {
  constructor(e) {
    $e(this, "selection");
    e ? Array.isArray(e) ? this.selection = new Set(e) : this.selection = e : this.selection = /* @__PURE__ */ new Set();
  }
  get selectionMode() {
    return "multiple";
  }
  get selectionGlobal() {
    return !1;
  }
  get selectionValues() {
    return [...this.selection];
  }
  get selectionCount() {
    return this.selection.size;
  }
  get hash() {
    return ["multiple", ...this.selection].join("");
  }
  optionUpdate(e) {
    return this.selection = new Set(e), this;
  }
  optionToggle(e) {
    return this.selection.has(e) ? this.selection.delete(e) : this.selection.add(e), this;
  }
  optionSet(e, i) {
    return i ? this.selection.add(e) : this.selection.delete(e), this;
  }
  updateModel() {
    return new Ze(this.selection);
  }
  optionChecked(e) {
    return this.selection.has(e);
  }
  optionEnabled(e) {
    return !0;
  }
}
const zr = b({
  components: {
    DropdownOptionsItem: $t
  },
  props: {
    value: {
      type: Object,
      required: !0
    },
    options: {
      type: Array,
      required: !0
    },
    option: {
      type: Object,
      required: !0
    }
  },
  methods: {
    onGlobalSelectionAdd() {
      this.$emit("input", new xi(this.option));
    },
    onGlobalSelectionRemove() {
      this.$emit("input", new Ze());
    }
  }
});
var kr = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("dropdown-options-item", { attrs: { mode: "multiple", option: e.option, checked: e.value.selectionGlobal }, on: { "item-remove": e.onGlobalSelectionRemove, "item-add": e.onGlobalSelectionAdd } });
}, Pr = [], Er = /* @__PURE__ */ _(
  zr,
  kr,
  Pr,
  !1,
  null,
  "d69b22ac"
);
const Ir = Er.exports, Or = b({
  components: {
    BaseDropdown: _i,
    DropdownOptions: wi,
    AppMultiselectContent: Mr,
    DropdownControlGlobal: Ir
  },
  props: {
    value: {
      type: Array,
      default: !0
    },
    options: {
      type: Array,
      required: !0
    },
    optionsPool: {
      type: Array,
      required: !1
    },
    optionsGroups: {
      type: Array,
      default() {
        return [];
      }
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    error: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    searchEnabled: {
      type: Boolean,
      default: !1
    },
    searchLabel: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    globalSelection: {
      type: Object,
      required: !1
    }
  },
  data() {
    return {
      optionsVisible: !1,
      model: this.buildModel(this.value),
      pool: new Set(this.optionsPool)
    };
  },
  watch: {
    optionsVisible(t) {
      this.$emit("toggle-open", t), t && this.focusSearchField();
    },
    optionsPool(t) {
      this.pool = new Set(t);
    },
    value(t) {
      const e = this.buildModel(t);
      e.hash !== this.model.hash && (this.model = e.updateModel());
    },
    model(t) {
      this.updateMemory(t.selectionValues), this.$emit("input", t.selectionValues), this.$emit("update-multiple", t.selectionValues);
    }
  },
  methods: {
    focusSearchField() {
      this.$nextTick(() => {
        const t = this.$el.querySelector(
          ".base-dropdown .text-input"
        );
        t == null || t.focus();
      });
    },
    updateMemory(t) {
      t.forEach((e) => {
        const i = this.options.find((n) => n.value === e);
        i && this.pool.add(i);
      });
    },
    buildModel(t) {
      var i;
      const e = (i = this.globalSelection) == null ? void 0 : i.value;
      return e && t.includes(e) ? new xi(this.globalSelection) : new Ze(this.value);
    },
    onItemAdd(t) {
      this.model = this.model.optionSet(t, !0).updateModel(), this.onSelectionItemAdded(t);
    },
    onItemRemove(t) {
      this.model = this.model.optionSet(t, !1).updateModel(), this.onSelectionItemRemoved(t);
    },
    onSelectionItemAdded(t) {
      this.$emit("selection-item-added", t);
    },
    onSelectionItemRemoved(t) {
      this.$emit("selection-item-removed", t);
    }
  }
});
var Tr = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("base-input-item", e._b({ attrs: { enabled: e.enabled, error: e.error } }, "base-input-item", e.$attrs, !1), [i("base-dropdown", { attrs: { enabled: e.enabled, error: e.error }, scopedSlots: e._u([{ key: "content", fn: function() {
    return [i("app-multiselect-content", { attrs: { options: e.options, "options-pool": e.pool, placeholder: e.placeholder, "global-selection": e.globalSelection }, on: { "selection-item-removed": e.onSelectionItemRemoved }, model: { value: e.model, callback: function(n) {
      e.model = n;
    }, expression: "model" } })];
  }, proxy: !0 }, { key: "options", fn: function() {
    return [i("dropdown-options", { attrs: { model: e.model, options: e.options, "options-groups": e.optionsGroups, loading: e.loading, "search-enabled": e.searchEnabled, "search-label": e.searchLabel }, on: { "item-add": e.onItemAdd, "item-remove": e.onItemRemove }, scopedSlots: e._u([{ key: "search", fn: function() {
      return [e._t("search")];
    }, proxy: !0 }, { key: "controls", fn: function() {
      return [e._t("controls"), e.globalSelection ? i("dropdown-control-global", { attrs: { options: e.options, option: e.globalSelection }, model: { value: e.model, callback: function(n) {
        e.model = n;
      }, expression: "model" } }) : e._e()];
    }, proxy: !0 }], null, !0) })];
  }, proxy: !0 }]), model: { value: e.optionsVisible, callback: function(n) {
    e.optionsVisible = n;
  }, expression: "optionsVisible" } })], 1);
}, Dr = [], Lr = /* @__PURE__ */ _(
  Or,
  Tr,
  Dr,
  !1,
  null,
  "d525abbd"
);
const jr = Lr.exports, Br = b({
  props: {
    value: {
      type: Boolean,
      required: !0
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    placement: {
      type: String,
      default: "bottom"
    },
    control: {
      type: String,
      default: "auto"
    },
    floatingStyle: {
      type: Object,
      required: !1
    }
  },
  mounted() {
    const t = this.$el;
    t.addEventListener("focusin", this.listenerFocusin), t.addEventListener("focusout", this.listenerFocusout), t.addEventListener("keyup", this.listenerKeyup);
  },
  unmounted() {
    const t = this.$el;
    t.removeEventListener("focusin", this.listenerFocusin), t.removeEventListener("focusout", this.listenerFocusout), t.removeEventListener("keyup", this.listenerKeyup);
  },
  watch: {
    value() {
      ve(() => {
        this.updateFloatingPosition();
      });
    }
  },
  computed: {
    disabled() {
      return !this.enabled;
    }
  },
  methods: {
    $contains(t) {
      const e = this.$refs.container;
      return e == null ? void 0 : e.contains(t);
    },
    listenerFocusin(t) {
      this.$contains(t.target) && this.onShow();
    },
    listenerFocusout(t) {
      this.$contains(t.relatedTarget) || this.onHide();
    },
    listenerKeyup(t) {
      var e;
      ((e = t.key) == null ? void 0 : e.toUpperCase()) === "ESCAPE" && this.onHide();
    },
    updateFloatingPosition() {
      const t = this.$refs.container, e = this.$refs.floating;
      e && wt(t, e, {
        placement: this.placement,
        middleware: [di(8), _t()]
      }).then(({ x: i, y: n }) => {
        Object.assign(e.style, {
          left: `${i}px`,
          top: `${n}px`
        });
      });
    },
    onShow() {
      this.enabled && (this.control === "auto" ? this.$emit("input", !0) : this.$emit("show-floating"));
    },
    onHide() {
      this.enabled && (this.control === "auto" ? this.$emit("input", !1) : this.$emit("hide-floating"));
    }
  }
});
var Fr = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("div", { ref: "container", staticClass: "app-floating", attrs: { tabindex: e.enabled ? 0 : -1 }, on: { click: e.onShow } }, [e._t("content"), i("transition", { attrs: { mode: "out-in", name: "dropdown-slide" } }, [e.value ? i("div", { ref: "floating", staticClass: "floating", style: e.floatingStyle }, [e._t("options")], 2) : e._e()])], 2);
}, Wr = [], Nr = /* @__PURE__ */ _(
  Br,
  Fr,
  Wr,
  !1,
  null,
  "b90bfdc0"
);
const qr = Nr.exports, Hr = b({
  props: {
    enabled: {
      type: Boolean,
      default: !0
    },
    placement: {
      type: String,
      default: "bottom"
    }
  },
  data() {
    return {
      opened: !1
    };
  },
  mounted() {
    const t = this.$el;
    t.addEventListener("mouseenter", this.listenerMouseEnter), t.addEventListener("mouseleave", this.listenerMouseLeave);
  },
  unmounted() {
    const t = this.$el;
    t.removeEventListener("mouseenter", this.listenerMouseEnter), t.removeEventListener("mouseleave", this.listenerMouseLeave);
  },
  watch: {
    opened() {
      ve(() => {
        this.updateFloatingPosition();
      });
    }
  },
  methods: {
    listenerMouseEnter(t) {
      this.onShow();
    },
    listenerMouseLeave(t) {
      this.onHide();
    },
    updateFloatingPosition() {
      const t = this.$refs.container, e = this.$refs.floating;
      e && wt(t, e, {
        placement: this.placement,
        middleware: [_t()]
      }).then(({ x: i, y: n }) => {
        Object.assign(e.style, {
          left: `${i}px`,
          top: `${n}px`
        });
      });
    },
    onShow() {
      this.enabled && (this.opened = !0);
    },
    onHide() {
      this.opened = !1;
    }
  }
});
var Vr = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("div", { ref: "container", staticClass: "app-floating-hover" }, [e._t("content"), i("transition", { attrs: { mode: "out-in", name: "hover-fade" } }, [e.opened ? i("div", { ref: "floating", staticClass: "floating" }, [e._t("floating")], 2) : e._e()])], 2);
}, Ur = [], Yr = /* @__PURE__ */ _(
  Hr,
  Vr,
  Ur,
  !1,
  null,
  "c737b8ef"
);
const Xr = Yr.exports, Gr = b({
  props: {
    currentImage: {
      type: String,
      required: !1
    },
    placeholder: {
      type: String,
      required: !0
    },
    required: {
      type: Boolean,
      default: !1
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      src: "",
      type: ""
    };
  },
  computed: {
    disabled() {
      return !this.enabled;
    }
  },
  methods: {
    onClickInput() {
      const t = this;
      t.enabled && t.$refs.file.click();
    },
    loadImage(t) {
      const e = this, { files: i } = t.target;
      if (i && i[0]) {
        e.src && URL.revokeObjectURL(e.src);
        const n = URL.createObjectURL(i[0]);
        this.$emit("blob-loaded", i[0]), e.src = n, e.type = i[0].type, this.$emit("image-loaded", { src: e.src, type: e.type }), e.$refs.file.value = "";
      }
    }
  }
});
var Zr = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("base-input-item", e._b({ staticClass: "app-image-input", attrs: { enabled: e.enabled, required: e.required, error: e.error } }, "base-input-item", e.$attrs, !1), [i("div", { staticClass: "input-content", class: { disabled: e.disabled, error: e.error }, attrs: { tabindex: e.enabled ? 0 : -1, role: "input" }, on: { click: e.onClickInput, keypress: function(n) {
    return !n.type.indexOf("key") && e._k(n.keyCode, "enter", 13, n.key, "Enter") ? null : (n.stopPropagation(), e.onClickInput.apply(null, arguments));
  } } }, [i("app-image", e._b({ staticClass: "app-image", attrs: { src: e.currentImage } }, "app-image", e.$attrs, !1)), i("div", { staticClass: "inner-text", class: { thin: e.$attrs.ratio && parseFloat(e.$attrs.ratio) > 3 } }, [e.currentImage ? e._e() : i("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-solid fa-camera" } }), e.currentImage ? e._e() : i("span", { staticClass: "placeholder" }, [e._v(e._s(e.placeholder))])], 1), i("input", { ref: "file", staticClass: "hidden-file-input", attrs: { type: "file" }, on: { change: function(n) {
    return e.loadImage(n);
  } } })], 1)]);
}, Kr = [], Qr = /* @__PURE__ */ _(
  Gr,
  Zr,
  Kr,
  !1,
  null,
  "450a3024"
);
const Jr = Qr.exports, eo = b({
  props: {
    value: String,
    rows: {
      type: Number,
      default: 4
    },
    placeholder: {
      type: String,
      default: ""
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    error: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String,
      default: () => self.crypto.randomUUID()
    },
    maxLength: {
      type: Number,
      required: !1
    }
  },
  computed: {
    disabled() {
      return !this.enabled;
    }
  },
  methods: {
    updateModel(t) {
      var e;
      this.$emit("input", (e = t == null ? void 0 : t.target) == null ? void 0 : e.value);
    },
    onFocus(t) {
      this.$emit("focus", t);
    },
    onBlur(t) {
      this.$emit("blur", t);
    },
    onKeydown(t) {
      this.$emit("keydown", t);
    },
    onPaste(t) {
      this.$emit("paste", t);
    }
  }
});
var to = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("base-input-item", e._b({ staticClass: "app-text-area", attrs: { enabled: e.enabled, error: e.error } }, "base-input-item", e.$attrs, !1), [i("textarea", { staticClass: "text-area", class: { error: e.error, disabled: e.disabled }, attrs: { id: e.id, placeholder: e.placeholder, disabled: e.disabled, maxlength: e.maxLength, rows: e.rows }, domProps: { value: e.value }, on: { input: e.updateModel, focus: e.onFocus, blur: e.onBlur, keydown: e.onKeydown, paste: e.onPaste } })]);
}, io = [], no = /* @__PURE__ */ _(
  eo,
  to,
  io,
  !1,
  null,
  "ce973a5a"
);
const so = no.exports, ro = b({
  props: {
    autocomplete: {
      type: String,
      required: !1
    }
  }
});
var oo = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("base-input-item", e._b({ staticClass: "app-text-input" }, "base-input-item", e.$attrs, !1), [i("base-input-text", e._g(e._b({ attrs: { autocomplete: e.autocomplete } }, "base-input-text", e.$attrs, !1), e.$listeners))], 1);
}, ao = [], lo = /* @__PURE__ */ _(
  ro,
  oo,
  ao,
  !1,
  null,
  "55abcfdf"
);
const Ci = lo.exports, co = b({
  props: {
    value: {
      type: Number
    },
    fractionDigits: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      innerValue: void 0
    };
  },
  watch: {
    value: {
      handler(t) {
        t === void 0 ? this.innerValue = void 0 : this.innerValue = this.numberToString(t), this.onInput(this.innerValue);
      },
      immediate: !0
    }
  },
  computed: {
    formatter() {
      return new Intl.NumberFormat(void 0, {
        style: "decimal",
        minimumFractionDigits: this.fractionDigits,
        maximumFractionDigits: this.fractionDigits
      });
    }
  },
  methods: {
    onBlur(t) {
      this.$emit("blur", t);
    },
    onInput(t) {
      if (t === void 0) {
        this.$emit("input", void 0);
        return;
      }
      const e = this.stringToNumber(t);
      ve(() => {
        this.innerValue = this.numberToString(e);
      }), this.$emit("input", e);
    },
    numberToString(t) {
      return this.formatter.format(t);
    },
    stringToNumber(t) {
      const e = t.replace(/\D/g, "");
      return parseInt(e || "0") / Math.pow(10, this.fractionDigits);
    }
  }
});
var uo = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("base-input-item", e._b({ staticClass: "app-number-input" }, "base-input-item", e.$attrs, !1), [i("base-input-text", e._b({ on: { paste: function(n) {
    n.preventDefault();
  }, input: e.onInput, blur: e.onBlur }, model: { value: e.innerValue, callback: function(n) {
    e.innerValue = n;
  }, expression: "innerValue" } }, "base-input-text", e.$attrs, !1))], 1);
}, ho = [], po = /* @__PURE__ */ _(
  co,
  uo,
  ho,
  !1,
  null,
  "69d08711"
);
const fo = po.exports, mo = b({
  props: {
    value: String,
    enabled: {
      type: Boolean,
      default: !0
    },
    debounceTimeout: {
      type: Number,
      required: !1
    }
  },
  data() {
    return {
      iconSize: 20,
      timer: null
    };
  },
  methods: {
    updateModel(t) {
      this.$emit("input", t), this.debounce(t);
    },
    emitDebounced(t) {
      this.$emit("debounced", t);
    },
    debounce(t) {
      if (!this.debounceTimeout || this.debounceTimeout < 1) {
        this.timer = null;
        return;
      }
      const e = this.timer ?? void 0;
      clearTimeout(e), this.$emit("dirty"), this.timer = setTimeout(() => {
        this.emitDebounced(t);
      }, this.debounceTimeout);
    }
  }
});
var go = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("base-input-item", e._b({ staticClass: "app-search-input" }, "base-input-item", e.$attrs, !1), [i("base-input-text", e._g(e._b({ attrs: { enabled: e.enabled, value: e.value }, on: { input: e.updateModel }, scopedSlots: e._u([{ key: "start", fn: function() {
    return [i("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-regular fa-magnifying-glass" } })];
  }, proxy: !0 }]) }, "base-input-text", e.$attrs, !1), e.$listeners))], 1);
}, vo = [], bo = /* @__PURE__ */ _(
  mo,
  go,
  vo,
  !1,
  null,
  "d740c63e"
);
const _o = bo.exports, yo = b({
  props: {
    enabled: {
      type: Boolean,
      default: !0
    },
    showVisibilityToggle: {
      type: Boolean,
      default: !0
    },
    autocomplete: {
      type: String,
      required: !1
    }
  },
  data() {
    return {
      passwordVisible: !1,
      iconSize: 20
    };
  },
  computed: {
    inputType() {
      return this.passwordVisible ? "text" : "password";
    }
  },
  methods: {
    onTogglePasswordVisible() {
      this.passwordVisible = !this.passwordVisible;
    }
  }
});
var wo = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("base-input-item", e._b({ staticClass: "app-password-input" }, "base-input-item", e.$attrs, !1), [i("base-input-text", e._g(e._b({ attrs: { enabled: e.enabled, "input-type": e.inputType, autocomplete: e.autocomplete }, scopedSlots: e._u([e.showVisibilityToggle ? { key: "end", fn: function() {
    return [i("app-icon-button", { attrs: { enabled: e.enabled, padding: 6, "aria-label": "Toggle password visibility" }, on: { click: e.onTogglePasswordVisible } }, [e.passwordVisible ? i("app-icon", { attrs: { size: e.iconSize, src: "/eye-closed.svg" } }) : i("app-icon", { attrs: { size: e.iconSize, src: "/eye-open.svg" } })], 1)];
  }, proxy: !0 } : null], null, !0) }, "base-input-text", e.$attrs, !1), e.$listeners))], 1);
}, $o = [], xo = /* @__PURE__ */ _(
  yo,
  wo,
  $o,
  !1,
  null,
  "f54a946d"
);
const Co = xo.exports, So = b({
  props: {
    label: {
      type: String,
      required: !1
    },
    tooltip: {
      type: String,
      required: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    disabled() {
      return !this.enabled;
    },
    tooltipVisible() {
      return !!this.label && !!this.tooltip && this.enabled;
    }
  }
});
var Ao = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("div", { staticClass: "base-input-label", class: { disabled: e.disabled, error: e.error } }, [e.label ? i("div", { staticClass: "label" }, [e._v(" " + e._s(e.label)), e.required ? i("span", [e._v("*")]) : e._e()]) : e._e(), e.tooltipVisible ? i("app-tooltip", { attrs: { tooltip: e.tooltip, enabled: e.enabled } }) : e._e()], 1);
}, Ro = [], Mo = /* @__PURE__ */ _(
  So,
  Ao,
  Ro,
  !1,
  null,
  "bf59376c"
);
const Si = Mo.exports, zo = b({
  props: {
    errors: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    errorMessage() {
      return this.errors.length > 0 ? this.errors[0] : void 0;
    }
  }
});
var ko = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, e.errorMessage ? i("div", { staticClass: "base-input-error" }, [e._v(" " + e._s(e.errorMessage) + " ")]) : e._e();
}, Po = [], Eo = /* @__PURE__ */ _(
  zo,
  ko,
  Po,
  !1,
  null,
  "aee55638"
);
const Ai = Eo.exports, Io = b({
  components: {
    BaseInputLabel: Si,
    BaseInputError: Ai
  },
  props: {
    label: {
      type: String,
      required: !1
    },
    tooltip: {
      type: String,
      required: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    error: {
      type: Boolean,
      default: !1
    },
    errors: {
      type: Array,
      default: () => []
    },
    validationKey: {
      type: String,
      required: !1
    },
    validationReport: {
      type: Object,
      required: !1
    }
  },
  computed: {
    hasLabel() {
      return !!this.label;
    },
    validationAvailable() {
      return !!this.validationKey && !!this.validationReport;
    },
    validationError() {
      var t, e;
      if (this.validationAvailable) {
        const i = (e = (t = this.validationReport) == null ? void 0 : t.field) == null ? void 0 : e.call(t, this.validationKey);
        return (i == null ? void 0 : i.error) ?? !1;
      } else
        return this.error;
    }
  }
});
var Oo = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("div", { staticClass: "base-input-item" }, [e.hasLabel ? i("base-input-label", { attrs: { label: e.label, tooltip: e.tooltip, required: e.required, enabled: e.enabled, error: e.validationError } }) : e._e(), e._t("default"), i("base-input-error", { attrs: { errors: e.errors } })], 2);
}, To = [], Do = /* @__PURE__ */ _(
  Io,
  Oo,
  To,
  !1,
  null,
  "acafcdc7"
);
const Lo = Do.exports, jo = b({
  props: {
    value: {
      type: String,
      default: ""
    },
    inputType: {
      type: String,
      default: "text"
    },
    placeholder: {
      type: String,
      default: ""
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    error: {
      type: Boolean,
      default: !1
    },
    autocomplete: {
      type: String,
      required: !1
    },
    inputmode: {
      type: String,
      required: !1
    },
    max: {
      // for date inputs
      type: String,
      required: !1
    },
    min: {
      // for date inputs
      type: String,
      required: !1
    }
  },
  computed: {
    disabled() {
      return !this.enabled;
    },
    validationStyle() {
      return { error: this.error };
    },
    hasSlotStart() {
      return !!this.$slots.start;
    },
    hasSlotEnd() {
      return !!this.$slots.end;
    }
  },
  methods: {
    updateModel(t) {
      var e;
      this.$emit("input", (e = t == null ? void 0 : t.target) == null ? void 0 : e.value);
    },
    onFocus(t) {
      this.$emit("focus", t);
    },
    onBlur(t) {
      this.$emit("blur", t);
    },
    onKeydown(t) {
      this.$emit("keydown", t);
    },
    onPaste(t) {
      this.$emit("paste", t);
    }
  }
});
var Bo = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("div", { staticClass: "base-input-text", class: { error: e.error, disabled: e.disabled } }, [e.hasSlotStart ? i("div", { staticClass: "slot-start" }, [e._t("start")], 2) : e._e(), i("input", { staticClass: "text-input", attrs: { autocomplete: e.autocomplete, inputmode: e.inputmode, type: e.inputType, placeholder: e.placeholder, disabled: e.disabled, max: e.max, min: e.min }, domProps: { value: e.value }, on: { input: e.updateModel, focus: e.onFocus, blur: e.onBlur, keydown: e.onKeydown, paste: e.onPaste } }), e.hasSlotEnd ? i("div", { staticClass: "slot-end" }, [e._t("end")], 2) : e._e()]);
}, Fo = [], Wo = /* @__PURE__ */ _(
  jo,
  Bo,
  Fo,
  !1,
  null,
  "2f69218d"
);
const No = Wo.exports, qo = b({
  props: {
    align: {
      type: String,
      default: "start",
      validator(t) {
        return ["start", "center", "end"].includes(t);
      }
    },
    theme: {
      type: String,
      default: "white",
      validator(t) {
        return ["white", "gray"].includes(t);
      }
    }
  }
});
var Ho = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("div", { staticClass: "app-button-sheet", class: [e.theme, e.align] }, [e._t("default")], 2);
}, Vo = [], Uo = /* @__PURE__ */ _(
  qo,
  Ho,
  Vo,
  !1,
  null,
  "aca1171a"
);
const Yo = Uo.exports, Xo = ue.extend({
  name: "AppCarousel",
  data() {
    return {
      carousel: null,
      scrollPosition: 0,
      carouselWidth: 0
    };
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    itemsPerPage: {
      type: Number,
      default: 4
    },
    itemsPerScroll: {
      type: Number,
      default: 1
    },
    displayItemFullWidth: {
      type: Number,
      required: !1
    },
    loop: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    slideWidth() {
      return {
        width: this.itemsPerPage === 1 && this.carouselWidth < this.displayItemFullWidth ? "100%" : `${80 / this.itemsPerPage}%`
      };
    },
    showPrevButton() {
      return this.loop || this.scrollPosition > 0;
    },
    showNextButton() {
      var e, i;
      const t = ((e = this.carousel) == null ? void 0 : e.scrollWidth) - this.carouselWidth || 1;
      return ((i = this.items) == null ? void 0 : i.length) > this.itemsPerPage && (this.loop || this.scrollPosition < t);
    },
    prevDelta() {
      return this.itemsPerScroll * -1;
    },
    nextDelta() {
      return this.itemsPerScroll;
    }
  },
  mounted() {
    window.addEventListener("resize", this.setCarouselWidth), setTimeout(this.setCarouselWidth, 500);
  },
  destroyed() {
    window.removeEventListener("resize", this.setCarouselWidth);
  },
  methods: {
    changeSlide(t = 1) {
      var e;
      (e = this.carousel) == null || e.scrollTo(
        this.carousel.scrollLeft + this.carouselWidth * t,
        0
      );
    },
    prev() {
      this.changeSlide(this.prevDelta / this.itemsPerPage);
    },
    next() {
      this.changeSlide(this.nextDelta / this.itemsPerPage);
    },
    onScroll() {
      var t;
      this.scrollPosition = ((t = this.carousel) == null ? void 0 : t.scrollLeft) ?? 0;
    },
    setCarouselWidth() {
      var t;
      this.carousel = this.$el.querySelector(".carousel"), this.carouselWidth = ((t = this.carousel) == null ? void 0 : t.offsetWidth) ?? 0;
    }
  }
});
var Go = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("div", { staticClass: "carousel-container" }, [i("div", { staticClass: "carousel", on: { scroll: e.onScroll } }, [e._t("add"), e._l(e.items, function(n, s) {
    return i("div", { key: s, staticClass: "slide", style: e.slideWidth }, [e._t("default", null, { item: n })], 2);
  })], 2), e.showPrevButton ? i("fa-icon-compat", { staticClass: "slide-arrow prev", attrs: { icon: "fa-solid fa-chevron-left" }, nativeOn: { click: function(n) {
    return n.stopPropagation(), e.prev.apply(null, arguments);
  } } }) : e._e(), e.showNextButton ? i("fa-icon-compat", { staticClass: "slide-arrow next", attrs: { icon: "fa-solid fa-chevron-right" }, nativeOn: { click: function(n) {
    return n.stopPropagation(), e.next.apply(null, arguments);
  } } }) : e._e()], 1);
}, Zo = [], Ko = /* @__PURE__ */ _(
  Xo,
  Go,
  Zo,
  !1,
  null,
  "9d2c5425"
);
const Qo = Ko.exports;
ue.util.warn;
function Vt(t, e) {
  var i = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function oe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var i = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Vt(Object(i), !0).forEach(function(n) {
      Jo(t, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : Vt(Object(i)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return t;
}
function Jo(t, e, i) {
  return e in t ? Object.defineProperty(t, e, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = i, t;
}
function Ut(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return Object.keys(t).reduce((i, n) => (e.includes(n) || (i[n] = R(t[n])), i), {});
}
function He(t) {
  return typeof t == "function";
}
function ea(t) {
  return Li(t) || ji(t);
}
function Ri(t, e, i) {
  let n = t;
  const s = e.split(".");
  for (let r = 0; r < s.length; r++) {
    if (!n[s[r]]) return i;
    n = n[s[r]];
  }
  return n;
}
function rt(t, e, i) {
  return z(() => t.some((n) => Ri(e, n, {
    [i]: !1
  })[i]));
}
function Yt(t, e, i) {
  return z(() => t.reduce((n, s) => {
    const r = Ri(e, s, {
      [i]: !1
    })[i] || [];
    return n.concat(r);
  }, []));
}
function Mi(t, e, i, n) {
  return t.call(n, R(e), R(i), n);
}
function zi(t) {
  return t.$valid !== void 0 ? !t.$valid : !t;
}
function ta(t, e, i, n, s, r, l) {
  let {
    $lazy: a,
    $rewardEarly: o
  } = s, c = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : [], d = arguments.length > 8 ? arguments[8] : void 0, u = arguments.length > 9 ? arguments[9] : void 0, p = arguments.length > 10 ? arguments[10] : void 0;
  const f = W(!!n.value), h = W(0);
  i.value = !1;
  const m = Se([e, n].concat(c, p), () => {
    if (a && !n.value || o && !u.value && !i.value)
      return;
    let g;
    try {
      g = Mi(t, e, d, l);
    } catch (v) {
      g = Promise.reject(v);
    }
    h.value++, i.value = !!h.value, f.value = !1, Promise.resolve(g).then((v) => {
      h.value--, i.value = !!h.value, r.value = v, f.value = zi(v);
    }).catch((v) => {
      h.value--, i.value = !!h.value, r.value = v, f.value = !0;
    });
  }, {
    immediate: !0,
    deep: typeof e == "object"
  });
  return {
    $invalid: f,
    $unwatch: m
  };
}
function ia(t, e, i, n, s, r, l, a) {
  let {
    $lazy: o,
    $rewardEarly: c
  } = n;
  const d = () => ({}), u = z(() => {
    if (o && !i.value || c && !a.value)
      return !1;
    let p = !0;
    try {
      const f = Mi(t, e, l, r);
      s.value = f, p = zi(f);
    } catch (f) {
      s.value = f;
    }
    return p;
  });
  return {
    $unwatch: d,
    $invalid: u
  };
}
function na(t, e, i, n, s, r, l, a, o, c, d) {
  const u = W(!1), p = t.$params || {}, f = W(null);
  let h, m;
  t.$async ? {
    $invalid: h,
    $unwatch: m
  } = ta(t.$validator, e, u, i, n, f, s, t.$watchTargets, o, c, d) : {
    $invalid: h,
    $unwatch: m
  } = ia(t.$validator, e, i, n, f, s, o, c);
  const g = t.$message;
  return {
    $message: He(g) ? z(() => g(Ut({
      $pending: u,
      $invalid: h,
      $params: Ut(p),
      $model: e,
      $response: f,
      $validator: r,
      $propertyPath: a,
      $property: l
    }))) : g || "",
    $params: p,
    $pending: u,
    $invalid: h,
    $response: f,
    $unwatch: m
  };
}
function sa() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const e = R(t), i = Object.keys(e), n = {}, s = {}, r = {};
  let l = null;
  return i.forEach((a) => {
    const o = e[a];
    switch (!0) {
      case He(o.$validator):
        n[a] = o;
        break;
      case He(o):
        n[a] = {
          $validator: o
        };
        break;
      case a === "$validationGroups":
        l = o;
        break;
      case a.startsWith("$"):
        r[a] = o;
        break;
      default:
        s[a] = o;
    }
  }), {
    rules: n,
    nestedValidators: s,
    config: r,
    validationGroups: l
  };
}
const ra = "__root";
function oa(t, e, i, n, s, r, l, a, o) {
  const c = Object.keys(t), d = n.get(s, t), u = W(!1), p = W(!1), f = W(0);
  if (d) {
    if (!d.$partial) return d;
    d.$unwatch(), u.value = d.$dirty.value;
  }
  const h = {
    $dirty: u,
    $path: s,
    $touch: () => {
      u.value || (u.value = !0);
    },
    $reset: () => {
      u.value && (u.value = !1);
    },
    $commit: () => {
    }
  };
  return c.length ? (c.forEach((m) => {
    h[m] = na(t[m], e, h.$dirty, r, l, m, i, s, o, p, f);
  }), h.$externalResults = z(() => a.value ? [].concat(a.value).map((m, g) => ({
    $propertyPath: s,
    $property: i,
    $validator: "$externalResults",
    $uid: `${s}-externalResult-${g}`,
    $message: m,
    $params: {},
    $response: null,
    $pending: !1
  })) : []), h.$invalid = z(() => {
    const m = c.some((g) => R(h[g].$invalid));
    return p.value = m, !!h.$externalResults.value.length || m;
  }), h.$pending = z(() => c.some((m) => R(h[m].$pending))), h.$error = z(() => h.$dirty.value ? h.$pending.value || h.$invalid.value : !1), h.$silentErrors = z(() => c.filter((m) => R(h[m].$invalid)).map((m) => {
    const g = h[m];
    return ft({
      $propertyPath: s,
      $property: i,
      $validator: m,
      $uid: `${s}-${m}`,
      $message: g.$message,
      $params: g.$params,
      $response: g.$response,
      $pending: g.$pending
    });
  }).concat(h.$externalResults.value)), h.$errors = z(() => h.$dirty.value ? h.$silentErrors.value : []), h.$unwatch = () => c.forEach((m) => {
    h[m].$unwatch();
  }), h.$commit = () => {
    p.value = !0, f.value = Date.now();
  }, n.set(s, t, h), h) : (d && n.set(s, t, h), h);
}
function aa(t, e, i, n, s, r, l) {
  const a = Object.keys(t);
  return a.length ? a.reduce((o, c) => (o[c] = pt({
    validations: t[c],
    state: e,
    key: c,
    parentKey: i,
    resultsCache: n,
    globalConfig: s,
    instance: r,
    externalResults: l
  }), o), {}) : {};
}
function la(t, e, i) {
  const n = z(() => [e, i].filter((h) => h).reduce((h, m) => h.concat(Object.values(R(m))), [])), s = z({
    get() {
      return t.$dirty.value || (n.value.length ? n.value.every((h) => h.$dirty) : !1);
    },
    set(h) {
      t.$dirty.value = h;
    }
  }), r = z(() => {
    const h = R(t.$silentErrors) || [], m = n.value.filter((g) => (R(g).$silentErrors || []).length).reduce((g, v) => g.concat(...v.$silentErrors), []);
    return h.concat(m);
  }), l = z(() => {
    const h = R(t.$errors) || [], m = n.value.filter((g) => (R(g).$errors || []).length).reduce((g, v) => g.concat(...v.$errors), []);
    return h.concat(m);
  }), a = z(() => n.value.some((h) => h.$invalid) || R(t.$invalid) || !1), o = z(() => n.value.some((h) => R(h.$pending)) || R(t.$pending) || !1), c = z(() => n.value.some((h) => h.$dirty) || n.value.some((h) => h.$anyDirty) || s.value), d = z(() => s.value ? o.value || a.value : !1), u = () => {
    t.$touch(), n.value.forEach((h) => {
      h.$touch();
    });
  }, p = () => {
    t.$commit(), n.value.forEach((h) => {
      h.$commit();
    });
  }, f = () => {
    t.$reset(), n.value.forEach((h) => {
      h.$reset();
    });
  };
  return n.value.length && n.value.every((h) => h.$dirty) && u(), {
    $dirty: s,
    $errors: l,
    $invalid: a,
    $anyDirty: c,
    $error: d,
    $pending: o,
    $touch: u,
    $reset: f,
    $silentErrors: r,
    $commit: p
  };
}
function pt(t) {
  let {
    validations: e,
    state: i,
    key: n,
    parentKey: s,
    childResults: r,
    resultsCache: l,
    globalConfig: a = {},
    instance: o,
    externalResults: c
  } = t;
  const d = s ? `${s}.${n}` : n, {
    rules: u,
    nestedValidators: p,
    config: f,
    validationGroups: h
  } = sa(e), m = oe(oe({}, a), f), g = n ? z(() => {
    const k = R(i);
    return k ? R(k[n]) : void 0;
  }) : i, v = oe({}, R(c) || {}), x = z(() => {
    const k = R(c);
    return n ? k ? R(k[n]) : void 0 : k;
  }), $ = oa(u, g, n, l, d, m, o, x, i), y = aa(p, g, d, l, m, o, x), C = {};
  h && Object.entries(h).forEach((k) => {
    let [ce, se] = k;
    C[ce] = {
      $invalid: rt(se, y, "$invalid"),
      $error: rt(se, y, "$error"),
      $pending: rt(se, y, "$pending"),
      $errors: Yt(se, y, "$errors"),
      $silentErrors: Yt(se, y, "$silentErrors")
    };
  });
  const {
    $dirty: M,
    $errors: pe,
    $invalid: j,
    $anyDirty: X,
    $error: G,
    $pending: Z,
    $touch: ie,
    $reset: ze,
    $silentErrors: K,
    $commit: we
  } = la($, y, r), le = n ? z({
    get: () => R(g),
    set: (k) => {
      M.value = !0;
      const ce = R(i), se = R(c);
      se && (se[n] = v[n]), ot(ce[n]) ? ce[n].value = k : ce[n] = k;
    }
  }) : null;
  n && m.$autoDirty && Se(g, () => {
    M.value || ie();
    const k = R(c);
    k && (k[n] = v[n]);
  }, {
    flush: "sync"
  });
  async function ne() {
    return ie(), m.$rewardEarly && (we(), await ve()), await ve(), new Promise((k) => {
      if (!Z.value) return k(!j.value);
      const ce = Se(Z, () => {
        k(!j.value), ce();
      });
    });
  }
  function N(k) {
    return (r.value || {})[k];
  }
  function q() {
    ot(c) ? c.value = v : Object.keys(v).length === 0 ? Object.keys(c).forEach((k) => {
      delete c[k];
    }) : Object.assign(c, v);
  }
  return ft(oe(oe(oe({}, $), {}, {
    $model: le,
    $dirty: M,
    $error: G,
    $errors: pe,
    $invalid: j,
    $anyDirty: X,
    $pending: Z,
    $touch: ie,
    $reset: ze,
    $path: d || ra,
    $silentErrors: K,
    $validate: ne,
    $commit: we
  }, r && {
    $getResultsForChild: N,
    $clearExternalResults: q,
    $validationGroups: C
  }), y));
}
class ca {
  constructor() {
    this.storage = /* @__PURE__ */ new Map();
  }
  set(e, i, n) {
    this.storage.set(e, {
      rules: i,
      result: n
    });
  }
  checkRulesValidity(e, i, n) {
    const s = Object.keys(n), r = Object.keys(i);
    return r.length !== s.length || !r.every((a) => s.includes(a)) ? !1 : r.every((a) => i[a].$params ? Object.keys(i[a].$params).every((o) => R(n[a].$params[o]) === R(i[a].$params[o])) : !0);
  }
  get(e, i) {
    const n = this.storage.get(e);
    if (!n) return;
    const {
      rules: s,
      result: r
    } = n, l = this.checkRulesValidity(e, i, s), a = r.$unwatch ? r.$unwatch : () => ({});
    return l ? r : {
      $dirty: r.$dirty,
      $partial: !0,
      $unwatch: a
    };
  }
}
const Le = {
  COLLECT_ALL: !0,
  COLLECT_NONE: !1
}, Xt = Symbol("vuelidate#injectChildResults"), Gt = Symbol("vuelidate#removeChildResults");
function ua(t) {
  let {
    $scope: e,
    instance: i
  } = t;
  const n = {}, s = W([]), r = z(() => s.value.reduce((d, u) => (d[u] = R(n[u]), d), {}));
  function l(d, u) {
    let {
      $registerAs: p,
      $scope: f,
      $stopPropagation: h
    } = u;
    h || e === Le.COLLECT_NONE || f === Le.COLLECT_NONE || e !== Le.COLLECT_ALL && e !== f || (n[p] = d, s.value.push(p));
  }
  i.__vuelidateInjectInstances = [].concat(i.__vuelidateInjectInstances || [], l);
  function a(d) {
    s.value = s.value.filter((u) => u !== d), delete n[d];
  }
  i.__vuelidateRemoveInstances = [].concat(i.__vuelidateRemoveInstances || [], a);
  const o = St(Xt, []);
  At(Xt, i.__vuelidateInjectInstances);
  const c = St(Gt, []);
  return At(Gt, i.__vuelidateRemoveInstances), {
    childResults: r,
    sendValidationResultsToParent: o,
    removeValidationResultsFromParent: c
  };
}
function ki(t) {
  return new Proxy(t, {
    get(e, i) {
      return typeof e[i] == "object" ? ki(e[i]) : z(() => e[i]);
    }
  });
}
let Zt = 0;
function da(t, e) {
  var i;
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  arguments.length === 1 && (n = t, t = void 0, e = void 0);
  let {
    $registerAs: s,
    $scope: r = Le.COLLECT_ALL,
    $stopPropagation: l,
    $externalResults: a,
    currentVueInstance: o
  } = n;
  const c = o || ((i = Oi()) === null || i === void 0 ? void 0 : i.proxy), d = c ? c.$options : {};
  s || (Zt += 1, s = `_vuelidate_${Zt}`);
  const u = W({}), p = new ca(), {
    childResults: f,
    sendValidationResultsToParent: h,
    removeValidationResultsFromParent: m
  } = c ? ua({
    $scope: r,
    instance: c
  }) : {
    childResults: W({})
  };
  if (!t && d.validations) {
    const g = d.validations;
    e = W({}), Ti(() => {
      e.value = c, Se(() => He(g) ? g.call(e.value, new ki(e.value)) : g, (v) => {
        u.value = pt({
          validations: v,
          state: e,
          childResults: f,
          resultsCache: p,
          globalConfig: n,
          instance: c,
          externalResults: a || c.vuelidateExternalResults
        });
      }, {
        immediate: !0
      });
    }), n = d.validationsConfig || n;
  } else {
    const g = ot(t) || ea(t) ? t : ft(t || {});
    Se(g, (v) => {
      u.value = pt({
        validations: v,
        state: e,
        childResults: f,
        resultsCache: p,
        globalConfig: n,
        instance: c ?? {},
        externalResults: a
      });
    }, {
      immediate: !0
    });
  }
  return c && (h.forEach((g) => g(u, {
    $registerAs: s,
    $scope: r,
    $stopPropagation: l
  })), Di(() => m.forEach((g) => g(s)))), z(() => oe(oe({}, R(u.value)), f.value));
}
function ha(t, e) {
  return e.split(".").reduce((n, s) => n && n[s], t);
}
class pa {
  constructor(e) {
    $e(this, "vuelidate");
    this.vuelidate = e;
  }
  update(e) {
    return this.vuelidate = e, this;
  }
  field(e) {
    const i = ha(this.vuelidate, e);
    return {
      required: i ? i.required : !1,
      dirty: i ? i.$dirty : !1,
      valid: i ? i.$invalid : !0,
      error: i ? i.$error : !1,
      errorMessages: ((i == null ? void 0 : i.$errors) ?? []).map((n) => n.$message.toString())
    };
  }
  touch(e) {
    console.log("TOUCHED", e);
  }
}
const fa = b({
  setup(t) {
    return { v$: t.validation ? da() : void 0 };
  },
  props: {
    value: {
      type: Object,
      required: !1
    },
    autoSubmit: {
      type: Boolean,
      default: !1
    },
    debounceTimeout: {
      type: Number,
      default: 500
    },
    form: {
      type: Object,
      required: !1
    },
    validation: {
      type: Object,
      required: !1
    }
  },
  data() {
    return {
      timer: null
    };
  },
  created() {
    if (this.v$) {
      const t = new pa(this.v$);
      this.$emit("input", t);
    }
  },
  validations() {
    return {
      $autoDirty: !0,
      form: this.validation
    };
  },
  watch: {
    v$(t) {
      this.updateModel(t);
    },
    form: {
      handler() {
        this.autoSubmit && (this.$emit("dirty"), this.onDebounce());
      },
      immediate: !0,
      deep: !0
    }
  },
  methods: {
    updateModel(t) {
      var i;
      const e = (i = this.value) == null ? void 0 : i.update(t);
      this.$emit("input", e);
    },
    clearTimer() {
      const t = this.timer ?? void 0;
      clearTimeout(t);
    },
    onDebounce() {
      this.clearTimer(), this.timer = setTimeout(() => {
        this.$emit("submit");
      }, this.debounceTimeout);
    },
    onSubmit() {
      this.clearTimer(), this.$emit("submit");
    }
  }
});
var ma = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("form", { staticClass: "app-form", on: { submit: function(n) {
    return n.preventDefault(), e.onSubmit.apply(null, arguments);
  } } }, [i("input", { attrs: { type: "submit", hidden: "" } }), e._t("default")], 2);
}, ga = [], va = /* @__PURE__ */ _(
  fa,
  ma,
  ga,
  !1,
  null,
  "0efcaddf"
);
const ba = va.exports, _a = b({
  props: {
    src: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      default: ""
    },
    size: {
      type: Number,
      required: !1
    },
    frame: {
      type: String,
      default: "round",
      validator(t) {
        return ["round", "square"].includes(t);
      }
    }
  },
  computed: {
    style() {
      return {
        minWidth: this.size ? `${this.size}px` : "initial",
        width: this.size ? `${this.size}px` : "100%",
        height: this.size ? `${this.size}px` : "100%",
        borderRadius: this.frame === "round" ? "100px" : "inherit"
      };
    }
  }
});
var ya = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("img", { staticClass: "app-icon", style: e.style, attrs: { alt: e.label, src: e.src, tabindex: "-1" } });
}, wa = [], $a = /* @__PURE__ */ _(
  _a,
  ya,
  wa,
  !1,
  null,
  "ee19c68b"
);
const xa = $a.exports, Ca = b({
  props: {
    theme: {
      type: String,
      default: "link",
      validator(t) {
        return ["link", "button", "cta-button"].includes(t);
      }
    },
    target: {
      type: String,
      default: "_self"
    },
    label: String,
    routeName: String,
    routePath: String,
    externalPath: String,
    routeParams: Object
  },
  computed: {
    to() {
      return {
        name: this.routeName,
        path: this.routePath,
        params: this.routeParams
      };
    },
    hasClickListener() {
      return !!this.$listeners.click;
    }
  },
  methods: {
    onClick() {
      this.$emit("click");
    }
  }
});
var Sa = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, e.hasClickListener ? i("span", { staticClass: "app-link", class: e.theme, attrs: { role: "link", tabindex: "0" }, on: { click: e.onClick } }, [e._v(" " + e._s(e.label) + " ")]) : e.externalPath ? i("a", { staticClass: "app-link", class: e.theme, attrs: { href: e.externalPath, target: e.target } }, [e._v(" " + e._s(e.label) + " ")]) : i("router-link", { staticClass: "app-link", class: e.theme, attrs: { to: e.to } }, [e._v(" " + e._s(e.label) + " ")]);
}, Aa = [], Ra = /* @__PURE__ */ _(
  Ca,
  Sa,
  Aa,
  !1,
  null,
  "811f8d0a"
);
const Ma = Ra.exports, za = b({
  props: {
    fullPage: {
      type: Boolean,
      default: !0
    },
    centerContent: {
      type: Boolean,
      default: !1
    },
    theme: {
      type: String,
      default: "dark",
      validator(t) {
        return ["light", "dark"].includes(t);
      }
    }
  },
  methods: {
    onClickBackground() {
      this.$emit("click-background");
    }
  }
});
var ka = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("div", { staticClass: "app-overlay", class: { center: e.centerContent, full: e.fullPage } }, [i("div", { staticClass: "background", class: [e.theme], on: { click: e.onClickBackground } }), e._t("default")], 2);
}, Pa = [], Ea = /* @__PURE__ */ _(
  za,
  ka,
  Pa,
  !1,
  null,
  "b5bd52c1"
);
const Ia = Ea.exports, Oa = b({});
var Ta = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("div", { staticClass: "dot-spin" });
}, Da = [], La = /* @__PURE__ */ _(
  Oa,
  Ta,
  Da,
  !1,
  null,
  "ec71d57d"
);
const ja = La.exports, Ba = b({
  props: {
    message: {
      type: String,
      default: ""
    }
  }
});
var Fa = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("div", { staticClass: "app-toast" }, [e._v(" " + e._s(e.message) + " ")]);
}, Wa = [], Na = /* @__PURE__ */ _(
  Ba,
  Fa,
  Wa,
  !1,
  null,
  "35fb11a9"
);
const qa = Na.exports, Ha = b({
  props: {
    loading: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    onClickOutside() {
      this.$emit("click-outside");
    }
  }
});
var Va = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("app-overlay", { attrs: { "center-content": !0 }, on: { "click-background": e.onClickOutside } }, [i("div", { staticClass: "app-modal" }, [e._t("default")], 2), e.loading ? i("app-overlay", { attrs: { "center-content": !0, theme: "light", "full-page": !1 } }, [i("app-loading")], 1) : e._e()], 1);
}, Ua = [], Ya = /* @__PURE__ */ _(
  Ha,
  Va,
  Ua,
  !1,
  null,
  "49b15398"
);
const Xa = Ya.exports, Ga = b({
  name: "AppConfirmationModal",
  props: {
    loading: {
      type: Boolean,
      default: !1
    },
    extraConfirmation: {
      type: Boolean,
      default: !1
    },
    confirmationLabel: {
      type: String,
      required: !1
    },
    title: {
      type: String
    },
    description: {
      type: String,
      required: !0
    },
    primaryLabel: {
      type: String,
      required: !0
    },
    secondaryLabel: {
      type: String,
      required: !1
    }
  },
  data() {
    return {
      extraConfirmationCheckbox: !1,
      clicked: !1
    };
  },
  computed: {
    isPrimaryEnabled() {
      return (!this.extraConfirmation || this.extraConfirmationCheckbox) && !this.clicked;
    }
  },
  methods: {
    onPrimary() {
      this.clicked = !0, this.$emit("click-primary");
    },
    onSecondary() {
      this.$emit("click-secondary");
    }
  }
});
var Za = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("app-modal", { staticClass: "modal-container", attrs: { loading: e.loading }, on: { "click-outside": e.onSecondary } }, [i("div", { staticClass: "modal-content" }, [e.title ? i("div", { staticClass: "modal-title" }, [e._v(" " + e._s(e.title) + " ")]) : e._e(), i("div", { staticClass: "modal-description" }, [e._v(e._s(e.description))]), e.extraConfirmation ? i("app-checkbox", { attrs: { label: e.confirmationLabel }, model: { value: e.extraConfirmationCheckbox, callback: function(n) {
    e.extraConfirmationCheckbox = n;
  }, expression: "extraConfirmationCheckbox" } }) : e._e()], 1), i("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center" } }, [i("app-button", { attrs: { enabled: e.isPrimaryEnabled, label: e.primaryLabel }, on: { click: e.onPrimary } }), e.secondaryLabel ? i("app-secondary-button", { attrs: { label: e.secondaryLabel }, on: { click: e.onSecondary } }) : e._e()], 1)], 1);
}, Ka = [], Qa = /* @__PURE__ */ _(
  Ga,
  Za,
  Ka,
  !1,
  null,
  "7b330783"
);
const Ja = Qa.exports, el = b({
  props: {
    title: {
      type: String,
      required: !1
    },
    detail: {
      type: String,
      required: !1
    },
    level: {
      type: Number,
      default: 1
    }
  },
  computed: {
    headingVisible() {
      return !!this.title || !!this.detail;
    }
  }
});
var tl = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("section", { staticClass: "app-section" }, [e.headingVisible ? i("app-heading", { attrs: { detail: e.detail, level: e.level, title: e.title }, scopedSlots: e._u([{ key: "action", fn: function() {
    return [e._t("action")];
  }, proxy: !0 }], null, !0) }) : e._e(), e._t("default")], 2);
}, il = [], nl = /* @__PURE__ */ _(
  el,
  tl,
  il,
  !1,
  null,
  null
);
const sl = nl.exports, rl = b({
  name: "AppHeading",
  props: {
    title: {
      type: String,
      required: !1
    },
    detail: {
      type: String,
      required: !1
    },
    action: {
      type: String,
      required: !1
    },
    level: {
      type: Number,
      default: 1
    }
  },
  computed: {
    levelClass() {
      return `level-${this.level}`;
    }
  }
});
var ol = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("div", { staticClass: "app-heading", class: [e.levelClass] }, [e.title ? i("div", { staticClass: "header-title" }, [i("span", [e._v(e._s(e.title))]), i("span", { staticClass: "detail" }, [e._v(e._s(e.detail))])]) : e._e(), e._t("action")], 2);
}, al = [], ll = /* @__PURE__ */ _(
  rl,
  ol,
  al,
  !1,
  null,
  "b9810583"
);
const cl = ll.exports, ul = b({
  props: {
    reference: {
      type: Object,
      required: !1
    },
    menuOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: !1
    };
  },
  computed: {
    visibleOptions() {
      return this.menuOptions.map((t) => ({
        tabKey: t.tabKey,
        label: t.label,
        enabled: t.enabled ?? !0,
        visible: t.visible ?? !0,
        error: t.error ?? !1
      })).filter((t) => t.visible);
    }
  },
  methods: {
    onSelectOption(t) {
      this.$emit(`click:${t.tabKey}`, this.reference), this.visible = !1;
    }
  }
});
var dl = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("app-floating", { staticClass: "app-ellipsis-menu", style: { position: "static" }, attrs: { "floating-style": { width: "unset", zIndex: "50" }, placement: "bottom-end" }, scopedSlots: e._u([{ key: "content", fn: function() {
    return [e._t("content", function() {
      return [i("app-icon-button", { attrs: { padding: 2, size: 32 }, on: { "!click": function(n) {
        n.stopPropagation(), n.preventDefault();
      } } }, [i("fa-icon-compat", { attrs: { icon: "fa-solid fa-ellipsis-vertical" } })], 1)];
    })];
  }, proxy: !0 }, { key: "options", fn: function() {
    return [i("div", { staticClass: "app-menu" }, e._l(e.visibleOptions, function(n) {
      return i("button", { key: n.tabKey, staticClass: "menu-item", attrs: { type: "button", title: n.label }, on: { "!click": function(s) {
        return s.stopPropagation(), s.preventDefault(), e.onSelectOption(n);
      } } }, [e._v(" " + e._s(n.label) + " ")]);
    }), 0)];
  }, proxy: !0 }], null, !0), model: { value: e.visible, callback: function(n) {
    e.visible = n;
  }, expression: "visible" } });
}, hl = [], pl = /* @__PURE__ */ _(
  ul,
  dl,
  hl,
  !1,
  null,
  "a9e8b996"
);
const fl = pl.exports, ml = b({
  props: {
    routeName: {
      type: String,
      required: !0
    },
    routeParams: {
      type: Object,
      required: !1
    },
    title: {
      type: String,
      required: !0
    },
    faIcon: {
      type: String,
      required: !1
    }
  },
  computed: {
    icon() {
      return this.faIcon ? `${this.faIcon}` : void 0;
    },
    routeTo() {
      return {
        name: this.routeName,
        params: this.routeParams
      };
    }
  }
});
var gl = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("router-link", { staticClass: "app-menu-item", attrs: { to: e.routeTo } }, [e.icon ? i("fa-icon-compat", { staticClass: "app-menu-item-icon", attrs: { icon: e.icon } }) : e._e(), i("span", { staticClass: "app-menu-item-title" }, [e._v(e._s(e.title))])], 1);
}, vl = [], bl = /* @__PURE__ */ _(
  ml,
  gl,
  vl,
  !1,
  null,
  "e7f02ef6"
);
const _l = bl.exports, yl = b({
  name: "AppTabs",
  props: {
    value: {
      type: String,
      default: ""
    },
    tabs: {
      type: Array,
      required: !0
    }
  },
  mounted() {
    this.value ? this.updateIndicatorPosition(this.value) : this.selectFirstAvailableTab();
  },
  watch: {
    value(t) {
      this.updateIndicatorPosition(t);
    }
  },
  computed: {
    visibleTabs() {
      return this.tabs.map((t) => ({
        tabKey: t.tabKey,
        label: t.label,
        enabled: t.enabled ?? !0,
        visible: t.visible ?? !0,
        error: t.error ?? !1
      })).filter((t) => t.visible);
    }
  },
  methods: {
    cssClasses(t) {
      const e = [`tab-id-${t.tabKey}`];
      return t.tabKey === this.value && e.push("selected"), t.error && e.push("error"), e;
    },
    selectFirstAvailableTab() {
      const t = this.visibleTabs.find((e) => e.enabled);
      t && this.$emit("input", t.tabKey);
    },
    updateIndicatorPosition(t) {
      const e = this.$refs.indicator, i = this.$el.querySelector(`.tab-id-${t}`);
      if (!i)
        e.style.opacity = "0";
      else {
        const { offsetLeft: n, offsetTop: s, clientHeight: r } = i;
        e.style.opacity = "1", e.style.top = `${s + r + 1}px`, e.style.left = `${n}px`;
      }
    },
    onClickTab(t) {
      this.$emit("input", t.tabKey);
    }
  }
});
var wl = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("nav", { staticClass: "app-tabs" }, [i("ul", { staticClass: "reset-ul tab-list" }, [e._l(e.visibleTabs, function(n) {
    return i("li", { key: n.tabKey }, [i("button", { staticClass: "tab-button", class: e.cssClasses(n), attrs: { disabled: !n.enabled }, on: { click: function(s) {
      return e.onClickTab(n);
    } } }, [e._v(" " + e._s(n.label) + " ")])]);
  }), i("div", { ref: "indicator", staticClass: "indicator" })], 2)]);
}, $l = [], xl = /* @__PURE__ */ _(
  yl,
  wl,
  $l,
  !1,
  null,
  "a43898c3"
);
const Cl = xl.exports, Sl = b({
  props: {
    tooltip: {
      type: String,
      required: !0
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    placement: {
      type: String,
      default: "auto"
    }
  },
  computed: {
    disabled() {
      return !this.enabled;
    }
  }
});
var Al = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("app-floating-hover", { staticClass: "app-tooltip", attrs: { enabled: e.enabled, placement: e.placement }, scopedSlots: e._u([{ key: "content", fn: function() {
    return [e._t("default", function() {
      return [i("div", { staticClass: "tooltip-content", class: { disabled: e.disabled } }, [e._v("?")])];
    })];
  }, proxy: !0 }, { key: "floating", fn: function() {
    return [i("div", { staticClass: "tooltip-floating" }, [i("app-markdown-text", { attrs: { text: e.tooltip } })], 1)];
  }, proxy: !0 }], null, !0) });
}, Rl = [], Ml = /* @__PURE__ */ _(
  Sl,
  Al,
  Rl,
  !1,
  null,
  "941aab69"
);
const zl = Ml.exports, kl = b({
  props: {
    textStart: String,
    textEnd: String,
    textLink: String
  }
});
var Pl = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("span", [e._v(" " + e._s(e.textStart) + " "), i("app-link", e._g(e._b({ attrs: { theme: "link", label: e.textLink } }, "app-link", e.$attrs, !1), e.$listeners)), e._v(" " + e._s(e.textEnd) + " ")], 1);
}, El = [], Il = /* @__PURE__ */ _(
  kl,
  Pl,
  El,
  !1,
  null,
  "fcdad90f"
);
const Ol = Il.exports, Tl = b({
  props: {
    src: {
      type: String,
      required: !1
    },
    fallback: {
      type: String,
      required: !1
    },
    type: {
      type: String,
      default: "rounded",
      validator(t) {
        return ["square", "rounded", "circle"].includes(t);
      }
    },
    ratio: {
      type: Number,
      required: !1
    },
    width: {
      type: String,
      required: !1
    },
    height: {
      type: String,
      required: !1
    }
  },
  data() {
    return {
      error: !1
    };
  },
  computed: {
    imageSrc() {
      return this.src ?? this.fallback ?? "";
    },
    defaultWidth() {
      return this.height ? "auto" : "100%";
    },
    style() {
      return {
        aspectRatio: `${this.ratio}`,
        width: `${this.width ?? this.defaultWidth}`,
        height: `${this.height}`
      };
    }
  },
  methods: {
    onErrorLoadingImage(t) {
      this.error = !0, console.warn(`Error loading image [src='${t.srcElement.src}']`);
    }
  }
});
var Dl = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, e.error ? i("div", { staticClass: "app-image error", class: [e.type], style: e.style }) : e.imageSrc ? i("img", { staticClass: "app-image", class: [e.type], style: e.style, attrs: { src: e.imageSrc }, on: { error: e.onErrorLoadingImage } }) : i("div", { staticClass: "app-image empty", class: [e.type], style: e.style });
}, Ll = [], jl = /* @__PURE__ */ _(
  Tl,
  Dl,
  Ll,
  !1,
  null,
  "dfe5b8ee"
);
const Bl = jl.exports, Fl = b({
  props: {
    items: {
      type: Array,
      required: !0
    },
    itemsPerPage: {
      type: Number,
      default: 3
    },
    itemsPerScroll: {
      type: Number,
      default: 3
    },
    label: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    error: {
      type: Boolean,
      default: !1
    },
    rounded: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      activeImage: "",
      allItems: []
    };
  },
  watch: {
    items() {
      this.setItems();
    }
  },
  created() {
    this.setItems();
  },
  computed: {
    disabled() {
      return !this.enabled;
    }
  },
  methods: {
    onClick(t) {
      this.enabled && (this.activeImage = t, this.$emit("input", t));
    },
    isSelected(t) {
      return this.activeImage === t;
    },
    setItems() {
      this.allItems = this.items, this.value && (this.allItems = this.items.filter((t) => t !== this.value), this.allItems.unshift(this.value)), this.activeImage = this.value;
    },
    onBlur(t) {
      this.$emit("blur", t);
    }
  }
});
var Wl = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("base-input-item", e._b({ staticClass: "app-image-input", attrs: { enabled: e.enabled, error: e.error, label: e.label, required: e.required } }, "base-input-item", e.$attrs, !1), [i("div", { staticClass: "input-content", class: { disabled: e.disabled, error: e.error } }, [i("div", { staticClass: "app-carousel-container", class: { error: e.error }, on: { blur: e.onBlur } }, [e.allItems.length || e.$slots.add ? i("app-carousel", { attrs: { items: e.allItems, "items-per-page": e.itemsPerPage, "items-per-scroll": e.itemsPerScroll, loop: !1 }, scopedSlots: e._u([{ key: "add", fn: function() {
    return [e._t("add")];
  }, proxy: !0 }, { key: "default", fn: function({ item: n }) {
    return [i("div", { staticClass: "image-wrapper" }, [i("app-image", { class: { "image-rounded": e.rounded }, attrs: { src: n, height: "fit-content", width: "fit-content" }, nativeOn: { click: function(s) {
      return e.onClick(n);
    } } }), e.isSelected(n) ? i("div", { staticClass: "selected-item", class: { "image-rounded": e.rounded } }, [i("fa-icon-compat", { staticClass: "selected-check", attrs: { icon: "fa-regular fa-check" } })], 1) : e._e()], 1)];
  } }], null, !0) }) : i("div", { staticClass: "no-items" }, [i("fa-icon-compat", { staticClass: "no-items-icon", attrs: { icon: "fa-light fa-image" } }), i("div", { staticClass: "no-items-title" }, [e._v(" " + e._s(e.$t("form.imageInputContainer.noItemsTitle")) + " ")]), i("div", { staticClass: "no-items-description" }, [e._v(" " + e._s(e.$t("form.imageInputContainer.noItemsDescription")) + " ")])], 1)], 1)])]);
}, Nl = [], ql = /* @__PURE__ */ _(
  Fl,
  Wl,
  Nl,
  !1,
  null,
  "cbb2414b"
);
const Hl = ql.exports, Vl = b({
  props: {
    value: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 10
    },
    step: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      innerValue: ""
    };
  },
  created() {
    this.innerValue = this.value.toString();
  },
  methods: {
    onChange() {
      const t = Number.parseInt(this.innerValue, 10);
      this.$emit("input", t);
    }
  }
});
var Ul = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("base-input-item", e._b({ staticClass: "app-range-input" }, "base-input-item", e.$attrs, !1), [i("div", { staticClass: "range-container" }, [i("div", { staticClass: "range" }, [i("input", { directives: [{ name: "model", rawName: "v-model", value: e.innerValue, expression: "innerValue" }], attrs: { type: "range", min: e.min, max: e.max, step: e.step, list: "values" }, domProps: { value: e.innerValue }, on: { change: e.onChange, __r: function(n) {
    e.innerValue = n.target.value;
  } } }), i("datalist", { attrs: { id: "values" } }, [i("option", { attrs: { label: e.min }, domProps: { value: e.min } }), i("option", { attrs: { label: e.max }, domProps: { value: e.max } })])]), i("span", [e._v(e._s(e.innerValue))])])]);
}, Yl = [], Xl = /* @__PURE__ */ _(
  Vl,
  Ul,
  Yl,
  !1,
  null,
  "8ee0179a"
);
const Gl = Xl.exports, Zl = b({
  name: "AppToggle",
  props: {
    value: {
      type: Boolean,
      default: !1
    },
    enabled: {
      type: Boolean,
      default: !0
    }
  },
  methods: {
    toggle() {
      this.enabled && this.$emit("input", !this.value);
    }
  }
});
var Kl = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("div", { staticClass: "app-toggle", class: { "is-active": e.value, "is-disabled": !e.enabled }, attrs: { "aria-checked": e.value, role: "switch" }, on: { "!click": function(n) {
    return n.stopPropagation(), n.preventDefault(), e.toggle.apply(null, arguments);
  } } }, [i("div", { staticClass: "switch-track" }), i("div", { staticClass: "switch-handle" })]);
}, Ql = [], Jl = /* @__PURE__ */ _(
  Zl,
  Kl,
  Ql,
  !1,
  null,
  "0216a46c"
);
const ec = Jl.exports, tc = b({
  name: "AppConfirmationModal",
  components: { AppTextInput: Ci },
  props: {
    loading: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String
    },
    description: {
      type: String,
      required: !0
    },
    reference: {
      type: String,
      required: !0
    },
    primaryLabel: {
      type: String,
      required: !0
    },
    secondaryLabel: {
      type: String,
      required: !0
    },
    placeholder: {
      type: String,
      required: !1
    }
  },
  data() {
    return {
      referenceInput: "",
      referenceInputError: !1
    };
  },
  methods: {
    onPrimary() {
      this.referenceInput !== this.reference ? this.referenceInputError = !0 : (this.referenceInputError = !1, this.$emit("click-primary"));
    },
    onSecondary() {
      this.$emit("click-secondary");
    }
  }
});
var ic = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("app-modal", { staticClass: "modal-container", attrs: { loading: e.loading }, on: { "click-outside": e.onSecondary } }, [i("div", { staticClass: "modal-content" }, [e.title ? i("div", { staticClass: "modal-title" }, [e._v(" " + e._s(e.title) + " ")]) : e._e(), i("app-banner", { attrs: { description: e.$t("modal.modalDeletion.bannerDescription"), bannerStyle: "warning" } }), i("div", { staticClass: "modal-description" }, [e._v(e._s(e.description))]), i("app-text-input", { attrs: { error: e.referenceInputError, placeholder: e.placeholder, required: !0 }, model: { value: e.referenceInput, callback: function(n) {
    e.referenceInput = n;
  }, expression: "referenceInput" } })], 1), i("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center" } }, [i("app-button", { attrs: { label: e.primaryLabel }, on: { click: e.onPrimary } }), i("app-secondary-button", { attrs: { label: e.secondaryLabel }, on: { click: e.onSecondary } })], 1)], 1);
}, nc = [], sc = /* @__PURE__ */ _(
  tc,
  ic,
  nc,
  !1,
  null,
  "9e244a6d"
);
const rc = sc.exports, oc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AppActionButton: qi,
  AppButton: Xi,
  AppButtonSheet: Yo,
  AppCarousel: Qo,
  AppCheckbox: Zn,
  AppCheckboxGroup: ts,
  AppCropper: li,
  AppCropperOverlay: Vn,
  AppDatepickerButton: os,
  AppDatepickerInput: ds,
  AppDropdown: ws,
  AppEllipsisMenu: fl,
  AppFloating: qr,
  AppFloatingHover: Xr,
  AppForm: ba,
  AppHeading: cl,
  AppIcon: xa,
  AppIconButton: Ji,
  AppImage: Bl,
  AppImageInput: Jr,
  AppImageSelector: Hl,
  AppLink: Ma,
  AppLinkText: Ol,
  AppLoading: ja,
  AppMenuItem: _l,
  AppModal: Xa,
  AppModalConfirmation: Ja,
  AppModalDeletion: rc,
  AppMultiselect: jr,
  AppNumberInput: fo,
  AppOverlay: Ia,
  AppPasswordInput: Co,
  AppRadioButtons: gs,
  AppRangeInput: Gl,
  AppSearchInput: _o,
  AppSecondaryButton: rn,
  AppSection: sl,
  AppSingleselect: br,
  AppTabs: Cl,
  AppTextArea: so,
  AppTextInput: Ci,
  AppToast: qa,
  AppToggle: ec,
  AppTooltip: zl,
  BaseCheckmark: yi,
  BaseInputError: Ai,
  BaseInputItem: Lo,
  BaseInputLabel: Si,
  BaseInputText: No,
  DropdownOptionsItem: $t
}, Symbol.toStringTag, { value: "Module" })), Pi = "toastEvent", ac = 1e4, Ct = b({
  data() {
    return {
      toastMessage: ""
    };
  },
  mounted() {
    this.$el.addEventListener(Pi, (t) => {
      var i;
      const e = (i = t.detail) == null ? void 0 : i.message;
      if (t.stopPropagation(), !e) {
        console.warn("Could not display empty toast message"), this.toastMessage = "";
        return;
      }
      this.toastMessage = e, setTimeout(() => {
        this.toastMessage = "";
      }, ac);
    });
  }
}), lc = b({
  mixins: [Ct]
});
var cc = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("div", { staticClass: "clean-layout" }, [e._t("default"), e.toastMessage ? i("app-toast", { attrs: { message: e.toastMessage } }) : e._e()], 2);
}, uc = [], dc = /* @__PURE__ */ _(
  lc,
  cc,
  uc,
  !1,
  null,
  "9e40b842"
);
const hc = dc.exports, pc = b({
  mixins: [Ct]
});
var fc = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("div", { staticClass: "main-layout" }, [i("header", [e._t("header")], 2), i("nav", [e._t("menu")], 2), i("main", [e._t("main")], 2), i("footer", [e._t("footer")], 2), e.toastMessage ? i("app-toast", { attrs: { message: e.toastMessage } }) : e._e()], 1);
}, mc = [], gc = /* @__PURE__ */ _(
  pc,
  fc,
  mc,
  !1,
  null,
  "0674f1f5"
);
const vc = gc.exports, bc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CleanLayout: hc,
  MainLayout: vc
}, Symbol.toStringTag, { value: "Module" })), _c = b({
  props: {
    title: {
      type: String,
      required: !0
    },
    contentLoaded: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    hideContent() {
      return !this.contentLoaded && this.loading;
    },
    hasSlotAction() {
      return !!this.$slots.action;
    }
  }
});
var yc = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("div", { staticClass: "simple-page" }, [i("div", { staticClass: "page-header" }, [i("span", { staticClass: "page-title" }, [e._v(" " + e._s(e.title) + " ")]), e.hasSlotAction ? e._t("action") : e._e()], 2), e.hideContent ? e._e() : i("div", { staticClass: "page-content" }, [e._t("default")], 2), i("transition", { attrs: { name: "modal-fade", mode: "out-in" } }, [e.loading ? i("app-overlay", { attrs: { "full-page": !1, "center-content": !0, theme: "light" } }, [i("app-loading")], 1) : e._e()], 1)], 1);
}, wc = [], $c = /* @__PURE__ */ _(
  _c,
  yc,
  wc,
  !1,
  null,
  "271f1cfa"
);
const xc = $c.exports, Cc = b({
  props: {
    title: {
      type: String,
      required: !0
    },
    contentLoaded: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    hideContent() {
      return !this.contentLoaded && this.loading;
    },
    hasSlotControls() {
      return !!this.$slots.controls;
    },
    hasSlotHeading() {
      return !!this.$slots.heading;
    }
  }
});
var Sc = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("div", { staticClass: "administrative-page" }, [i("div", { staticClass: "page-title" }, [e._v(" " + e._s(e.title) + " ")]), e.hasSlotHeading ? i("div", { staticClass: "page-heading" }, [e._t("heading")], 2) : e._e(), e.hasSlotControls ? i("div", { staticClass: "page-controls" }, [e._t("controls")], 2) : e._e(), e.hideContent ? e._e() : i("div", { staticClass: "page-content" }, [e._t("default")], 2), i("transition", { attrs: { name: "modal-fade", mode: "out-in" } }, [e.loading ? i("app-overlay", { attrs: { "full-page": !1, "center-content": !0, theme: "light" } }, [i("app-loading")], 1) : e._e()], 1)], 1);
}, Ac = [], Rc = /* @__PURE__ */ _(
  Cc,
  Sc,
  Ac,
  !1,
  null,
  "82c05512"
);
const Mc = Rc.exports, zc = b({
  props: {
    loading: {
      type: Boolean,
      default: !1
    }
  }
});
var kc = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("div", { staticClass: "center-page" }, [e._t("default"), i("transition", { attrs: { name: "modal-fade", mode: "out-in" } }, [e.loading ? i("app-overlay", { attrs: { "full-page": !1, "center-content": !0, theme: "light" } }, [i("app-loading")], 1) : e._e()], 1)], 2);
}, Pc = [], Ec = /* @__PURE__ */ _(
  zc,
  kc,
  Pc,
  !1,
  null,
  "d7b0d00b"
);
const Ic = Ec.exports, Oc = b({
  props: {
    contentLoaded: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    hideContent() {
      return !this.contentLoaded && this.loading;
    }
  }
});
var Tc = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("div", { staticClass: "empty-page" }, [e.hideContent ? e._e() : i("div", { staticClass: "page-content" }, [e.hideContent ? e._e() : e._t("default")], 2), i("transition", { attrs: { mode: "out-in", name: "modal-fade" } }, [e.loading ? i("app-overlay", { attrs: { "center-content": !0, "full-page": !1, theme: "light" } }, [i("app-loading")], 1) : e._e()], 1)], 1);
}, Dc = [], Lc = /* @__PURE__ */ _(
  Oc,
  Tc,
  Dc,
  !1,
  null,
  "71a8002e"
);
const jc = Lc.exports, Bc = b({
  mixins: [Ct],
  props: {
    title: {
      type: String,
      required: !1
    },
    contentLoaded: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    reloadOnClose: {
      type: Boolean,
      default: !1
    },
    detachedPopup: {
      type: Boolean,
      default: !1
    },
    showCloseButton: {
      type: Boolean,
      default: !0
    },
    confirmationToClose: {
      type: Boolean,
      default: !1
    },
    escToClose: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      confirmationModal: !1
    };
  },
  created() {
    let t = window.innerWidth - document.body.clientWidth;
    document.body.style.paddingRight = `${t}px`, document.body.style.overflowY = "hidden", this.escToClose && document.addEventListener("keyup", this.escape);
  },
  beforeDestroy() {
    document.body.style.paddingRight = "0px", document.body.style.overflowY = "auto", document.removeEventListener("keyup", this.escape);
  },
  computed: {
    hideContent() {
      return !this.contentLoaded && this.loading;
    },
    hasFooter() {
      return !!this.$slots.footer;
    }
  },
  methods: {
    escape(t) {
      (t.key === "Esc" || t.key === "Escape") && this.tryClosing();
    },
    showConfirmationModal(t) {
      this.confirmationModal = t;
    },
    tryClosing() {
      this.confirmationToClose ? this.showConfirmationModal(!0) : this.close();
    },
    close() {
      const t = this.$route.matched.slice(-2, -1), { name: e } = t[0], i = this.reloadOnClose ? { action: "reload" } : void 0;
      this.$router.push({
        name: e,
        params: i
      });
    }
  }
});
var Fc = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("app-overlay", { staticClass: "app-side-panel", attrs: { theme: "dark" }, on: { "click-background": e.tryClosing } }, [i("div", { staticClass: "panel", class: { "detached-popup": e.detachedPopup } }, [i("div", { staticClass: "header" }, [i("div", { staticClass: "title" }, [e._v(e._s(e.title))]), e.showCloseButton ? i("app-icon-button", { staticClass: "close", attrs: { size: 32 }, on: { click: e.tryClosing } }, [i("fa-icon-compat", { attrs: { icon: "fa-solid fa-xmark" } })], 1) : e._e()], 1), i("div", { staticClass: "content" }, [e.hideContent ? e._e() : e._t("default")], 2), e.hasFooter ? i("div", { staticClass: "footer" }, [e.hideContent ? e._e() : e._t("footer")], 2) : e._e(), i("transition", { attrs: { mode: "out-in", name: "modal-fade" } }, [e.loading ? i("app-overlay", { attrs: { "center-content": !0, "full-page": !1, theme: "light" } }, [i("app-loading")], 1) : e._e()], 1), e.toastMessage ? i("app-toast", { attrs: { message: e.toastMessage } }) : e._e()], 1), e.confirmationModal ? i("app-modal-confirmation", { attrs: { description: e.$t("modal.closeModalConfirmation.description"), "primary-label": e.$t("modal.closeModalConfirmation.confirm"), "secondary-label": e.$t("modal.closeModalConfirmation.cancel"), title: e.$t("modal.closeModalConfirmation.title") }, on: { "click-secondary": function(n) {
    return e.showConfirmationModal(!1);
  }, "click-primary": e.close } }) : e._e()], 1);
}, Wc = [], Nc = /* @__PURE__ */ _(
  Bc,
  Fc,
  Wc,
  !1,
  null,
  "fb34bf6c"
);
const qc = Nc.exports, Hc = b({
  props: {
    title: {
      type: String,
      default: ""
    },
    contentLoaded: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    hideContent() {
      return !this.contentLoaded && this.loading;
    }
  }
});
var Vc = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("div", { staticClass: "two-column-page" }, [e.title ? i("div", { staticClass: "page-header" }, [i("span", { staticClass: "page-title" }, [e._v(" " + e._s(e.title) + " ")])]) : e._e(), e.hideContent ? e._e() : i("div", { staticClass: "first-column page-content" }, [e.hideContent ? e._e() : e._t("first-column")], 2), e.hideContent ? e._e() : i("div", { staticClass: "second-column page-content" }, [e.hideContent ? e._e() : e._t("second-column")], 2), i("transition", { attrs: { mode: "out-in", name: "modal-fade" } }, [e.loading ? i("app-overlay", { attrs: { "center-content": !0, "full-page": !1, theme: "light" } }, [i("app-loading")], 1) : e._e()], 1)], 1);
}, Uc = [], Yc = /* @__PURE__ */ _(
  Hc,
  Vc,
  Uc,
  !1,
  null,
  "c4af15d8"
);
const Xc = Yc.exports, Gc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AdministrativePage: Mc,
  AppSidePanel: qc,
  CenterPage: Ic,
  EmptyPage: jc,
  SimplePage: xc,
  TwoColumnPage: Xc
}, Symbol.toStringTag, { value: "Module" })), Qc = b({
  methods: {
    $toast(t) {
      this.$nextTick(() => {
        const e = new CustomEvent(Pi, {
          bubbles: !0,
          detail: {
            message: t
          }
        });
        this.$el.dispatchEvent(e);
      });
    }
  }
}), Jc = {
  install(t) {
    Object.entries(oc).forEach(([e, i]) => {
      t.component(e, i);
    }), Object.entries(bc).forEach(([e, i]) => {
      t.component(e, i);
    }), Object.entries(Gc).forEach(([e, i]) => {
      t.component(e, i);
    });
  }
};
export {
  Jc as rreadyUi,
  Ct as toastCaptureMixin,
  Qc as toastMixin
};
